import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormControl, Validators, FormBuilder, FormArray, NgForm, AbstractControl } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';
import { IomService } from 'src/app/services/iom.service';
import { SessionService } from 'src/app/services/session.service';
import { AoAnalytics, IoAnalytics, OthersAnalytics } from 'src/app/models/text-analytics-config';
import { NgxSpinnerService } from 'ngx-spinner';
import { TopKeyWordsFilter } from 'src/app/models/TopKeyWordsFilter';
import { DomainMappingRequest, ExcelUploadResponse } from 'src/app/models/ExcelUploadResponse';
import { MessageService } from 'src/app/services/message.service';
import { timeout } from 'rxjs/operators';
import { AppConfigService } from 'src/app/services/app-config.service';
import { MultiSelectComponent } from 'ng-multiselect-dropdown';
import { find, get, pull, truncate } from 'lodash';
declare var bootbox: any;

declare var $: any;
@Component({
  selector: 'app-text-conf',
  templateUrl: './text-conf.component.html',
  styleUrls: ['./text-conf.component.css']
})
export class TextConfComponent implements OnInit {
  textConfigForm: FormGroup;
  textConfigFormStandard: FormGroup;
  isLoadAoPill = true;
  isLoadIoPill = false;
  isLoadOtherPill = false;
  enableOthers = false;
  enableAo = false;
  enableIo = false;
  isDataAvailable = false;
  mindate: any;
  maxdate: any;
  BAUploadedData: Uint8Array;
  // selectedAlgorithmModel: string = "User Defined + N-Gram Category Name"; //"System Generated: (K-means)";
  // selectedAlgorithmModel_others: string = "User Defined + N-Gram Category Name";//"System Generated: (K-means)";
  selectedAlgoOption: boolean = true;
  selectedAlgoOption_others: boolean = true;
  selectedAlgoOption_io: boolean = true;
  // lang_disable: boolean = false;
  classifiedBasedOn: string = "ShortDescription";
  selectedSupportGroup_AO: string;
  selectedSupportGroup_IO: string;
  selectedSupportGroup_Others: string;
  LanguageList: any;
  Language: string;
  isDisabled: boolean = false;
  ShowPopup: boolean = true;
  public lstDomainOption = [];
  // public MasterDummyData = [];
  public lstMappingConfig_ao: any;
  public lstFilterMappingConfig_ao: any;

  public lstMappingConfig_io: any;
  public lstFilterMappingConfig_io: any;

  public lstMappingConfig_others: any;
  public lstFilterMappingConfig_others: any;

  public lstFilterMappingConfig_aoSearch: any;
  public lstFilterMappingConfig_ioSearch: any;
  public lstFilterMappingConfig_othSearch: any;

  public searchAssignmentText: string;

  public lstCategorisedBy_ao = [];
  public lstCategorisedBy_io = [];
  public lstCategorisedBy_others = [];

  public lstClassifiedBy = [];
  public lstClassifiedBy_ao = [];
  public lstClassifiedBy_io = []
  public lstClassifiedBy_others = [];

  public lstTicketType_ao = [];
  public lstTicketType_io = [];
  public lstTicketType_others = [];
  // public langlist = []
  isValidFormSubmitted = false;
  public ignorekeyword: string;
  public lstIgnoreKeys: any;
  public lstIgnoreKeys_others: any;
  public lstIgnoreKeys_io: any;
  public check_language: string = "English";
  public check_language_ao: string;
  public check_language_others: string;
  // textAnalytics = new TextAnalyticsConfig();
  // disabled = false;
  aoAnalytics = new AoAnalytics();
  ioAnalytics = new IoAnalytics();
  othersAnalytics = new OthersAnalytics();
  MasterDummyDataUpload: any;
  categorizedByFlag_ao: boolean = false;
  categorizedByFlag_io: boolean = false;
  categorizedByFlag_others: boolean = false;
  isAddkeywordsEnabled_Others: boolean = true;
  isAddkeywordsEnabled_AO: boolean = true;
  isAddkeywordsEnabled_IO: boolean = true;
  isResolutionDescEnabled_Others: boolean = false;
  isResolutionDescEnabled_AO: boolean = false;
  isResolutionDescEnabled_IO: boolean = false;
  isQualifiedDescEnabled: boolean = null;
  isQualifiedDescEnabled_AO: boolean = null;
  isQualifiedDescEnabled_IO: boolean = null;
  isQualifiedDescEnabled_Others: boolean = null;
  enableBox_AO = false;
  enableBox_IO = false;
  enableBox_Others = false;
  @ViewChild('selectedAllAoId') selectedAllAoId: ElementRef;
  @ViewChild('selectedAllIoId') selectedAllIoId: ElementRef;
  @ViewChild('selectedAllOthersId') selectedAllOthersId: ElementRef;
  @ViewChild('selectedAoAssignedId') selectedAoAssignedId: ElementRef;
  @ViewChild('selectedIoAssignedId') selectedIoAssignedId: ElementRef;
  @ViewChild('selectedOthersAssignedId') selectedOthersAssignedId: ElementRef;
  @ViewChild('selectedSearchAllAoId') selectedSearchAllAoId: ElementRef;
  @ViewChild('selectedSearchAllIoId') selectedSearchAllIoId: ElementRef;
  @ViewChild('selectedSearchAllOthersId') selectedSearchAllOthersId: ElementRef;

  isResolutionDescEnabled_Others_old: boolean;
  isResolutionDescEnabled_AO_old: boolean;
  isResolutionDescEnabled_IO_old: boolean;
  isAvanced: boolean;
  categorisedBy: { Key: string, Value: string[], MappingKey: string }[];
  SelectedMapping: string = "Select";
  MappingData: { FieldValue: string, indexNo: number, isChecked: boolean, IsAO: boolean, IsIO: boolean, IsOthers: boolean }[] = [];
  all_Others: boolean = false;
  all_AO: boolean = false;
  all_IO: boolean = false;
  MappingFilterData: { FieldValue: string, indexNo: number, isChecked: boolean, IsAO: boolean, IsIO: boolean, IsOthers: boolean }[] = [];
  HistoricalDomainMapping: { MappingField: string, MappingValue: string, MappingDomain: string }[];
  displayMappingTable: boolean = false;
  IsMappingCompleted: boolean;
  DomainMappingRequest: DomainMappingRequest = new DomainMappingRequest();
  CreateDDInput: ExcelUploadResponse = new ExcelUploadResponse()
  isAvanced1: boolean;
  mapping: number;
  TopKeyWordData_AO: any;
  TopKeyWordData_IO: any;
  TopKeyWordData_Others: any;
  ChartData_AO: any;
  ChartData_IO: any;
  ChartData_Others: any;
  public topKeyWord_AO: TopKeyWordsFilter;
  public topKeyWord_std: TopKeyWordsFilter;
  public topKeyWord_AO_Pre: TopKeyWordsFilter;
  public topKeyWord_IO: TopKeyWordsFilter;
  public topKeyWord_IO_Pre: TopKeyWordsFilter;
  public topKeyWord_Others: TopKeyWordsFilter;
  public topKeyWord_Others_Pre: TopKeyWordsFilter;
  DoTicketPull: boolean = true;
  BatchId: string = "";
  UserOption: number;
  MaxEndDate: any;
  MinStartDate: any;
  isGetTopWordsEnabled: boolean = true;
  isSkipTopWords: boolean = true;
  proposalId: string;
  WordCloudFilterOptions: string[] = [];
  containerwordCloud_AO: string = "containerwordCloud_AO";
  containerwordCloud_IO: string = "containerwordCloud_IO";
  containerwordCloud_Others: string = "containerwordCloud_Others";
  topKeywordsResponse_History_AO: any = [];
  topKeywordsResponse_History_IO: any = [];
  topKeywordsResponse_History_Others: any = [];
  startDate: string;
  endDate: string;
  userType: any;
  ticketType: any;
  required_ao: boolean = true;
  required_io: boolean = false;
  required_others: boolean = true;
  searchcheck_ao: boolean = true;
  searchcheck_io: boolean = true;
  searchcheck_others: boolean = true;
  prev_language: string = 'English';
  envVar: any;
  @ViewChild('closeModal') private closeModal: ElementRef;
  @ViewChild('openModal') private openModal: ElementRef;
  indexOf = (arr, q) => arr.findIndex(item => q.toLowerCase() === item.toLowerCase());
  skrequest: any;
  historyDataForSelectedMappingField: { MappingField: string; MappingValue: string; MappingDomain: string; }[];
  EnableDQTStd: boolean = false;
  enableDQT: boolean;
  EnableDQTAO: boolean = false;
  EnableDQTIO: boolean = false;
  EnableDQTOth: boolean = false;
  EnableLemmaStd: boolean = false;
  EnableRestrictDDCreation: boolean = false;
  enableRestrictdd: boolean = false;
  enableLemma: boolean;
  enableRestrictDD: boolean;
  EnableLemmaAO: boolean = false;
  EnableLemmaIO: boolean = false;
  EnableLemmaOth: boolean = false;
  LemmaDisableStd: boolean = false;
  LemmaDisableAO: boolean = false;
  LemmaDisableIO: boolean = false;
  LemmaDisableOth: boolean = false;
  DQTenableStd: boolean = false;
  DQTenableAO: boolean = false;
  DQTenableIO: boolean = false;
  DQTenableOth: boolean = false;

  enableSearch: boolean = false;
  enableSearchAO: boolean = false;
  enableSearchIO: boolean = false;
  enableSearchOth: boolean = false;
  enableApply: boolean = false;
  isClearAll: boolean = false;
  aoArr: any = [];
  ioArr: any = [];
  othArr: any = [];
  selectedStdLanguageAO: string = 'Select';
  selectedStdLanguageIO: string = 'Select';
  selectedStdLanguageOthers: string = 'Select';
  LanguageKeywordAO: { Language: string, Keywords: string[] }[] = [];
  LanguageKeywordIO: { Language: string, Keywords: string[] }[] = [];
  LanguageKeywordOthers: { Language: string, Keywords: string[] }[] = [];
  selectedLanguage = [];
  selectedStdLanguage = [];
  selectedLanguage_AO: any= [];
  selectedLanguage_IO: any = [];
  selectedLanguage_Other: any = [];
  dropdownSettings = {};
  selectedLanguagestd = [];
  selectedLanguageAO: any = [];
  selectedLanguageIO: any = [];
  selectedLanguageOther: any = [];
  public templstClassifiedBy = [];
  public templstClassifiedBy_ao = [];
  public templstClassifiedBy_io = []
  public templstClassifiedBy_others = [];
  public lstIgnoreKeysTemp: any;
  public lstIgnoreKeys_othersTemp: any;
  public lstIgnoreKeys_ioTemp: any;
  // displayDD: boolean= false;
  constructor(private router: Router, private iomService: IomService, public fb: FormBuilder, private SessionService: SessionService, private spinner: NgxSpinnerService, private messageService: MessageService, private appConfigService: AppConfigService) {
    this.envVar = this.appConfigService.getEnvironment();
    if (this.SessionService.getSessionStorageItem('CreateDDInput') != null && this.SessionService.getSessionStorageItem('CreateDDInput') != 'null' && this.SessionService.getSessionStorageItem('CreateDDInput') != '') {
      this.isDataAvailable = true;
    }
    this.MasterDummyDataUpload = JSON.parse(this.SessionService.getSessionStorageItem('CreateDDInput'));
    if (this.isDataAvailable == true) {
      this.WordCloudFilterOptions = this.MasterDummyDataUpload.WordCloudFilterOptions?.split(','); //?.filter(x => x).map(x => x.trim())
      //this.categorisedBy = this.MasterDummyDataUpload.CategorisedBy;
    }
    this.SessionService.setSessionStorageItem("SelectedDDLanguage", '');
    this.SessionService.setSessionStorageItem("SelectedLanguage", '');
    var lstClassifiedByTemp = this.MasterDummyDataUpload.ClassifiedBy;
    lstClassifiedByTemp.push({ 'name': 'ShortDescription' });

    if (this.MasterDummyDataUpload.DisplayResolutionDesc == true) {
      lstClassifiedByTemp.push({ 'name': 'ResolutionDescription' });
    }

    if (this.MasterDummyDataUpload.DisplayLongDesc == true) {
      lstClassifiedByTemp.push({ 'name': 'LongDescription' });
    }

    this.lstClassifiedBy = lstClassifiedByTemp;
    this.lstClassifiedBy_ao = lstClassifiedByTemp;
    this.lstClassifiedBy_io = lstClassifiedByTemp;
    this.lstClassifiedBy_others = lstClassifiedByTemp;

    this.templstClassifiedBy = lstClassifiedByTemp;
    this.templstClassifiedBy_ao = lstClassifiedByTemp;
    this.templstClassifiedBy_io = lstClassifiedByTemp;
    this.templstClassifiedBy_others = lstClassifiedByTemp;  

    this.textConfigFormStandard = this.fb.group({
      deepdiveConfig: new FormControl('', Validators.required),
      classifiedBasedOn: new FormControl('ShortDescription'),
      ClassifiedBased: new FormControl('Select', Validators.required),
      Language: new FormControl('Select', Validators.required)
    });
  }
  enableAdvanceOption() {
    this.categorisedBy = this.MasterDummyDataUpload.CategorisedByDD;
    this.HistoricalDomainMapping = this.MasterDummyDataUpload.HistoricalDomainMapping;
    this.isAvanced = true;
    this.isAvanced1 = false;
    this.enableSearch = false;
    this.displayMappingTable = false;
    this.SelectedMapping = "Select";
    this.mapping = 0;
    this.SessionService.setSessionStorageItem("selectAllAO", "false");
    this.SessionService.setSessionStorageItem("selectAllIO", "false");
    this.SessionService.setSessionStorageItem("selectAllOth", "false");
    this.aoArr = [];
    this.ioArr = [];
    this.othArr = [];
    this.selectedLanguage_AO = [];
    this.selectedLanguage_IO = [];
    this.selectedLanguage_Other = [];
    this.selectedLanguageAO = [];
    this.selectedLanguageIO = [];
    this.selectedLanguageOther = [];
    this.selectedStdLanguageAO = 'Select';
    this.selectedStdLanguageIO = 'Select';
    this.selectedStdLanguageOthers = 'Select';
  }
  LoadMappingData() {
    this.MappingData = [];
    this.all_AO = false;
    this.all_IO = false;
    this.all_Others = false;
    let data = this.categorisedBy.find(x => x.Key.replace(/\s/g, '') == this.SelectedMapping.replace(/\s/g, ''));
    this.historyDataForSelectedMappingField = this.HistoricalDomainMapping.filter(x => x.MappingField.toLowerCase().replace(/\s/g, '') == this.SelectedMapping.replace(/\s/g, ''));
    if (data) {
      this.displayMappingTable = true;
      let i = 0;
      for (const value of data.Value) {
        var historyIndex = this.historyDataForSelectedMappingField.findIndex(x => x.MappingValue == value);
        if (historyIndex >= 0) {
          var historyDomain = this.historyDataForSelectedMappingField[historyIndex].MappingDomain;
          this.MappingData.push({ FieldValue: value, indexNo: i++, isChecked: false, IsAO: historyDomain == 'AO', IsIO: historyDomain == 'IO', IsOthers: historyDomain == 'Others' });
        }
        else {
          this.MappingData.push({ FieldValue: value, indexNo: i++, isChecked: false, IsAO: false, IsIO: false, IsOthers: false });
        }
        this.MappingFilterData = this.MappingData;
      }
      if (this.MappingData.filter(x => x.IsAO).length == this.MappingData.length)
        this.all_AO = true;
      if (this.MappingData.filter(x => x.IsIO).length == this.MappingData.length)
        this.all_IO = true;
      if (this.MappingData.filter(x => x.IsOthers).length == this.MappingData.length)
        this.all_Others = true;
      if (this.MappingData.filter(x => x.IsOthers).length + this.MappingData.filter(x => x.IsIO).length + this.MappingData.filter(x => x.IsAO).length == this.MappingData.length)
        this.IsMappingCompleted = true;
      else
        this.IsMappingCompleted = false;
    }
    else {
      this.displayMappingTable = false;
    }
    $("#txtSearch").val('');
  }
  searchDomainMapping(searchText: string) {
    //console.log(searchText);
    this.MappingFilterData = null;
    if (searchText == "") {
      this.MappingFilterData = this.MappingData;
    }
    else {
      searchText != "" ? this.MappingFilterData = this.MappingData.filter(filterValue => {
        return filterValue.FieldValue != undefined ? filterValue.FieldValue.toLowerCase().trim().includes(searchText.toLowerCase().trim()) : false
      })
        : this.MappingFilterData == undefined ? this.MappingFilterData = null : '';
    }

  }
  OnDomainChange(mData: { FieldValue: string, IsAO: boolean, IsIO: boolean, IsOthers: boolean }, domain: string, isAllControl: boolean) {
    if (isAllControl) {
      switch (domain) {
        case 'AO':
          this.MappingData.map(x => x.IsAO = true);
          this.MappingData.map(x => x.IsIO = false);
          this.MappingData.map(x => x.IsOthers = false);
          break;
        case 'IO':
          this.MappingData.map(x => x.IsAO = false);
          this.MappingData.map(x => x.IsIO = true);
          this.MappingData.map(x => x.IsOthers = false);
          break;
        case 'Others':
          this.MappingData.map(x => x.IsAO = false);
          this.MappingData.map(x => x.IsIO = false);
          this.MappingData.map(x => x.IsOthers = true);
          break;
        default:
          break;
      }
    }
    else {
      let objIndex = this.MappingData.findIndex((obj => obj.FieldValue == mData.FieldValue));
      if (objIndex != -1) {
        switch (domain) {
          case 'AO':
            this.MappingData[objIndex].IsAO = true;
            this.MappingData[objIndex].IsIO = false;
            this.MappingData[objIndex].IsOthers = false;
            break;
          case 'IO':
            this.MappingData[objIndex].IsAO = false;
            this.MappingData[objIndex].IsIO = true;
            this.MappingData[objIndex].IsOthers = false;
            break;
          case 'Others':
            this.MappingData[objIndex].IsAO = false;
            this.MappingData[objIndex].IsIO = false;
            this.MappingData[objIndex].IsOthers = true;
            break;
          default:
            break;
        }
      }
    }
    if (this.MappingData.filter(x => x.IsAO).length == this.MappingData.length)
      this.all_AO = true;
    else
      this.all_AO = false;
    if (this.MappingData.filter(x => x.IsIO).length == this.MappingData.length)
      this.all_IO = true;
    else
      this.all_IO = false;
    if (this.MappingData.filter(x => x.IsOthers).length == this.MappingData.length)
      this.all_Others = true;
    else
      this.all_Others = false;
    if (this.MappingData.filter(x => x.IsOthers).length + this.MappingData.filter(x => x.IsIO).length + this.MappingData.filter(x => x.IsAO).length == this.MappingData.length)
      this.IsMappingCompleted = true;
    else
      this.IsMappingCompleted = false;
  }
  clickNext() {
    if (this.BatchId != "") {
      this.clearStagingTicketsByCloudId(this.BatchId);
    }
    this.prev_language = 'English';
    this.ChartData_AO = null;
    this.ChartData_IO = null;
    this.ChartData_Others = null;
    if (this.ValidateInputs()) {
      this.spinner.show();
      let Data_AO = this.MappingData.filter(x => x.IsAO == true);
      let Data_IO = this.MappingData.filter(x => x.IsIO == true);
      let Data_Others = this.MappingData.filter(x => x.IsOthers);
      this.CreateDDInput = this.MasterDummyDataUpload;
      let ActualFilterName = this.categorisedBy.find(x => x.Key.replace(/\s/g, '') == this.SelectedMapping.replace(/\s/g, '')).MappingKey;
      let AOdata = [];
      let IOdata = [];
      let Othdata = [];
      Data_AO.forEach((x, i) => {
        AOdata.push({
          name: x.FieldValue,
          indexNo: i,
          isChecked: false
        })
      })
      this.CreateDDInput.MappingData_AO = { FilterName: this.SelectedMapping, ActualFilterName: ActualFilterName, data: AOdata };
      Data_IO.forEach((x, i) => {
        IOdata.push({
          name: x.FieldValue,
          indexNo: i,
          isChecked: false
        })
      })
      this.CreateDDInput.MappingData_IO = { FilterName: this.SelectedMapping, ActualFilterName: ActualFilterName, data: IOdata };
      Data_Others.forEach((x, i) => {
        Othdata.push({
          name: x.FieldValue,
          indexNo: i,
          isChecked: false
        })
      })
      this.CreateDDInput.MappingData_Others = { FilterName: this.SelectedMapping, ActualFilterName: ActualFilterName, data: Othdata };
      this.SessionService.setSessionStorageItem("CreateDDInput", JSON.stringify(this.CreateDDInput));
      this.DomainMappingRequest.MappingField = this.SelectedMapping;
      this.DomainMappingRequest.MappingData_AO = this.CreateDDInput.MappingData_AO.data;
      this.DomainMappingRequest.MappingData_IO = this.CreateDDInput.MappingData_IO.data;
      this.DomainMappingRequest.MappingData_Others = this.CreateDDInput.MappingData_Others.data;
      this.DomainMappingRequest.ProposalId = sessionStorage.getItem('selectedProposalId');
      this.DomainMappingRequest.ClientId = this.SessionService.getDeliveryConstructUId();
      this.DomainMappingRequest.UserType = parseInt(this.SessionService.getSessionStorageItem('userType'));
      this.DomainMappingRequest.UserId = this.SessionService.getUserName();
      this.SaveDomainMappingData(this.DomainMappingRequest);
      // this.hideModel();
      // this.deepDiveAdvance();
      // this.isAvanced1=true;
      // //this.isAvanced =false;
      //this.enableCreateDDTab.emit(1);
      //this.messageService.updateNavigateToCreateDDTab(true);
      //this.router.navigate(["/createdeepdive"]);
    }
    if (this.envVar.EnableLanguage == false) {
      this.textConfigForm.get('IOGroup').get('algorithmModel').setValue('3');
      this.algorithmChange(false, 'io', false, false, false, 'regression');
    }
  }
  public hideModel() {
    this.closeModal.nativeElement.click();
    setTimeout(() => {
      this.openModal.nativeElement.click();
    }, 200);
  }
  ValidateInputs(): boolean {
    if (!this.SelectedMapping || this.SelectedMapping == 'Select') {
      bootbox.alert("Please select the valid feature to map the tickets");
      return false;
    }
    else if (!this.IsMappingCompleted) {
      bootbox.alert("Domain mapping is incomplete");
      return false;
    }
    return true;
  }
  SaveDomainMappingData(domainMappingRequest: DomainMappingRequest) {
    this.iomService.SaveDomainMappingData(domainMappingRequest).subscribe((data: any) => {
      if (data) {
        // console.log("Success");
        //this.hideModel();       
        this.deepDiveAdvance();
        this.isAvanced1 = true;
        this.isAvanced = false;
        this.enableSearch = false;
        this.spinner.hide();
      }
    },
      (err) => {
        this.spinner.hide();
        //console.log(err);
      }
    );
  }
  deepDiveAdvance() {
    this.lstIgnoreKeys = [];
    this.lstIgnoreKeys_others = [];
    this.lstIgnoreKeys_io = [];
    this.lstIgnoreKeysTemp = [];
    this.lstIgnoreKeys_othersTemp = [];
    this.lstIgnoreKeys_ioTemp = [];
    // this.check_language = this.textConfigFormStandard.value.Language;
    // this.check_language = this.SessionService.getSessionStorageItem("Language");
    this.resetDomain();
    if (this.SessionService.getSessionStorageItem('CreateDDInput') != null && this.SessionService.getSessionStorageItem('CreateDDInput') != 'null' && this.SessionService.getSessionStorageItem('CreateDDInput') != '') {
      this.isDataAvailable = true;
    }
    this.MasterDummyDataUpload = JSON.parse(this.SessionService.getSessionStorageItem('CreateDDInput'));
    // if (localStorage.getItem("data") == null)
    //  localStorage.setItem("data", this.SessionService.getSessionStorageItem("CreateDDInput"));
    // this.MasterDummyDataUpload = JSON.parse(localStorage.getItem("data"));

    if (this.isDataAvailable == true) {
      this.lstDomainOption = [];
      this.lstDomainOption = [];
      this.isLoadAoPill = false;
      this.isLoadOtherPill = false;
      this.isLoadOtherPill = false;
      this.enableAo = false;
      this.enableIo = false;
      this.enableOthers = false;
      if (this.MasterDummyDataUpload.MappingData_AO.data.length > 0) {
        this.lstDomainOption.push({ name: 'AO', selected: true, disabled: false, msg: '', id: 1 });
        this.isLoadAoPill = true;
        this.enableAo = true;
        this.required_ao = true;
      }
      else {
        this.lstDomainOption.push({ name: 'AO', selected: false, disabled: true, msg: 'There are no tickets mapped for this domain', id: 1 });
      }
      if (this.MasterDummyDataUpload.MappingData_IO.data.length > 0) {
        this.lstDomainOption.push({ name: 'IO', selected: true, disabled: false, msg: '', id: 2 });
        if (this.enableAo == false) {
          this.isLoadIoPill = true;
          //this.isAddkeywordsEnabled_IO = false;
          //this.ChartData_IO = null;
          //this.required_io = false;
          // this.isResolutionDescEnabled_IO = false;
        }
        this.enableIo = true;
        this.required_io = true;
      }
      else {
        this.lstDomainOption.push({ name: 'IO', selected: false, disabled: true, msg: 'There are no tickets mapped for this domain', id: 2 });
        this.isAddkeywordsEnabled_IO = false;
        this.ChartData_IO = null;
        //this.isResolutionDescEnabled_IO = false;
      }
      if (this.MasterDummyDataUpload.MappingData_Others.data.length > 0) {
        this.lstDomainOption.push({ name: 'Others', selected: true, disabled: false, msg: '', id: 3 });
        if (this.enableAo == false && this.enableIo == false) {
          this.isLoadOtherPill = true;
          this.required_others = true;
        }
        this.enableOthers = true;
        this.required_others = true;
      }
      else {
        this.lstDomainOption.push({ name: 'Others', selected: false, disabled: true, msg: 'There are no tickets mapped for this domain', id: 3 });
      }
      // this.lstDomainOption = [
      //   { name: 'AO', selected: true, id: 1 },
      //   { name: 'IO', selected: true, id: 2 },
      //   { name: 'Others', selected: false, id: 3 },
      // ]
      this.isResolutionDescEnabled_Others_old = this.MasterDummyDataUpload.DisplayResolutionDesc;
      this.isResolutionDescEnabled_AO_old = this.MasterDummyDataUpload.DisplayResolutionDesc;
      this.isResolutionDescEnabled_IO_old = this.MasterDummyDataUpload.DisplayResolutionDesc;
      this.isResolutionDescEnabled_AO = this.isResolutionDescEnabled_AO_old;
      if (this.enableIo) {
        this.isResolutionDescEnabled_IO = false;
      }
      else {
        this.isResolutionDescEnabled_IO = this.isResolutionDescEnabled_IO_old;
      }
      this.isResolutionDescEnabled_Others = this.isResolutionDescEnabled_Others_old;
      this.mindate = {
        year: +this.MasterDummyDataUpload.MinTicketDate.substring(0, 4),
        month: +this.MasterDummyDataUpload.MinTicketDate.substring(5, 7),
        day: +this.MasterDummyDataUpload.MinTicketDate.substring(8, 10)
      };
      this.maxdate = {
        year: +this.MasterDummyDataUpload.MaxTicketDate.substring(0, 4),
        month: +this.MasterDummyDataUpload.MaxTicketDate.substring(5, 7),
        day: +this.MasterDummyDataUpload.MaxTicketDate.substring(8, 10)
      };
      this.lstMappingConfig_ao = this.MasterDummyDataUpload.MappingData_AO;
      this.lstMappingConfig_io = this.MasterDummyDataUpload.MappingData_IO;
      this.lstMappingConfig_others = this.MasterDummyDataUpload.MappingData_Others;

      this.lstTicketType_ao = this.MasterDummyDataUpload.TicketTypes_AO;
      this.lstTicketType_io = this.MasterDummyDataUpload.TicketTypes_IO;
      this.lstTicketType_others = this.MasterDummyDataUpload.TicketTypes_AO;

      this.lstCategorisedBy_ao = this.MasterDummyDataUpload.CategorisedBy;
      this.lstCategorisedBy_io = this.MasterDummyDataUpload.CategorisedBy;
      this.lstCategorisedBy_others = this.MasterDummyDataUpload.CategorisedBy;

      // var lstClassifiedByTemp = this.MasterDummyDataUpload.CategorisedBy;
      // lstClassifiedByTemp.push({'name' : 'ShortDescription'});
      // lstClassifiedByTemp.push({'name' : 'ResolutionDescription'});

      // this.lstClassifiedBy = lstClassifiedByTemp;
      // this.lstClassifiedBy_ao = lstClassifiedByTemp;
      // this.lstClassifiedBy_io = lstClassifiedByTemp;
      // this.lstClassifiedBy_others = lstClassifiedByTemp;
      // assing value to place holder of support group
      this.selectedSupportGroup_AO = 'Select ' + this.lstMappingConfig_ao.FilterName;
      this.selectedSupportGroup_IO = 'Select ' + this.lstMappingConfig_io.FilterName;
      this.selectedSupportGroup_Others = 'Select ' + this.lstMappingConfig_others.FilterName;
      // create dynamic checkbox controls domain mapping config
      const formControls_ao = this.lstMappingConfig_ao.data.map(control => new FormControl(false));
      const formControls_io = this.lstMappingConfig_io.data.map(control => new FormControl(false));
      const formControls_others = this.lstMappingConfig_others.data.map(control => new FormControl(false));
      const formCntrols_domain = this.lstDomainOption.map(control => new FormControl({ value: control.selected, disabled: control.disabled }));
      // const formCntrols_domain = this.lstDomainOption.map(control => new FormControl(control.selected));
      //this.selectedAlgoOption_io = false;
      this.textConfigForm = this.fb.group({
        AOGroup: this.fb.group({
          mappingConfigs: new FormArray(formControls_ao),
          deepdiveConfig: new FormControl('', Validators.required),
          algorithmModel: new FormControl('2', Validators.required),
          noOfCluster: new FormControl(""),
          exitCriteria: new FormControl(""),
          classifiedBasedOn: new FormControl('ShortDescription'),
          categorisedBy: new FormControl(''),
          ClassifiedBased: new FormControl('Select', Validators.required),
          ddlMultiselect: new MultiSelectComponent(this.selectedLanguage_AO),
          ignorekeywordLanguage: new FormControl('Select', Validators.required),
          ticketType: new FormControl('Select', Validators.required),
          startDate: new FormControl(this.mindate),
          endDate: new FormControl(this.maxdate),
          ignorekeyword: new FormControl(''),
          searchText: new FormControl(''),
          selectAllConfig: new FormControl(false),
          selectAllSearchConfig: new FormControl(false),
          topWordOption: new FormControl(this.WordCloudFilterOptions[2]),
          Language: new FormControl('Select', Validators.required)
        }),
        IOGroup: this.fb.group({
          mappingConfigs: new FormArray(formControls_io),
          deepdiveConfig: new FormControl('', Validators.required),
          algorithmModel: new FormControl('2', Validators.required),
          noOfCluster: new FormControl(""),
          exitCriteria: new FormControl(""),
          classifiedBasedOn: new FormControl('ShortDescription'),
          ddlMultiselect: new MultiSelectComponent(this.selectedLanguage_IO),
          ignorekeywordLanguage: new FormControl('Select', Validators.required),
          categorisedBy: new FormControl(''),
          ClassifiedBased: new FormControl('Select', Validators.required),
          ticketType: new FormControl('Select', Validators.required),
          startDate: new FormControl(this.mindate),
          endDate: new FormControl(this.maxdate),
          ignorekeyword: new FormControl(''),
          searchText: new FormControl(''),
          selectAllConfig: new FormControl(false),
          selectAllSearchConfig: new FormControl(false),
          topWordOption: new FormControl(this.WordCloudFilterOptions[2]),
          Language: new FormControl('Select', Validators.required)
        }),
        OthersGroup: this.fb.group({
          mappingConfigs: new FormArray(formControls_others),
          deepdiveConfig: new FormControl('', Validators.required),
          algorithmModel: new FormControl('2', Validators.required),
          noOfCluster: new FormControl(""),
          exitCriteria: new FormControl(""),
          classifiedBasedOn: new FormControl('ShortDescription'),
          categorisedBy: new FormControl(''),
          ClassifiedBased: new FormControl('Select', Validators.required),
          ddlMultiselect: new MultiSelectComponent(this.selectedLanguage_Other),
          ignorekeywordLanguage: new FormControl('Select', Validators.required),
          ticketType: new FormControl('Select', Validators.required),
          startDate: new FormControl(this.mindate),
          endDate: new FormControl(this.maxdate),
          ignorekeyword: new FormControl(''),
          searchText: new FormControl(''),
          selectAllConfig: new FormControl(false),
          selectAllSearchConfig: new FormControl(false),
          topWordOption: new FormControl(this.WordCloudFilterOptions[2]),
          Language: new FormControl('Select', Validators.required)
        }),
        domainOption: new FormArray(formCntrols_domain)

      });
    }
    this.lstFilterMappingConfig_ao = this.lstMappingConfig_ao.data;
    this.lstFilterMappingConfig_io = this.lstMappingConfig_io.data;
    this.lstFilterMappingConfig_others = this.lstMappingConfig_others.data;
    if (this.MasterDummyDataUpload.MappingData_IO.data.length > 0) {
      this.check_language = this.envVar.EnableLanguage ? this.selectedLanguage_IO.join('|') : 'English';

      this.GetLanguageCheck_IO('IO');
    }
  }
  resetDomain() {
    this.isLoadAoPill = false;
    this.isLoadIoPill = false;
    this.isLoadOtherPill = false;
  }

  formMinDate() {
    const year = +this.MasterDummyDataUpload.MinTicketDate.substring(0, 4);
    const month = this.MasterDummyDataUpload.MinTicketDate.substring(5, 7);
    const day = this.MasterDummyDataUpload.MinTicketDate.substring(8, 10);
    return { year: +year, month: +month, day: +day };
  }

  ngOnInit(): void {
    let that = this;
    this.dropdownSettings = {
      // singleSelection: false,
      idField: 'DimensionValue',
      textField: 'DimensionValue',
      itemsShowLimit: 2,
      // limitSelection : 2,
      allowSearchFilter: false
    };
    this.getLanguageList();
    this.textConfigForm.get('AOGroup').get('ignorekeywordLanguage').setValue('Select');
    this.textConfigForm.get('IOGroup').get('ignorekeywordLanguage').setValue('Select');
    this.textConfigForm.get('OthersGroup').get('ignorekeywordLanguage').setValue('Select');
    this.messageService.currentBAUploadedData.subscribe(msg => {
      that.BAUploadedData = msg;
    });
    if (this.isDataAvailable == false) {
      event.preventDefault();
      bootbox.alert('Please upload the ticket data..!');
      let element: HTMLElement = document.getElementById('uploadExceltemp') as HTMLElement;
      element.click();
    }
    else {
      // this.lstFilterMappingConfig_ao = this.lstMappingConfig_ao.data;
      // this.lstFilterMappingConfig_io = this.lstMappingConfig_io.data;
      // this.lstFilterMappingConfig_others = this.lstMappingConfig_others.data;
    }
    $(document).ready(function () {
      $('.iom-dropdown .dropdown-menu .new').click(function (e) {
        e.stopPropagation();
      });
      $('.iom-drop-body .dropdown-menu.iomcalender').click(function (e) {
        e.stopPropagation();
      });
      $(window).scroll(function () {
        if ($(this).scrollTop() >= $('.myw-topbar').offset().top)
          $('body').addClass('myw-sticky');
        else
          $('body').removeClass('myw-sticky');
      }).trigger('scroll');

      //TABS
      $('.domain-check input').click(function (e) {
        $('.iom-tab-content').show();
        if (e.currentTarget.checked) {
          $('#' + e.currentTarget.name + '-tab').addClass('show-an');
          if (!$('.nav-item.nav-link.show-an.active').length) {
            $('#' + e.currentTarget.name + '-tab').addClass('active');
            $('#' + e.currentTarget.name).addClass('active');
          }
        }
        else {
          $('#' + e.currentTarget.name + '-tab').removeClass('show-an');
          $('#' + e.currentTarget.name + '-tab').removeClass('active');
          $('#' + e.currentTarget.name).removeClass('active');
          if (!$('.nav-item.nav-link.show-an.active').length && $('.nav-item.nav-link.show-an').length) {
            $('.nav-item.nav-link.show-an').first().addClass('active');
            $('#' + $('.nav-item.nav-link.show-an')[0].id.replace('-tab', '')).addClass('active');
          }
          if (!$('.tab-pane.active').length) {
            $('.iom-tab-content').hide();
          }
        }
      });
      $('.iom-tabs a').click(function (e) {
        $('.iom-tab-content .tab-pane').removeClass('active');
        $('#' + e.currentTarget.id.replace('-tab', '')).addClass('active');
      });

      // Select Next
      $('.validate-action').one('click', function (e) {
        e.preventDefault();
        $(this).removeClass('validate-action').text('Next');
        $('.validate-section').removeClass('d-none');
      });
      //Select Feature Dropdown

      $("select").change(function () {
        $(this).find("option:selected").each(function () {
          var optionValue = $(this).attr("value");
          if (optionValue) {
            $(".imo-table").not("." + optionValue).hide();
            $("." + optionValue).show();
          } else {
            $(".imo-table").hide();
          }
        });
      }).change();
      // Select Advance Opention Next
      $(".select-domain").hide();
      $('.advance-optnext').click(function () {
        $(".select-domain").show();
        $(".validate-section").hide();
      });
      $('.supportgrp-optnext').click(function () {
        $(".select-domain").hide();
        $(".validate-section").hide();
        $(".suportgrp-section").show();
      });
      this.SessionService.setSessionStorageItem("selectAllAO", "false");
      this.SessionService.setSessionStorageItem("selectAllIO", "false");
      this.SessionService.setSessionStorageItem("selectAllOth", "false");
    });

  }
  searchAssignment(tab: string) {
    let text;
    let sao = '';
    switch (tab) {
      case 'ao':
        this.lstFilterMappingConfig_ao = null;
        text = this.textConfigForm.value.AOGroup.searchText != undefined && this.textConfigForm.value.AOGroup.searchText != '' ? this.textConfigForm.value.AOGroup.searchText.toString().toLowerCase().trim() : '';
        if (text == '') {
          this.lstFilterMappingConfig_ao = this.lstMappingConfig_ao.data;
          this.searchcheck_ao = true;
          setTimeout(() => {
            this.lstFilterMappingConfig_ao.forEach((x, i) => {
              if (x.isChecked) {
                this.textConfigForm.value.AOGroup.mappingConfigs[x.indexNo] = true;
                $('#aoSearch_' + x.indexNo).prop('checked', true);
              }
              else {
                this.textConfigForm.value.AOGroup.mappingConfigs[x.indexNo] = false;
                $('#aoSearch_' + x.indexNo).prop('checked', false);
              }
            });
            this.selectedSearchAllAoId.nativeElement.checked = false;
            this.textConfigForm.value.AOGroup.selectAllSearchConfig = false;
            if (this.lstFilterMappingConfig_ao != null) {
              this.lstFilterMappingConfig_ao.forEach((x, i) => {
                if (x.isChecked)
                  sao += sao == '' ? x.name : ',' + x.name;
              });
            }
            if ((sao !== '' && sao !== undefined) && this.textConfigForm.value.AOGroup.mappingConfigs.length === sao.split(',').filter(value => value !== 'All').length) {
              this.selectedAllAoId.nativeElement.checked = true;
              this.textConfigForm.value.AOGroup.selectAllConfig = true;
              this.SessionService.setSessionStorageItem("selectAllAO", "true");
            }
            else {
              this.selectedAllAoId.nativeElement.checked = false;
              this.textConfigForm.value.AOGroup.selectAllConfig = false;
              this.SessionService.setSessionStorageItem("selectAllAO", "false");
            }
          }, 100);
        }
        else {
          this.lstFilterMappingConfig_aoSearch = null;
          $('#selectAllSearchAO').prop('checked', false);
          this.textConfigForm.value.AOGroup.selectAllSearchConfig = false;
          text != '' ? this.lstFilterMappingConfig_ao = this.lstMappingConfig_ao.data.filter(row => {
            return (row.name != undefined ? row.name.toLowerCase().trim().includes(text) : false);
          }) :
            this.lstFilterMappingConfig_ao == undefined ? this.lstFilterMappingConfig_ao = null : '';
          if (this.lstFilterMappingConfig_ao.length != 0) {
            this.lstFilterMappingConfig_aoSearch = this.lstFilterMappingConfig_ao;
          }
          this.searchcheck_ao = false;
        }
        break;
      case 'io':
        this.lstFilterMappingConfig_io = null;
        text = this.textConfigForm.value.IOGroup.searchText != undefined && this.textConfigForm.value.IOGroup.searchText != '' ? this.textConfigForm.value.IOGroup.searchText.toString().toLowerCase().trim() : '';
        if (text == '') {
          this.lstFilterMappingConfig_io = this.lstMappingConfig_io.data;
          this.searchcheck_io = true;
          setTimeout(() => {
            this.lstFilterMappingConfig_io.forEach((x, i) => {
              if (x.isChecked) {
                this.textConfigForm.value.IOGroup.mappingConfigs[x.indexNo] = true;
                $('#ioSearch_' + x.indexNo).prop('checked', true);
              }
              else {
                this.textConfigForm.value.IOGroup.mappingConfigs[x.indexNo] = false;
                $('#ioSearch_' + x.indexNo).prop('checked', false);
              }
            });
            this.selectedSearchAllIoId.nativeElement.checked = false;
            this.textConfigForm.value.IOGroup.selectAllSearchConfig = false;

            if (this.lstFilterMappingConfig_io != null) {
              this.lstFilterMappingConfig_io.forEach((x, i) => {
                if (x.isChecked)
                  sao += sao == '' ? x.name : ',' + x.name;
              });
            }
            if ((sao !== '' && sao !== undefined) && this.textConfigForm.value.IOGroup.mappingConfigs.length === sao.split(',').filter(value => value !== 'All').length) {
              this.selectedAllIoId.nativeElement.checked = true;
              this.textConfigForm.value.IOGroup.selectAllConfig = true;
              this.SessionService.setSessionStorageItem("selectAllIO", "true");
            }
            else {
              this.selectedAllIoId.nativeElement.checked = false;
              this.textConfigForm.value.IOGroup.selectAllConfig = false;
              this.SessionService.setSessionStorageItem("selectAllIO", "false");
            }
          }, 100);
        }
        else {
          this.lstFilterMappingConfig_ioSearch = null;
          $('#selectAllSearchIO').prop('checked', false);
          this.textConfigForm.value.IOGroup.selectAllSearchConfig = false;
          text != '' ? this.lstFilterMappingConfig_io = this.lstMappingConfig_io.data.filter(row => {
            return (row.name != undefined ? row.name.toLowerCase().trim().includes(text) : false);
          }) :
            this.lstFilterMappingConfig_io == undefined ? this.lstFilterMappingConfig_io = null : '';
          if (this.lstFilterMappingConfig_io.length != 0) {
            this.lstFilterMappingConfig_ioSearch = this.lstFilterMappingConfig_io;
          }
          this.searchcheck_io = false;
        }
        break;
      case 'others':
        this.lstFilterMappingConfig_others = null;
        text = this.textConfigForm.value.OthersGroup.searchText != undefined && this.textConfigForm.value.OthersGroup.searchText != '' ? this.textConfigForm.value.OthersGroup.searchText.toString().toLowerCase().trim() : '';
        if (text == '') {
          this.lstFilterMappingConfig_others = this.lstMappingConfig_others.data;
          this.searchcheck_others = true;
          setTimeout(() => {
            this.lstFilterMappingConfig_others.forEach((x, i) => {
              if (x.isChecked) {
                this.textConfigForm.value.OthersGroup.mappingConfigs[x.indexNo] = true;
                $('#othSearch_' + x.indexNo).prop('checked', true);
              }
              else {
                this.textConfigForm.value.OthersGroup.mappingConfigs[x.indexNo] = false;
                $('#othSearch_' + x.indexNo).prop('checked', false);
              }
            });
            this.selectedSearchAllOthersId.nativeElement.checked = false;
            this.textConfigForm.value.OthersGroup.selectAllSearchConfig = false;

            if (this.lstFilterMappingConfig_others != null) {
              this.lstFilterMappingConfig_others.forEach((x, i) => {
                if (x.isChecked)
                  sao += sao == '' ? x.name : ',' + x.name;
              });
            }
            if ((sao !== '' && sao !== undefined) && this.textConfigForm.value.OthersGroup.mappingConfigs.length === sao.split(',').filter(value => value !== 'All').length) {
              this.selectedAllOthersId.nativeElement.checked = true;
              this.textConfigForm.value.OthersGroup.selectAllConfig = true;
              this.SessionService.setSessionStorageItem("selectAllOth", "true");
            }
            else {
              this.selectedAllOthersId.nativeElement.checked = false;
              this.textConfigForm.value.OthersGroup.selectAllConfig = false;
              this.SessionService.setSessionStorageItem("selectAllOth", "false");
            }
          }, 100);
        }
        else {
          this.lstFilterMappingConfig_othSearch = null;
          $('#selectAllSearchOth').prop('checked', false);
          this.textConfigForm.value.OthersGroup.selectAllSearchConfig = false;
          text != '' ? this.lstFilterMappingConfig_others = this.lstMappingConfig_others.data.filter(row => {
            return (row.name != undefined ? row.name.toLowerCase().trim().includes(text) : false);
          }) :
            this.lstFilterMappingConfig_others == undefined ? this.lstFilterMappingConfig_others = null : '';
          if (this.lstFilterMappingConfig_others.length != 0) {
            this.lstFilterMappingConfig_othSearch = this.lstFilterMappingConfig_others;
          }
          this.searchcheck_others = false;
        }
        break;
      default:
        break;
    }
  }
  algorithmChange(flag: boolean, tab: string, categorizedByFlag: boolean, isAddkeywordsEnabled: boolean, isResolutionDescEnabled: boolean, algoModel: string) {
    switch (tab) {
      case 'ao':
        this.selectedAlgoOption = flag; // IsKmeans
        this.categorizedByFlag_ao = categorizedByFlag; // Catgeorized by option
        if (this.selectedLanguage_AO.join('|').toString().includes('Chinese')) {
          this.LemmaDisableAO = true;
          this.EnableLemmaAO = false;
        }
        else {
          this.LemmaDisableAO = false;
        }
        if (!categorizedByFlag) {
          this.required_ao = true;
          this.textConfigForm.get('AOGroup').get('categorisedBy').setValue('');
        }
        else {
          this.required_ao = false;
          this.textConfigForm.get('AOGroup').get('noOfCluster').setValue('');
          this.textConfigForm.get('AOGroup').get('exitCriteria').setValue('');
        }
        this.isAddkeywordsEnabled_AO = isAddkeywordsEnabled;
        if (this.isResolutionDescEnabled_AO_old)
          this.isResolutionDescEnabled_AO = isResolutionDescEnabled;

        // if (flag == false)
        //   this.textConfigForm.value.AOGroup.algorithmModel.setValue("User Defined");
        // else
        //   this.textConfigForm.value.AOGroup.algorithmModel.setValue("System Generated: (K-means)");
        break;
      case 'io':
        this.LemmaDisableIO = false;
        this.EnableLemmaIO = false;
        this.selectedAlgoOption_io = flag;
        this.categorizedByFlag_io = categorizedByFlag;
        this.isAddkeywordsEnabled_IO = isAddkeywordsEnabled;        
        if (this.isResolutionDescEnabled_IO_old)
          this.isResolutionDescEnabled_IO = isResolutionDescEnabled;
        if (flag && !categorizedByFlag) {
          this.required_io = true;
          this.textConfigForm.get('IOGroup').get('categorisedBy').setValue('');
        }
        else if (categorizedByFlag) {
          this.required_io = false;
          this.textConfigForm.get('IOGroup').get('noOfCluster').setValue('');
          this.textConfigForm.get('IOGroup').get('exitCriteria').setValue('');
        }
        else {
          this.required_io = false;
          this.textConfigForm.get('IOGroup').get('noOfCluster').setValue('');
          this.textConfigForm.get('IOGroup').get('exitCriteria').setValue('');
          this.textConfigForm.get('IOGroup').get('categorisedBy').setValue('');
        }
        if (!this.isResolutionDescEnabled_IO) {
          this.textConfigForm.get('IOGroup').get('classifiedBasedOn').setValue('ShortDescription');
        }
        if (algoModel == "regression" || this.selectedLanguage_IO.join('|').toString().includes('Chinese')) {
          this.LemmaDisableIO = true;          
          this.isResolutionDescEnabled_IO = false;          
        }
        else {         
          if (this.selectedLanguage_IO.join('|').toString().includes('English')) {
            this.LemmaDisableIO = false;
          }                    
          this.isResolutionDescEnabled_IO = this.isResolutionDescEnabled_IO_old;
        }        
        // if (flag == false)
        //   this.textConfigForm.value.AOGroup.algorithmModel.setValue("User Defined");
        // else
        //   this.textConfigForm.value.AOGroup.algorithmModel.setValue("System Generated: (K-means)");
        break;
      case 'others':
        this.selectedAlgoOption_others = flag;
        this.categorizedByFlag_others = categorizedByFlag;
        this.isAddkeywordsEnabled_Others = isAddkeywordsEnabled;
        if (this.selectedLanguage_Other.join('|').toString().includes('Chinese')) {
          this.LemmaDisableOth = true;
          this.EnableLemmaOth = false;
        }
        else {
          this.LemmaDisableOth = false;
        }
        if (this.isResolutionDescEnabled_Others_old)
          this.isResolutionDescEnabled_Others = isResolutionDescEnabled;
        if (!categorizedByFlag) {
          this.required_others = true;
          this.textConfigForm.get('OthersGroup').get('categorisedBy').setValue('');
        }
        else {
          this.required_others = false;
          this.textConfigForm.get('OthersGroup').get('noOfCluster').setValue('');
          this.textConfigForm.get('OthersGroup').get('exitCriteria').setValue('');
        }
        // if (flag == false)
        //   this.textConfigForm.value.OthersGroup.algorithmModel.setValue("User Defined");
        // else
        //   this.textConfigForm.value.OthersGroup.algorithmModel.setValue("System Generated: (K-means)");
        break;
      default:
        break;
    }
  }
  ClassifiedBasedONChange(value: string, domain: string) {
    this.classifiedBasedOn = value;
    switch (domain) {
      case 'AO':
        this.textConfigForm.get('AOGroup').get('classifiedBasedOn').setValue(this.classifiedBasedOn);
        break;
      case 'IO':
        this.textConfigForm.get('IOGroup').get('classifiedBasedOn').setValue(this.classifiedBasedOn);
        break;
      case 'Others':
        this.textConfigForm.get('OthersGroup').get('classifiedBasedOn').setValue(this.classifiedBasedOn);
        break;
      default:
        break;
    }
    if (this.isAddkeywordsEnabled_IO == false && domain == "IO") {
      return;
    }
    this.LoadWordCloudDataFromHistory(domain);
  }

  loadAoPill() {
    this.isLoadAoPill = true;
    this.isLoadIoPill = false;
    this.isLoadOtherPill = false;
  }

  loadIoPill() {
    this.isLoadAoPill = false;
    this.isLoadIoPill = true;
    this.isLoadOtherPill = false;
    if (this.textConfigForm.value.IOGroup.algorithmModel == "3") {
      this.isAddkeywordsEnabled_IO = false;
      this.isResolutionDescEnabled_IO = false;
    }
    else if (this.textConfigForm.value.IOGroup.algorithmModel == "2") {
      this.selectedAlgoOption_io = true;
      this.required_io = true;
    }
  }

  loadOtherPill() {
    this.isLoadAoPill = false;
    this.isLoadIoPill = false;
    this.isLoadOtherPill = true;
  }

  navigateToDeepDive() {
    this.router.navigate(['deepdive']);
  }
  CreateDeepdiveStandard() {
    let that = this;
    this.spinner.show();
    // Set the userType    
    var UserType = this.SessionService.getSessionStorageItem('userType');
    var e2EUID = this.SessionService.getE2EUId();
    if (this.envVar.Env == "FDS_ManualUpload") {
      e2EUID = this.SessionService.getDeliveryConstructUId();
    }
    const cMSUID = this.SessionService.getCMSUId();
    //const wSUID = this.SessionService.getWSUId();
    const DeliveryConstructUId = this.SessionService.getDeliveryConstructUId();
    this.startDate = this.MasterDummyDataUpload.MinTicketDate;
    this.endDate = this.MasterDummyDataUpload.MaxTicketDate;
    this.enableDQT = this.EnableDQTStd;
    this.enableLemma = this.EnableLemmaStd;
    this.enableRestrictDD = this.enableRestrictdd;
    this.categorisedBy = this.MasterDummyDataUpload.CategorisedByDD;
    if ((this.envVar.Env == "FDS_ManualUpload" && this.SessionService.getSessionStorageItem('userType') == "1") || this.envVar.Env == "SAAS_PAM") {
      UserType = '1';
    }
    else if (this.envVar.Env == "SAAS_ManuaUpload" || (this.envVar.Env == "FDS_ManualUpload" && this.SessionService.getSessionStorageItem('userType') == "3") || this.envVar.Env == "SAAS_FDS") {
      UserType = '3';
    }

    var actualclassifiedBasedON = '';
    if (this.textConfigFormStandard.value.ClassifiedBased != 'Select' && this.textConfigFormStandard.value.ClassifiedBased != undefined &&
      this.textConfigFormStandard.value.ClassifiedBased != 'ShortDescription' && this.textConfigFormStandard.value.ClassifiedBased != 'ResolutionDescription' && this.textConfigFormStandard.value.ClassifiedBased != 'LongDescription') {
      actualclassifiedBasedON = this.IsEmpty(this.textConfigFormStandard.value.ClassifiedBased) ? null : this.lstClassifiedBy.find(x => x.name.replace(/\s/g, '') == this.textConfigFormStandard.value.ClassifiedBased.replace(/\s/g, '')).name;
    }

    if (this.ValidateFormStandard()) {
      if (this.isQualifiedDescEnabled != null && !this.isQualifiedDescEnabled) {
        this.spinner.hide();
        bootbox.alert('Selected value is not qualified for the categorized description.');
        return false;
      }
      this.iomService.CreateDeepdiveStandared<any>("1", this.textConfigFormStandard.value.deepdiveConfig, this.textConfigFormStandard.value.ClassifiedBased, actualclassifiedBasedON, UserType, this.BAUploadedData, this.MasterDummyDataUpload.DisplayResolutionDesc, this.MasterDummyDataUpload.MandatoryColumns, this.MasterDummyDataUpload.ExcelMappingFields, 0, this.SessionService.getUserName(), this.MasterDummyDataUpload.fileName, this.MasterDummyDataUpload.ActualColumns, this.MasterDummyDataUpload.SheetName, e2EUID, cMSUID, DeliveryConstructUId, this.startDate, this.endDate, this.envVar.EnableLanguage ? this.selectedStdLanguage.join('|') : 'English', this.envVar.Env, this.enableDQT, this.enableLemma, this.enableRestrictDD).subscribe(data => {
        if (data) {
          this.spinner.hide();
          if (data.Result.indexOf('success') > -1) {
            bootbox.alert(data.Result, function () {
              that.SessionService.removeSessionValue('CreateDDInput');
              that.BAUploadedData = null;
              if (UserType != '4') {
                that.router.navigate(['deepdive']);
              }
              else {
                that.router.navigate(['deepdive'], { queryParams: { SolutionId: that.SessionService.getSolutionId() } });
              }
            });
          }
          else {
            bootbox.alert(data.Result);
          }
        }
      },
        (err: HttpErrorResponse) => {
          this.spinner.hide();
          //console.log('Error Occured !');
          bootbox.alert('deepdive creation failed');
        });
    }
    else {
      this.spinner.hide();
    }
  }

  ValidateFormStandard() {
    if (this.textConfigFormStandard.value.deepdiveConfig == '' || this.textConfigFormStandard.value.deepdiveConfig == undefined) {
      bootbox.alert('Please enter Deepdive Name.');
      return false;
    }
    if (this.selectedStdLanguage.length == 0) {
      if (this.envVar.EnableLanguage == true) {
        bootbox.alert('Please select Ticket Language.');
        return false;
      }
    }
    if (this.textConfigFormStandard.value.ClassifiedBased == 'Select' || this.textConfigFormStandard.value.ClassifiedBased == '' || this.textConfigFormStandard.value.ClassifiedBased == undefined) {
      bootbox.alert('Please select Classified Based on.');
      return false;
    }
    if (this.textConfigFormStandard.value.deepdiveConfig.length > 50) {
      bootbox.alert('Deep dive name size should not be greater than 50 characters!');
      return false;
    }
    if ((/^[a-zA-Z0-9_ -]*$/.test(this.textConfigFormStandard.value.deepdiveConfig)) == false) {
      bootbox.alert('Deep dive name have some invalid characters!');
      return false;
    }
    else if (this.textConfigFormStandard.value.deepdiveConfig.match(/^[0-9\s_ -]*$/)) {
      bootbox.alert('Deep dive name should be alphanumeric!');
      return false;
    }
    return true;
  }
  CreateDeepdive() {
    const that = this;
    this.spinner.show();
    // capturing Form data
    if (this.ValidateForm()) {
      // if(this.isQualifiedDescEnabled !=null && !this.isQualifiedDescEnabled)
      // {
      //   this.spinner.hide();
      //   bootbox.alert('Selected value is not qualified for the categorized description.');
      //   return false;
      // }
      // if (true) {
      if (this.isSkipTopWords)
        this.BatchId = '';
      this.isValidFormSubmitted = false;
      //  if(this.textConfigForm.invalid){
      //   return;
      //  }
      // this.isValidFormSubmitted = true;
      // Set the userType
      var UserType = this.SessionService.getSessionStorageItem('userType');
      // assigning domain option     
      const domainOption = this.textConfigForm.getRawValue().domainOption
        .map((checked, index) => checked ? this.lstDomainOption[index].name : null)
        .filter(value => value !== null).join();
      // assigning AO Analytics configuration
      this.aoAnalytics.mappingConfigFilter = this.lstMappingConfig_ao.ActualFilterName.split('|')[1];
      this.aoAnalytics.mappingConfigData = this.textConfigForm.value.AOGroup.mappingConfigs
        .map((checked, index) => checked ? this.lstMappingConfig_ao.data[index].name : null)
        .filter(value => value !== null).join('~^~');
      this.aoAnalytics.deepdiveConfig = this.textConfigForm.value.AOGroup.deepdiveConfig;
      this.aoAnalytics.selectedAlgorithm = this.textConfigForm.value.AOGroup.algorithmModel;
      this.aoAnalytics.noOfCluster = this.textConfigForm.value.AOGroup.noOfCluster;
      this.aoAnalytics.exitCriteria = this.textConfigForm.value.AOGroup.exitCriteria;
      this.aoAnalytics.classifiedBasedON = this.textConfigForm.value.AOGroup.ClassifiedBased;
      this.aoAnalytics.categorisedBy = this.textConfigForm.value.AOGroup.categorisedBy == 'Select' ? null : this.textConfigForm.value.AOGroup.categorisedBy;
      this.aoAnalytics.ticketType = this.textConfigForm.value.AOGroup.ticketType == 'Select' ? '' : this.textConfigForm.value.AOGroup.ticketType;
      this.aoAnalytics.startDate = JSON.stringify(this.textConfigForm.value.AOGroup.startDate);
      this.aoAnalytics.endDate = JSON.stringify(this.textConfigForm.value.AOGroup.endDate);
      this.aoAnalytics.ignoreKeywords = this.LanguageKeywordAO;
      this.aoAnalytics.actualOpportunityBy = this.IsEmpty(this.aoAnalytics.categorisedBy) ? null : this.categorisedBy.find(x => x.Key.replace(/\s/g, '') == this.aoAnalytics.categorisedBy.replace(/\s/g, '')).MappingKey.split('|')[0];
      this.aoAnalytics.actualclassifiedBasedON = '';
      if (this.aoAnalytics.classifiedBasedON != 'Select' && this.aoAnalytics.classifiedBasedON != undefined && this.aoAnalytics.classifiedBasedON != 'ShortDescription' && this.aoAnalytics.classifiedBasedON != 'ResolutionDescription' && this.aoAnalytics.classifiedBasedON != 'LongDescription') {
        this.aoAnalytics.actualclassifiedBasedON = this.IsEmpty(this.aoAnalytics.classifiedBasedON) ? null : this.lstClassifiedBy_ao.find(x => x.name.replace(/\s/g, '') == this.aoAnalytics.classifiedBasedON.replace(/\s/g, '')).name;
      }
      this.aoAnalytics.Language = this.envVar.EnableLanguage ? this.selectedLanguage_AO.join('|') : 'English';
      this.aoAnalytics.enableDQT = this.EnableDQTAO;
      this.aoAnalytics.IsLemmaEnabled = this.EnableLemmaAO;
      // this.textAnalytics.aoAnalytics = this.aoAnalytics;
      this.topKeyWord_AO = new TopKeyWordsFilter(this.BatchId, this.isSkipTopWords,
        this.textConfigForm.value.AOGroup.startDate != '' ? JSON.stringify(this.textConfigForm.value.AOGroup.startDate) : '',
        this.textConfigForm.value.AOGroup.endDate != '' ? JSON.stringify(this.textConfigForm.value.AOGroup.endDate) : '',
        0,
        "AO",
        this.textConfigForm.value.AOGroup.ClassifiedBased,

        this.textConfigForm.value.AOGroup.ticketType == 'Select' ? '' : this.textConfigForm.value.AOGroup.ticketType,
        this.textConfigForm.value.AOGroup.mappingConfigs
          .map((checked, index) => checked ? this.lstMappingConfig_ao.data[index].name : null)
          .filter(value => value !== null).join(),
        null, this.lstMappingConfig_ao.ActualFilterName, this.lstIgnoreKeys?.join(), "", this.envVar.EnableLanguage ? this.selectedLanguage_AO.join('|') : 'English');

      // assigning IO Analytics
      this.ioAnalytics.mappingConfigFilter = this.lstMappingConfig_io.ActualFilterName.split('|')[1];
      this.ioAnalytics.mappingConfigData = this.textConfigForm.value.IOGroup.mappingConfigs
        .map((checked, index) => checked ? this.lstMappingConfig_io.data[index].name : null)
        .filter(value => value !== null).join('~^~');
      this.ioAnalytics.selectedAlgorithm = this.textConfigForm.value.IOGroup.algorithmModel;
      this.ioAnalytics.noOfCluster = this.textConfigForm.value.IOGroup.noOfCluster;
      this.ioAnalytics.exitCriteria = this.textConfigForm.value.IOGroup.exitCriteria;
      this.ioAnalytics.classifiedBasedON = this.textConfigForm.value.IOGroup.ClassifiedBased;
      this.ioAnalytics.deepdiveConfig = this.textConfigForm.value.IOGroup.deepdiveConfig;
      this.ioAnalytics.categorisedBy = this.textConfigForm.value.IOGroup.categorisedBy == 'Select' ? null : this.textConfigForm.value.IOGroup.categorisedBy;
      this.ioAnalytics.ticketType = this.textConfigForm.value.IOGroup.ticketType == 'Select' ? '' : this.textConfigForm.value.IOGroup.ticketType;
      this.ioAnalytics.startDate = JSON.stringify(this.textConfigForm.value.IOGroup.startDate);
      this.ioAnalytics.endDate = JSON.stringify(this.textConfigForm.value.IOGroup.endDate);
      this.ioAnalytics.ignoreKeywords = this.LanguageKeywordIO;
      this.ioAnalytics.actualOpportunityBy = this.IsEmpty(this.ioAnalytics.categorisedBy) ? null : this.categorisedBy.find(x => x.Key.replace(/\s/g, '') == this.ioAnalytics.categorisedBy.replace(/\s/g, '')).MappingKey.split('|')[0];
      this.ioAnalytics.actualclassifiedBasedON = '';
      if (this.ioAnalytics.classifiedBasedON != 'Select' && this.ioAnalytics.classifiedBasedON != undefined && this.ioAnalytics.classifiedBasedON != 'ShortDescription' && this.ioAnalytics.classifiedBasedON != 'ResolutionDescription' && this.ioAnalytics.classifiedBasedON != 'LongDescription') {
        this.ioAnalytics.actualclassifiedBasedON = this.IsEmpty(this.ioAnalytics.classifiedBasedON) ? null : this.lstClassifiedBy_io.find(x => x.name.replace(/\s/g, '') == this.ioAnalytics.classifiedBasedON.replace(/\s/g, '')).name;
      }
      this.ioAnalytics.Language = this.envVar.EnableLanguage ? this.selectedLanguage_IO.join('|') : 'English';
      this.ioAnalytics.enableDQT = this.EnableDQTIO;
      this.ioAnalytics.IsLemmaEnabled = this.EnableLemmaIO;
      // this.ioAnalytics.selectedAlgorithm = 2;
      // this.textAnalytics.ioAnalytics = this.ioAnalytics;
      this.topKeyWord_IO = new TopKeyWordsFilter(this.BatchId, this.isSkipTopWords,
        this.textConfigForm.value.IOGroup.startDate != '' ? JSON.stringify(this.textConfigForm.value.IOGroup.startDate) : '',
        this.textConfigForm.value.IOGroup.endDate != '' ? JSON.stringify(this.textConfigForm.value.IOGroup.endDate) : '',
        0,
        "IO",
        this.textConfigForm.value.IOGroup.ClassifiedBased,
        this.textConfigForm.value.IOGroup.ticketType == 'Select' ? '' : this.textConfigForm.value.IOGroup.ticketType,
        this.textConfigForm.value.IOGroup.mappingConfigs
          .map((checked, index) => checked ? this.lstMappingConfig_io.data[index].name : null)
          .filter(value => value !== null).join(),
        null, this.lstMappingConfig_io.ActualFilterName, this.lstIgnoreKeys_io?.join(), "", this.envVar.EnableLanguage ? this.selectedLanguage_IO.join('|') : 'English');

      // assigning Others Analytics configuration
      this.othersAnalytics.mappingConfigFilter = this.lstMappingConfig_others.ActualFilterName.split('|')[1];
      this.othersAnalytics.mappingConfigData = this.textConfigForm.value.OthersGroup.mappingConfigs
        .map((checked, index) => checked ? this.lstMappingConfig_others.data[index].name : null)
        .filter(value => value !== null).join('~^~');
      this.othersAnalytics.deepdiveConfig = this.textConfigForm.value.OthersGroup.deepdiveConfig;
      this.othersAnalytics.selectedAlgorithm = this.textConfigForm.value.OthersGroup.algorithmModel;
      this.othersAnalytics.noOfCluster = this.textConfigForm.value.OthersGroup.noOfCluster;
      this.othersAnalytics.exitCriteria = this.textConfigForm.value.OthersGroup.exitCriteria;
      this.othersAnalytics.classifiedBasedON = this.textConfigForm.value.OthersGroup.ClassifiedBased;
      this.othersAnalytics.categorisedBy = this.textConfigForm.value.OthersGroup.categorisedBy == 'Select' ? null : this.textConfigForm.value.OthersGroup.categorisedBy;
      this.othersAnalytics.ticketType = this.textConfigForm.value.OthersGroup.ticketType == 'Select' ? '' : this.textConfigForm.value.OthersGroup.ticketType;
      this.othersAnalytics.startDate = JSON.stringify(this.textConfigForm.value.OthersGroup.startDate);
      this.othersAnalytics.endDate = JSON.stringify(this.textConfigForm.value.OthersGroup.endDate);
      this.othersAnalytics.ignoreKeywords = this.LanguageKeywordOthers
      this.othersAnalytics.actualOpportunityBy = this.IsEmpty(this.othersAnalytics.categorisedBy) ? null : this.categorisedBy.find(x => x.Key.replace(/\s/g, '') == this.othersAnalytics.categorisedBy.replace(/\s/g, '')).MappingKey.split('|')[0];
      this.othersAnalytics.actualclassifiedBasedON = '';
      if (this.othersAnalytics.classifiedBasedON != 'Select' && this.othersAnalytics.classifiedBasedON != undefined && this.othersAnalytics.classifiedBasedON != 'ShortDescription' && this.othersAnalytics.classifiedBasedON != 'ResolutionDescription' && this.othersAnalytics.classifiedBasedON != 'LongDescription') {
        this.othersAnalytics.actualclassifiedBasedON = this.IsEmpty(this.othersAnalytics.classifiedBasedON) ? null : this.lstClassifiedBy_others.find(x => x.name.replace(/\s/g, '') == this.othersAnalytics.classifiedBasedON.replace(/\s/g, '')).name;
      }
      this.othersAnalytics.Language = this.ioAnalytics.Language = this.envVar.EnableLanguage ? this.selectedLanguage_Other.join('|') : 'English';
      this.othersAnalytics.enableDQT = this.EnableDQTOth;
      this.othersAnalytics.IsLemmaEnabled = this.EnableLemmaOth;
      // this.textAnalytics.othersAnalytics = this.othersAnalytics;
      this.topKeyWord_Others = new TopKeyWordsFilter(this.BatchId, this.isSkipTopWords,
        this.textConfigForm.value.OthersGroup.startDate != '' ? JSON.stringify(this.textConfigForm.value.OthersGroup.startDate) : '',
        this.textConfigForm.value.OthersGroup.endDate != '' ? JSON.stringify(this.textConfigForm.value.OthersGroup.endDate) : '',
        0,
        "Others",
        this.textConfigForm.value.OthersGroup.ClassifiedBased,
        this.textConfigForm.value.OthersGroup.ticketType == 'Select' ? '' : this.textConfigForm.value.OthersGroup.ticketType,
        this.textConfigForm.value.OthersGroup.mappingConfigs
          .map((checked, index) => checked ? this.lstMappingConfig_others.data[index].name : null)
          .filter(value => value !== null).join(),
        null, this.lstMappingConfig_others.ActualFilterName, this.lstIgnoreKeys_others?.join(), "", this.envVar.EnableLanguage ? this.selectedLanguage_Other.join('|') : 'English');

      // end Capturing Form data

      const e2EUID = this.SessionService.getE2EUId();
      const cMSUID = this.SessionService.getCMSUId();
      //const wSUID = this.SessionService.getWSUId();
      const DeliveryConstructUId = this.SessionService.getDeliveryConstructUId();
      if ((this.envVar.Env == "FDS_ManualUpload" && this.SessionService.getSessionStorageItem('userType') == "1") || this.envVar.Env == "SAAS_PAM") {
        UserType = '1';
      }
      else if (this.envVar.Env == "SAAS_ManuaUpload" || (this.envVar.Env == "FDS_ManualUpload" && this.SessionService.getSessionStorageItem('userType') == "3") || this.envVar.Env == "SAAS_FDS") {
        UserType = '3';
      }
      this.spinner.show();
      this.iomService.CreateDeepdive<any>("2", UserType, domainOption, this.aoAnalytics, this.ioAnalytics, this.othersAnalytics, this.BAUploadedData, this.MasterDummyDataUpload.DisplayResolutionDesc, this.MasterDummyDataUpload.MandatoryColumns, this.MasterDummyDataUpload.ExcelMappingFields, 0, this.SessionService.getUserName(), this.topKeyWord_AO, this.topKeyWord_IO, this.topKeyWord_Others, this.MasterDummyDataUpload.ActualColumns, this.MasterDummyDataUpload.fileName, this.MasterDummyDataUpload.SheetName, e2EUID, cMSUID, DeliveryConstructUId, this.envVar.Env).subscribe(data => {
        if (data) {
          this.spinner.hide();
          if (data.Result.indexOf('success') > -1) {
            $("#btnAdvanceClose").click();
            bootbox.alert(data.Result, function () {
              that.SessionService.removeSessionValue('CreateDDInput');
              that.BAUploadedData = null;
              if (UserType != '4') {
                that.router.navigate(['deepdive']);
              }
              else {
                that.router.navigate(['deepdive'], { queryParams: { SolutionId: that.SessionService.getSolutionId() } });
              }
            });
          }
          else {
            bootbox.alert(data.Result);
          }
        }
      },
        (err: HttpErrorResponse) => {
          this.spinner.hide();
          //console.log('Error Occured !');
          bootbox.alert('deepdive creation failed');
        });
    }
    else {
      this.spinner.hide();
    }
  }
  ValidateForm() {
    let domain = this.textConfigForm.getRawValue().domainOption
      .map((checked, index) => checked ? this.lstDomainOption[index].name : null)
      .filter(value => value !== null).join();

    if (domain.includes('AO')) {
      this.loadValues('ao');
      let AO_config = this.textConfigForm.value.AOGroup.mappingConfigs.map((checked, index) => checked ? this.lstMappingConfig_ao.data[index].name : null)
        .filter(value => value !== null).join();
      if (AO_config == '' || AO_config == undefined) {
        bootbox.alert('Please select ' + this.lstMappingConfig_ao.FilterName + ' Apps.');
        return false;
      }
      if (this.textConfigForm.value.AOGroup.deepdiveConfig == '' || this.textConfigForm.value.AOGroup.deepdiveConfig == undefined) {
        bootbox.alert('Please enter Deep dive Configuration Apps.');
        return false;
      }
      if (this.textConfigForm.value.AOGroup.deepdiveConfig.length > 50) {
        bootbox.alert('Deep dive name (Apps) size should not be greater than 50 characters!');
        return false;
      }
      if ((/^[a-zA-Z0-9_ -]*$/.test(this.textConfigForm.value.AOGroup.deepdiveConfig)) == false) {
        bootbox.alert('Deep dive name (Apps) have some invalid characters!');
        return false;
      }
      else if (this.textConfigForm.value.AOGroup.deepdiveConfig.match(/^[0-9\s_ -]*$/)) {
        bootbox.alert('Deep dive name (Apps) should be alphanumeric!');
        return false;
      }
      if (this.textConfigForm.value.AOGroup.algorithmModel == 2 && this.textConfigForm.value.AOGroup.noOfCluster === "") {
        bootbox.alert("Please provide No of clusters (Apps)");
        return false;
      }
      if (this.textConfigForm.value.AOGroup.algorithmModel == 2 && this.textConfigForm.value.AOGroup.exitCriteria === "") {
        bootbox.alert("Please provide Allowed maximum % of unclassified tickets (Apps)");
        return false;
      }
      if (this.textConfigForm.value.AOGroup.algorithmModel == 2 && (/^[0-9]*$/.test(this.textConfigForm.value.AOGroup.noOfCluster.toString())) == false) {
        bootbox.alert("No of Cluster (Apps) must be a numeric!");
        return false;
      }
      if (this.textConfigForm.value.AOGroup.algorithmModel == 2 && this.textConfigForm.value.AOGroup.noOfCluster > 99) {
        bootbox.alert('No of Cluster (Apps) should not be greater than 99!');
        return false;
      }
      if (this.textConfigForm.value.AOGroup.algorithmModel == 2 && this.textConfigForm.value.AOGroup.noOfCluster <= 0) {
        bootbox.alert('No of Cluster (Apps) should be greater than 0!');
        return false;
      }
      if (this.textConfigForm.value.AOGroup.algorithmModel == 2 && (/^[0-9]*$/.test(this.textConfigForm.value.AOGroup.exitCriteria.toString())) == false) {
        // bootbox.alert("Exit Criteria (Apps) must be a numeric!");
        bootbox.alert("Allowed maximum % of unclassified tickets (Apps) must be a numeric!");
        return false;
      }
      if (this.textConfigForm.value.AOGroup.algorithmModel == 2 && this.textConfigForm.value.AOGroup.exitCriteria <= 0) {
        // bootbox.alert("Exit Criteria (Apps) should be greater than 0!");
        bootbox.alert("Allowed maximum % of unclassified tickets (Apps) should be greater than 0!");
        return false;
      }
      if (this.textConfigForm.value.AOGroup.algorithmModel == 2 && this.textConfigForm.value.AOGroup.exitCriteria > 100) {
        //bootbox.alert("Exit Criteria (Apps) should not be greater than 999999!");
        bootbox.alert("Allowed maximum % of unclassified tickets (Apps) should not be greater than 100!");
        return false;
      }
      if (this.textConfigForm.value.AOGroup.ticketType == 'Select' || this.textConfigForm.value.AOGroup.ticketType == undefined) {
        bootbox.alert('Please select TicketType for Apps.');
        return false;
      }
      if (this.selectedLanguage_AO.length == 0 || this.selectedLanguage_AO == undefined) {
        if (this.envVar.EnableLanguage == true) {
          bootbox.alert('Please select Ticket Language for Apps.');
          return false;
        }
      }
      if (this.textConfigForm.value.AOGroup.ClassifiedBased == 'Select' || this.textConfigForm.value.AOGroup.ClassifiedBased == '' || this.textConfigForm.value.AOGroup.ClassifiedBased == undefined) {
        bootbox.alert('Please select Classified Based on for Apps.');
        return false;
      }
      if (this.isQualifiedDescEnabled_AO != null && !this.isQualifiedDescEnabled_AO) {
        bootbox.alert('Selected value is not qualified for the categorized description for Apps.');
        return false;
      }
      if (this.textConfigForm.value.AOGroup.startDate == '' || this.textConfigForm.value.AOGroup.startDate == undefined) {
        bootbox.alert('Please select start date for Apps.');
        return false;
      }
      if (this.textConfigForm.value.AOGroup.endDate == '' || this.textConfigForm.value.AOGroup.endDate == undefined) {
        bootbox.alert('Please select end date for Apps.');
        return false;
      }
      if (this.textConfigForm.value.AOGroup.startDate != '' && this.textConfigForm.value.AOGroup.endDate != '') {
        let fd = this.textConfigForm.value.AOGroup.startDate;
        let ed = this.textConfigForm.value.AOGroup.endDate;
        const fdate = new Date(fd.year, fd.month - 1, fd.day);
        const edate = new Date(ed.year, ed.month - 1, ed.day);
        if (fdate > edate) {
          bootbox.alert('End Date should be greater than or equal to Start Date For Apps.');
          return false;
        }
      }
    }
    if (domain.includes('IO')) {
      this.loadValues('io');
      let IO_config = this.textConfigForm.value.IOGroup.mappingConfigs.map((checked, index) => checked ? this.lstMappingConfig_io.data[index].name : null)
        .filter(value => value !== null).join();
      if (IO_config == '' || IO_config == undefined) {
        bootbox.alert('Please select ' + this.lstMappingConfig_io.FilterName + ' Infra.');
        return false;
      }
      if (this.textConfigForm.value.IOGroup.deepdiveConfig == '' || this.textConfigForm.value.IOGroup.deepdiveConfig == undefined) {
        bootbox.alert('Please enter Deepdive Configuration Infra.');
        return false;
      }
      if (this.textConfigForm.value.IOGroup.deepdiveConfig.length > 50) {
        bootbox.alert('Deep dive name (Infra) size should not be greater than 50 characters!');
        return false;
      }
      if ((/^[a-zA-Z0-9_ -]*$/.test(this.textConfigForm.value.IOGroup.deepdiveConfig)) == false) {
        bootbox.alert('Deep dive name (Infra) have some invalid characters!');
        return false;
      }
      else if (this.textConfigForm.value.IOGroup.deepdiveConfig.match(/^[0-9\s_ -]*$/)) {
        bootbox.alert('Deep dive name (Infra) should be alphanumeric!');
        return false;
      }
      if (this.textConfigForm.value.IOGroup.algorithmModel == 2 && this.textConfigForm.value.IOGroup.noOfCluster === "") {
        bootbox.alert("Please provide No of Clusters (Infra)");
        return false;
      }
      if (this.textConfigForm.value.IOGroup.algorithmModel == 2 && this.textConfigForm.value.IOGroup.exitCriteria === "") {
        bootbox.alert("Please provide Allowed maximum % of unclassified tickets (Infra)");
        return false;
      }
      if (this.textConfigForm.value.IOGroup.algorithmModel == 2 && (/^[0-9]*$/.test(this.textConfigForm.value.IOGroup.noOfCluster.toString())) == false) {
        bootbox.alert("No of Cluster (Infra) must be a numeric!");
        return false;
      }
      if (this.textConfigForm.value.IOGroup.algorithmModel == 2 && this.textConfigForm.value.IOGroup.noOfCluster > 99) {
        bootbox.alert('No of Cluster (Infra) should not be greater than 99!');
        return false;
      }
      if (this.textConfigForm.value.IOGroup.algorithmModel == 2 && (/^[0-9]*$/.test(this.textConfigForm.value.IOGroup.exitCriteria.toString())) == false) {
        // bootbox.alert("Exit Criteria (Infra) must be a numeric!");
        bootbox.alert("Allowed maximum % of unclassified tickets (Infra) must be a numeric!");
        return false;
      }
      if (this.textConfigForm.value.IOGroup.algorithmModel == 2 && this.textConfigForm.value.IOGroup.exitCriteria <= 0) {
        // bootbox.alert("Exit Criteria (Infra) should be greater than 0!");
        bootbox.alert("Allowed maximum % of unclassified tickets (Infra) should be greater than 0!");
        return false;
      }
      if (this.textConfigForm.value.IOGroup.algorithmModel == 2 && this.textConfigForm.value.IOGroup.exitCriteria > 100) {
        //bootbox.alert("Exit Criteria (Infra) should not be greater than 999999!");
        bootbox.alert("Allowed maximum % of unclassified tickets (Infra) should not be greater than 100!");
        return false;
      }
      if (this.textConfigForm.value.IOGroup.algorithmModel == 2 && this.textConfigForm.value.IOGroup.noOfCluster <= 0) {
        bootbox.alert('No of Cluster (Infra) should be greater than 0!');
        return false;
      }
      if (this.textConfigForm.value.IOGroup.ticketType == 'Select' || this.textConfigForm.value.IOGroup.ticketType == undefined) {
        bootbox.alert('Please select TicketType for Infra.');
        return false;
      }
      if (this.selectedLanguage_IO.length == 0 || this.selectedLanguage_IO == undefined) {
        if (this.envVar.EnableLanguage == true) {
          bootbox.alert('Please select Ticket Language for Infra.');
          return false;
        }
      }
      if (this.textConfigForm.value.IOGroup.ClassifiedBased == 'Select' || this.textConfigForm.value.IOGroup.ClassifiedBased == '' || this.textConfigForm.value.IOGroup.ClassifiedBased == undefined) {
        bootbox.alert('Please select Classified Based on for Infra.');
        return false;
      }
      if (this.isQualifiedDescEnabled_IO != null && !this.isQualifiedDescEnabled_IO) {
        bootbox.alert('Selected value is not qualified for the categorized description for Infra.');
        return false;
      }
      if (this.textConfigForm.value.IOGroup.startDate == '' || this.textConfigForm.value.IOGroup.startDate == undefined) {
        bootbox.alert('Please select start date for Infra.');
        return false;
      }
      if (this.textConfigForm.value.IOGroup.endDate == '' || this.textConfigForm.value.IOGroup.endDate == undefined) {
        bootbox.alert('Please select end date for Infra.');
        return false;
      }
      if (this.textConfigForm.value.IOGroup.startDate != '' && this.textConfigForm.value.IOGroup.endDate != '') {
        let fd = this.textConfigForm.value.IOGroup.startDate;
        let ed = this.textConfigForm.value.IOGroup.endDate;
        const fdate = new Date(fd.year, fd.month - 1, fd.day);
        const edate = new Date(ed.year, ed.month - 1, ed.day);
        if (fdate > edate) {
          bootbox.alert('End Date should be greater than or equal to Start Date For Infra.');
          return false;
        }
      }
    }
    if (domain.includes('Others')) {
      this.loadValues('others');
      let Others_config = this.textConfigForm.value.OthersGroup.mappingConfigs.map((checked, index) => checked ? this.lstMappingConfig_others.data[index].name : null)
        .filter(value => value !== null).join();
      if (Others_config == '' || Others_config == undefined) {
        bootbox.alert('Please select ' + this.lstMappingConfig_others.FilterName + ' Others.');
        return false;
      }
      if (this.textConfigForm.value.OthersGroup.deepdiveConfig == '' || this.textConfigForm.value.OthersGroup.deepdiveConfig == undefined) {
        bootbox.alert('Please enter Deepdive Configuration Others.');
        return false;
      }
      if (this.textConfigForm.value.OthersGroup.deepdiveConfig.length > 50) {
        bootbox.alert('Deep dive name (Others) size should not be greater than 50 characters!');
        return false;
      }
      if ((/^[a-zA-Z0-9_ -]*$/.test(this.textConfigForm.value.OthersGroup.deepdiveConfig)) == false) {
        bootbox.alert('Deep dive name (Others) have some invalid characters!');
        return false;
      }
      else if (this.textConfigForm.value.OthersGroup.deepdiveConfig.match(/^[0-9\s_ -]*$/)) {
        bootbox.alert('Deep dive name (Others) should be alphanumeric!');
        return false;
      }
      if (this.textConfigForm.value.OthersGroup.algorithmModel == 2 && this.textConfigForm.value.OthersGroup.noOfCluster === "") {
        bootbox.alert("Please provide No of Clusters (Others)");
        return false;
      }
      if (this.textConfigForm.value.OthersGroup.algorithmModel == 2 && this.textConfigForm.value.OthersGroup.noOfCluster === "") {
        bootbox.alert("Please provide Allowed maximum % of unclassified tickets (Others)");
        return false;
      }
      if (this.textConfigForm.value.OthersGroup.algorithmModel == 2 && (/^[0-9]*$/.test(this.textConfigForm.value.OthersGroup.noOfCluster.toString())) == false) {
        bootbox.alert("No of Cluster (Others) must be a numeric!");
        return false;
      }
      if (this.textConfigForm.value.OthersGroup.algorithmModel == 2 && this.textConfigForm.value.OthersGroup.noOfCluster > 99) {
        bootbox.alert('No of Cluster (Others) should not be greater than 99!');
        return false;
      }
      if (this.textConfigForm.value.OthersGroup.algorithmModel == 2 && (/^[0-9]*$/.test(this.textConfigForm.value.OthersGroup.exitCriteria.toString())) == false) {
        //bootbox.alert("Exit Criteria (Others) must be a numeric!");
        bootbox.alert("Allowed maximum % of unclassified tickets (Others) must be a numeric!");
        return false;
      }
      if (this.textConfigForm.value.OthersGroup.algorithmModel == 2 && this.textConfigForm.value.OthersGroup.exitCriteria <= 0) {
        //bootbox.alert("Exit Criteria (Others) should be greater than 0!");
        bootbox.alert("Allowed maximum % of unclassified tickets (Others) should be greater than 0!");
        return false;
      }
      if (this.textConfigForm.value.OthersGroup.algorithmModel == 2 && this.textConfigForm.value.OthersGroup.exitCriteria > 100) {
        // bootbox.alert("Exit Criteria (Others) should not be greater than 999999!");
        bootbox.alert("Allowed maximum % of unclassified tickets (Others) should not be greater than 100!");
        return false;
      }
      if (this.textConfigForm.value.OthersGroup.algorithmModel == 2 && this.textConfigForm.value.OthersGroup.noOfCluster <= 0) {
        bootbox.alert('No of Cluster (Others) should be greater than 0!');
        return false;
      }
      if (this.textConfigForm.value.OthersGroup.ticketType == 'Select' || this.textConfigForm.value.OthersGroup.ticketType == undefined) {
        bootbox.alert('Please select TicketType for Others.');
        return false;
      }
      if (this.selectedLanguage_Other.length == 0 || this.selectedLanguage_Other == undefined) {
        if (this.envVar.EnableLanguage == true) {
          bootbox.alert('Please select Ticket Language for Others.');
          return false;
        }
      }
      if (this.textConfigForm.value.OthersGroup.ClassifiedBased == 'Select' || this.textConfigForm.value.OthersGroup.ClassifiedBased == '' || this.textConfigForm.value.OthersGroup.ClassifiedBased == undefined) {
        bootbox.alert('Please select Classified Based on for Others.');
        return false;
      }
      if (this.isQualifiedDescEnabled_Others != null && !this.isQualifiedDescEnabled_Others) {
        bootbox.alert('Selected value is not qualified for the categorized description for Others.');
        return false;
      }
      if (this.textConfigForm.value.OthersGroup.startDate == '' || this.textConfigForm.value.OthersGroup.startDate == undefined) {
        bootbox.alert('Please select start date for Others.');
        return false;
      }
      if (this.textConfigForm.value.OthersGroup.endDate == '' || this.textConfigForm.value.OthersGroup.endDate == undefined) {
        bootbox.alert('Please select end date for Others.');
        return false;
      }
      if (this.textConfigForm.value.OthersGroup.startDate != '' && this.textConfigForm.value.OthersGroup.endDate != '') {
        let fd = this.textConfigForm.value.OthersGroup.startDate;
        let ed = this.textConfigForm.value.OthersGroup.endDate;
        const fdate = new Date(fd.year, fd.month - 1, fd.day);
        const edate = new Date(ed.year, ed.month - 1, ed.day);
        if (fdate > edate) {
          bootbox.alert('End Date should be greater than or equal to Start Date For Others.');
          return false;
        }
      }

    }
    return true;
  }
  DQTCheckStd(value: boolean) {
    this.EnableDQTStd = value;
  }
  DQTCheckAdv(value: boolean, DQTdomain) {
    if (DQTdomain == 'AO') {
      this.EnableDQTAO = value;
    }
    else if (DQTdomain == 'IO') {
      this.EnableDQTIO = value;
    }
    else if (DQTdomain == 'Oth') {
      this.EnableDQTOth = value;
    }
  }
  LemmaCheckStd(value: boolean) {
    this.EnableLemmaStd = value;
  }
  RestrictDDCheck(value: boolean) {
    this.enableRestrictdd = value;
  }
  LemmaCheckAdv(value: boolean, Lemmadomain) {
    if (Lemmadomain == 'AO') {
      this.EnableLemmaAO = value;
      this.GetLanguageCheck_AO_Lemma('AO');
    }
    else if (Lemmadomain == 'IO') {
      this.EnableLemmaIO = value;
      this.check_language = this.envVar.EnableLanguage ? this.selectedLanguage_IO.join('|') : 'English';
      this.getStopwords('IO', this.skrequest, this.userType, this.proposalId, this.ticketType, this.check_language, this.EnableLemmaIO, false);
    }
    else if (Lemmadomain == 'Oth') {
      this.EnableLemmaOth = value;
      this.GetLanguageCheck_Others_Lemma('Others');
    }
  }
  SelectDoamin() {
    this.resetDomain();
    const selectedDomain = this.textConfigForm.getRawValue().domainOption
      .map((checked, index) => checked ? this.lstDomainOption[index].name : null)
      .filter(value => value !== null);
    if (selectedDomain.includes('AO') || selectedDomain.includes('IO') || selectedDomain.includes('Others')) {
      if (selectedDomain.includes('AO')) {
        this.enableAo = true;
        this.isLoadAoPill = true;
      }
      else {
        this.enableAo = false;
        this.isLoadIoPill = false;
        this.isLoadOtherPill = false;
      }
      if (selectedDomain.includes('IO')) {
        this.enableIo = true;
        if (this.isLoadAoPill == false && this.isLoadOtherPill == false) {
          this.isLoadIoPill = true;
          //this.isAddkeywordsEnabled_IO = false;
        }
      }
      else {
        this.enableIo = false;
        this.isAddkeywordsEnabled_IO = true;
      }

      if (selectedDomain.includes('Others')) {
        this.enableOthers = true;
        if (this.isLoadAoPill == false && this.isLoadIoPill == false) {
          this.isLoadOtherPill = true;
        }
      }
      else {
        this.enableOthers = false;
      }
    }
    else {
      bootbox.alert("Please select atleast one domain to create Deepdives");
    }
  }

  addIgnoreKeyword(section) {
    if (section == "ao") {
      this.textConfigForm.value.AOGroup.ignorekeyword = this.textConfigForm.value.AOGroup.ignorekeyword.trim();
      if (this.IsEmpty(this.textConfigForm.value.AOGroup.ignorekeyword)) {
        bootbox.alert("keyword should not be empty");
      }
      else if (this.selectedStdLanguageAO == null || this.selectedStdLanguageAO == undefined || this.selectedStdLanguageAO == 'Select') {
        bootbox.alert("Please select language to add keyword");
      }
      // else if (/[0-9]/.test(this.textConfigForm.value.AOGroup.ignorekeyword)) {
      //   bootbox.alert("Keyword must have alphabets only")
      // }
      //else if ((/^[a-zA-Z]*$/.test(this.textConfigForm.value.AOGroup.ignorekeyword) == false) && (this.textConfigForm.value.AOGroup.Language =="English")) {
      //  bootbox.alert("Keyword must be a single word and should contain alphabets only")
      //}
      // else if (/[@!#$%^&*()\-+={}\[\]|\\/'";:`.,~№?<>]+/i.test(this.textConfigForm.value.AOGroup.ignorekeyword) == true || this.textConfigForm.value.AOGroup.ignorekeyword.indexOf(' ') >= 0) {
      //   bootbox.alert("Keyword must be a single word and should contain alphabets only")
      // }
      else if ((/^[a-zA-Z0-9-/_&\s]*$/.test(this.textConfigForm.value.AOGroup.ignorekeyword)) == false && (this.envVar.EnableLanguage ? this.selectedLanguage_AO.join('|') : 'English') == 'English') { //((/[0-9]/.test(catName)) == true || 
        bootbox.alert("Keyword must be a single word and should contain alphabets only");
        return false;
      }
      else if (/[@!#$%^&*()\-+={}\[\]|\\/'";:`.,~№?<>]+/i.test(this.textConfigForm.value.AOGroup.ignorekeyword) == true || this.textConfigForm.value.AOGroup.ignorekeyword.indexOf(' ') >= 0) {
        bootbox.alert("Keyword must be a single word and should contain alphabets only")
      }
      else if (this.indexOf(this.lstIgnoreKeys, this.textConfigForm.value.AOGroup.ignorekeyword.trim() + '(' + this.selectedStdLanguageAO + ')') >= 0) {
        bootbox.alert("\"" + this.textConfigForm.value.AOGroup.ignorekeyword + "\" KeyWord(s) already exists");
      }
      else {
        if (this.EnableLemmaAO) {
          if (this.selectedLanguage_AO.length == 0 || this.selectedLanguage_AO == undefined) {
            if (this.envVar.EnableLanguage == true) {
              bootbox.alert('Please select Ticket Language for Apps.');
              return false;
            }
          }
          else {
            let that = this;
            bootbox.dialog({
              message: 'The entered text will be added in the lemmatized form',
              buttons: {
                sucess: {
                  label: 'Yes',
                  className: 'btn-primary',
                  callback: function () {
                    that.spinner.show();
                    var Language = that.envVar.EnableLanguage ? that.selectedStdLanguageAO : 'English';
                    that.iomService.GetLemmaKeywords('', '', '', that.textConfigForm.value.AOGroup.ignorekeyword, Language).subscribe((data: any) => {
                      that.spinner.hide();

                      if (data.response.Result == "Success") {
                        var LemmaString = data.response.LemmaResponse.StopKeyWords_Lemma;
                        if (that.indexOf(that.lstIgnoreKeys, LemmaString) >= 0) {
                          bootbox.alert("\"" + LemmaString + "\" KeyWord(s) already exists");
                        }
                        else {
                          that.lstIgnoreKeys = [
                            ...that.lstIgnoreKeys,
                            LemmaString + '(' + that.selectedStdLanguageAO + ')'
                          ];
                          that.pushLanguageWiseKeyword(LemmaString, 'ao');
                        }
                        that.enableBox_AO = true;
                        that.textConfigForm.controls.AOGroup.patchValue({ ignorekeyword: '' });
                      }
                      else {
                        that.textConfigForm.controls.AOGroup.patchValue({ ignorekeyword: '' });
                        bootbox.alert("Timeout. Please Refresh and Try again");
                      }
                    },
                      (err: HttpErrorResponse) => {
                        that.spinner.hide();
                        bootbox.alert("Timeout. Please Refresh and Try again");
                      });
                  }
                },
                cancel: {
                  label: 'No',
                  className: 'btn-secondary',
                  callback: function () {
                    that.lstIgnoreKeys = [
                      ...that.lstIgnoreKeys,
                      that.textConfigForm.value.AOGroup.ignorekeyword
                    ];
                    that.lstIgnoreKeysTemp = [
                      ...that.lstIgnoreKeysTemp,
                      that.textConfigForm.value.AOGroup.ignorekeyword
                    ];
                    that.enableBox_AO = true;
                    that.textConfigForm.controls.AOGroup.patchValue({ ignorekeyword: '' });
                  }
                }
              },
              onEscape: function () {
                //on escape
              }
            });
          }
        }
        else {
          this.lstIgnoreKeys = [
            ...this.lstIgnoreKeys,
            this.textConfigForm.value.AOGroup.ignorekeyword + '(' + this.selectedStdLanguageAO + ')'
          ];
          this.lstIgnoreKeysTemp = [
            ...this.lstIgnoreKeysTemp,
            this.textConfigForm.value.AOGroup.ignorekeyword + '(' + this.selectedStdLanguageAO + ')'
          ];
          this.pushLanguageWiseKeyword(this.textConfigForm.value.AOGroup.ignorekeyword, 'ao');
          this.enableBox_AO = true;
          this.textConfigForm.controls.AOGroup.patchValue({ ignorekeyword: '' });
        }
      }
    }
    else if (section == "io") {
      this.textConfigForm.value.IOGroup.ignorekeyword = this.textConfigForm.value.IOGroup.ignorekeyword.trim();
      if (this.IsEmpty(this.textConfigForm.value.IOGroup.ignorekeyword)) {
        bootbox.alert("keyword should not be empty");
      }
      else if (this.selectedStdLanguageIO == null || this.selectedStdLanguageIO == undefined || this.selectedStdLanguageIO == 'Select') {
        bootbox.alert("Please select language to add keyword");
      }
      // else if (/[0-9]/.test(this.textConfigForm.value.IOGroup.ignorekeyword)) {
      //   bootbox.alert("Keyword must have alphabets only")
      // }
      //else if ((/^[a-zA-Z]*$/.test(this.textConfigForm.value.IOGroup.ignorekeyword) == false)&& (this.textConfigForm.value.IOGroup.Language =="English")) {
      //  bootbox.alert("Keyword must be a single word and should contain alphabets only")
      //}
      // else if (/[@!#$%^&*()\-+={}\[\]|\\/'";:`.,~№?<>]+/i.test(this.textConfigForm.value.IOGroup.ignorekeyword) == true || this.textConfigForm.value.IOGroup.ignorekeyword.indexOf(' ') >= 0) {
      //   bootbox.alert("Keyword must be a single word and should contain alphabets only")
      // }
      else if ((/^[a-zA-Z0-9-/_&\s]*$/.test(this.textConfigForm.value.IOGroup.ignorekeyword)) == false && (this.envVar.EnableLanguage ? this.selectedLanguage_IO.join('|') : 'English') == 'English') { //((/[0-9]/.test(catName)) == true || 
        bootbox.alert("Keyword must be a single word and should contain alphabets only");
        return false;
      }
      else if (/[@!#$%^&*()\-+={}\[\]|\\/'";:`.,~№?<>]+/i.test(this.textConfigForm.value.IOGroup.ignorekeyword) == true || this.textConfigForm.value.IOGroup.ignorekeyword.indexOf(' ') >= 0) {
        bootbox.alert("Keyword must be a single word and should contain alphabets only")
      }
      else if (this.indexOf(this.lstIgnoreKeys_io, this.textConfigForm.value.IOGroup.ignorekeyword.trim()) >= 0) {
        bootbox.alert("\"" + this.textConfigForm.value.IOGroup.ignorekeyword + "\" KeyWord(s) already exists");
      }
      else {
        if (this.EnableLemmaIO) {
          if (this.selectedLanguage_IO.length == 0 || this.selectedLanguage_IO == undefined) {
            if (this.envVar.EnableLanguage == true) {
              bootbox.alert('Please select Ticket Language for Infra.');
              return false;
            }
          }
          else {
            let that = this;
            bootbox.dialog({
              message: 'The entered text will be added in the lemmatized form',
              buttons: {
                sucess: {
                  label: 'Yes',
                  className: 'btn-primary',
                  callback: function () {
                    that.spinner.show();
                    var Language = that.envVar.EnableLanguage ? that.selectedStdLanguageIO : 'English';
                    that.iomService.GetLemmaKeywords('', '', '', that.textConfigForm.value.IOGroup.ignorekeyword, Language).subscribe((data: any) => {
                      that.spinner.hide();

                      if (data.response.Result == "Success") {
                        var LemmaString = data.response.LemmaResponse.StopKeyWords_Lemma;
                        if (that.indexOf(that.lstIgnoreKeys, LemmaString) >= 0) {
                          bootbox.alert("\"" + LemmaString + "\" KeyWord(s) already exists");
                        }
                        else {
                          that.lstIgnoreKeys_io = [
                            ...that.lstIgnoreKeys_io,
                            LemmaString + '(' + that.selectedStdLanguageIO + ')'
                          ];
                          that.lstIgnoreKeys_ioTemp = [
                            ...that.lstIgnoreKeys_ioTemp,
                            LemmaString + '(' + that.selectedStdLanguageIO + ')'
                          ];
                          this.pushLanguageWiseKeyword(LemmaString, 'io');
                        }
                        that.enableBox_IO = true;
                        that.textConfigForm.controls.IOGroup.patchValue({ ignorekeyword: '' });
                      }
                      else {
                        that.textConfigForm.controls.IOGroup.patchValue({ ignorekeyword: '' });
                        bootbox.alert("Timeout. Please Refresh and Try again");
                      }
                    },
                      (err: HttpErrorResponse) => {
                        that.spinner.hide();
                        bootbox.alert("Timeout. Please Refresh and Try again");
                      });
                  }
                },
                cancel: {
                  label: 'No',
                  className: 'btn-secondary',
                  callback: function () {
                    that.lstIgnoreKeys_io = [
                      ...that.lstIgnoreKeys_io,
                      that.textConfigForm.value.IOGroup.ignorekeyword
                    ];
                    that.lstIgnoreKeys_ioTemp = [
                      ...that.lstIgnoreKeys_ioTemp,
                      that.textConfigForm.value.IOGroup.ignorekeyword
                    ];
                    that.enableBox_IO = true;
                    that.textConfigForm.controls.IOGroup.patchValue({ ignorekeyword: '' });
                  }
                }
              },

            });
          }
        }
        else {
          this.lstIgnoreKeys_io = [
            ...this.lstIgnoreKeys_io,
            this.textConfigForm.value.IOGroup.ignorekeyword + '(' + this.selectedStdLanguageIO + ')'
          ];
          this.lstIgnoreKeys_ioTemp = [
            ...this.lstIgnoreKeys_ioTemp,
            this.textConfigForm.value.IOGroup.ignorekeyword + '(' + this.selectedStdLanguageIO + ')'
          ];
          this.pushLanguageWiseKeyword(this.textConfigForm.value.IOGroup.ignorekeyword, 'io');
          this.enableBox_IO = true;
          this.textConfigForm.controls.IOGroup.patchValue({ ignorekeyword: '' });
        }
      }
    }
    else {
      this.textConfigForm.value.OthersGroup.ignorekeyword = this.textConfigForm.value.OthersGroup.ignorekeyword.trim();
      if (this.IsEmpty(this.textConfigForm.value.OthersGroup.ignorekeyword)) {
        bootbox.alert("keyword should not be empty");
      }
      else if (this.selectedStdLanguageOthers == null || this.selectedStdLanguageOthers == undefined || this.selectedStdLanguageOthers == 'Select') {
        bootbox.alert("Please select language to add keyword");
      }
      // else if (/[0-9]/.test(this.textConfigForm.value.OthersGroup.ignorekeyword)) {
      //   bootbox.alert("Keyword must have alphabets only")
      // }
      //else if ((/^[a-zA-Z]*$/.test(this.textConfigForm.value.OthersGroup.ignorekeyword) == false)&&(this.textConfigForm.value.OthersGroup.Language=="English")) {
      //  bootbox.alert("Keyword must be a single word and should contain alphabets only")
      //}
      // else if (/[@!#$%^&*()\-+={}\[\]|\\/'";:`.,~№?<>]+/i.test(this.textConfigForm.value.OthersGroup.ignorekeyword) == true || this.textConfigForm.value.OthersGroup.ignorekeyword.indexOf(' ') >= 0) {
      //   bootbox.alert("Keyword must be a single word and should contain alphabets only")
      // }
      else if ((/^[a-zA-Z0-9-/_&\s]*$/.test(this.textConfigForm.value.OthersGroup.ignorekeyword)) == false && (this.envVar.EnableLanguage ? this.selectedLanguage_Other.join('|') : 'English') == 'English') { //((/[0-9]/.test(catName)) == true || 
        bootbox.alert("Keyword must be a single word and should contain alphabets only");
        return false;
      }
      else if (/[@!#$%^&*()\-+={}\[\]|\\/'";:`.,~№?<>]+/i.test(this.textConfigForm.value.OthersGroup.ignorekeyword) == true || this.textConfigForm.value.OthersGroup.ignorekeyword.indexOf(' ') >= 0) {
        bootbox.alert("Keyword must be a single word and should contain alphabets only")
      }
      else if (this.indexOf(this.lstIgnoreKeys_others, this.textConfigForm.value.OthersGroup.ignorekeyword.trim()) >= 0) {
        bootbox.alert("\"" + this.textConfigForm.value.OthersGroup.ignorekeyword + "\" KeyWord(s) already exists");
      }
      else {
        if (this.EnableLemmaOth) {
          if (this.selectedLanguage_Other.length == 0 || this.selectedLanguage_Other == undefined) {
            if (this.envVar.EnableLanguage == true) {
              bootbox.alert('Please select Ticket Language for Others.');
              return false;
            }
          }
          else {
            let that = this;
            bootbox.dialog({
              message: 'The entered text will be added in the lemmatized form',
              buttons: {
                sucess: {
                  label: 'Yes',
                  className: 'btn-primary',
                  callback: function () {
                    that.spinner.show();
                    var Language = that.envVar.EnableLanguage ? that.selectedStdLanguageOthers : 'English';
                    that.iomService.GetLemmaKeywords('', '', '', that.textConfigForm.value.OthersGroup.ignorekeyword, Language).subscribe((data: any) => {
                      that.spinner.hide();

                      if (data.response.Result == "Success") {
                        var LemmaString = data.response.LemmaResponse.StopKeyWords_Lemma;
                        if (that.indexOf(that.lstIgnoreKeys, LemmaString) >= 0) {
                          bootbox.alert("\"" + LemmaString + "\" KeyWord(s) already exists");
                        }
                        else {
                          that.lstIgnoreKeys_others = [
                            ...that.lstIgnoreKeys_others,
                            LemmaString + '(' + that.selectedStdLanguageOthers + ')'
                          ];
                          that.lstIgnoreKeys_othersTemp = [
                            ...that.lstIgnoreKeys_othersTemp,
                            LemmaString + '(' + that.selectedStdLanguageOthers + ')'
                          ];
                          this.pushLanguageWiseKeyword(LemmaString, 'others');
                        }
                        that.enableBox_Others = true;
                        that.textConfigForm.controls.OthersGroup.patchValue({ ignorekeyword: '' });
                      }
                      else {
                        that.textConfigForm.controls.OthersGroup.patchValue({ ignorekeyword: '' });
                        bootbox.alert("Timeout. Please Refresh and Try again");
                      }
                    },
                      (err: HttpErrorResponse) => {
                        that.spinner.hide();
                        bootbox.alert("Timeout. Please Refresh and Try again");
                      });
                  }
                },
                cancel: {
                  label: 'No',
                  className: 'btn-secondary',
                  callback: function () {
                    that.lstIgnoreKeys_others = [
                      ...that.lstIgnoreKeys_others,
                      that.textConfigForm.value.OthersGroup.ignorekeyword
                    ];
                    that.lstIgnoreKeys_othersTemp = [
                      ...that.lstIgnoreKeys_othersTemp,
                      that.textConfigForm.value.OthersGroup.ignorekeyword
                    ];
                    that.enableBox_Others = true;
                    that.textConfigForm.controls.OthersGroup.patchValue({ ignorekeyword: '' });
                  }
                }
              },

            });
          }
        }
        else {
          this.lstIgnoreKeys_others = [
            ...this.lstIgnoreKeys_others,
            this.textConfigForm.value.OthersGroup.ignorekeyword + '(' + this.selectedStdLanguageOthers + ')'
          ];
          this.lstIgnoreKeys_othersTemp = [
            ...this.lstIgnoreKeys_othersTemp,
            this.textConfigForm.value.OthersGroup.ignorekeyword + '(' + this.selectedStdLanguageOthers + ')'
          ];
          this.pushLanguageWiseKeyword(this.textConfigForm.value.OthersGroup.ignorekeyword, 'others');
          this.enableBox_Others = true;
          this.textConfigForm.controls.OthersGroup.patchValue({ ignorekeyword: '' });
        }
      }
      // this.textConfigForm.value.OthersGroup.ignorekeyword.setValue('');
    }
  }
  RemoveKeyword(word, section) {
    if (section == 'ao') {
      this.pullLanguageWiseKeyword(word, 'ao');
      this.lstIgnoreKeys = this.lstIgnoreKeys.filter(e => e !== word);
      this.lstIgnoreKeysTemp = this.lstIgnoreKeys;
      if (this.lstIgnoreKeys.length <= 0)
        this.enableBox_AO = false;
    }
    else if (section == 'io') {
      this.pullLanguageWiseKeyword(word, 'io');
      this.lstIgnoreKeys_io = this.lstIgnoreKeys_io.filter(e => e !== word);
      this.lstIgnoreKeys_ioTemp = this.lstIgnoreKeys_io;
      if (this.lstIgnoreKeys_io.length <= 0)
        this.enableBox_IO = false;
    }
    else {
      this.pullLanguageWiseKeyword(word, 'others');
      this.lstIgnoreKeys_others = this.lstIgnoreKeys_others.filter(e => e !== word);
      this.lstIgnoreKeys_othersTemp = this.lstIgnoreKeys_others;
      if (this.lstIgnoreKeys_others.length <= 0)
        this.enableBox_Others = false;
    }
  }
  selectAllConfig(tab: string) {
    this.ShowPopup = false;
    let all;
    switch (tab) {
      case 'ao':
        $(".newao .dropdown-menu ").addClass('show');
        $(".newao .iom-dropdown-toggle").addClass('show');
        all = this.textConfigForm.value.AOGroup.selectAllConfig;
        if (all) {
          this.selectedAllAoId.nativeElement.checked = true;
          (this.textConfigForm.get('AOGroup').get('mappingConfigs') as FormArray).controls.map(
            control => control.setValue(true));
          if (this.lstFilterMappingConfig_ao != null && this.lstFilterMappingConfig_ao != undefined) {
            this.lstFilterMappingConfig_ao.forEach((x, i) => {
              this.textConfigForm.value.AOGroup.mappingConfigs[x.indexNo] = true;
              $('#aoSearch_' + x.indexNo).prop('checked', true);
              x.isChecked = true;
            });
          }
        }
        else {
          this.selectedAllAoId.nativeElement.checked = false;
          (this.textConfigForm.get('AOGroup').get('mappingConfigs') as FormArray).controls.map(
            control => control.setValue(false));
          if (this.lstFilterMappingConfig_ao != null && this.lstFilterMappingConfig_ao != undefined) {
            this.lstFilterMappingConfig_ao.forEach((x, i) => {
              this.textConfigForm.value.AOGroup.mappingConfigs[x.indexNo] = false;
              $('#aoSearch_' + x.indexNo).prop('checked', false);
              x.isChecked = false;
            });
          }
        }
        const sao = this.textConfigForm.value.AOGroup.mappingConfigs.map((checked, index) => checked ? this.lstMappingConfig_ao.data[index].name : null)
          .filter(value => value !== null).join();
        if (sao !== '' && sao !== undefined && this.enableSearchAO == true) {
          this.enableApply = true;
          this.isClearAll = true;
        }
        //this.selectedAoAssignedId.nativeElement.classList.remove('show');
        break;
      case 'io':
        $(".newio .dropdown-menu ").addClass('show');
        $(".newio .iom-dropdown-toggle").addClass('show');
        all = this.textConfigForm.value.IOGroup.selectAllConfig;
        if (all) {
          (this.textConfigForm.get('IOGroup').get('mappingConfigs') as FormArray).controls.map(
            control => control.setValue(true));
          if (this.lstFilterMappingConfig_io != null && this.lstFilterMappingConfig_io != undefined) {
            this.lstFilterMappingConfig_io.forEach((x, i) => {
              this.textConfigForm.value.IOGroup.mappingConfigs[x.indexNo] = true;
              $('#aoSearch_' + x.indexNo).prop('checked', true);
              x.isChecked = true;
            });
          }
        }
        else {
          (this.textConfigForm.get('IOGroup').get('mappingConfigs') as FormArray).controls.map(
            control => control.setValue(false));
          if (this.lstFilterMappingConfig_io != null && this.lstFilterMappingConfig_io != undefined) {
            this.lstFilterMappingConfig_io.forEach((x, i) => {
              this.textConfigForm.value.IOGroup.mappingConfigs[x.indexNo] = false;
              $('#aoSearch_' + x.indexNo).prop('checked', false);
              x.isChecked = false;
            });
          }
        }
        // tslint:disable-next-line: max-line-length
        const sio = this.textConfigForm.value.IOGroup.mappingConfigs.map((checked, index) => checked ? this.lstMappingConfig_io.data[index].name : null)
          .filter(value => value !== null).join();
        if (sio !== '' && sio !== undefined && this.enableSearchIO == true) {
          this.enableApply = true;
          this.isClearAll = true;
        }
        //this.selectedIoAssignedId.nativeElement.classList.remove('show');
        break;
      case 'others':
        $(".newoth .dropdown-menu ").addClass('show');
        $(".newoth .iom-dropdown-toggle").addClass('show');
        all = this.textConfigForm.value.OthersGroup.selectAllConfig;
        if (all) {
          (this.textConfigForm.get('OthersGroup').get('mappingConfigs') as FormArray).controls.map(
            control => control.setValue(true));
          if (this.lstFilterMappingConfig_others != null && this.lstFilterMappingConfig_others != undefined) {
            this.lstFilterMappingConfig_others.forEach((x, i) => {
              this.textConfigForm.value.OthersGroup.mappingConfigs[x.indexNo] = true;
              $('#aoSearch_' + x.indexNo).prop('checked', true);
              x.isChecked = true;
            });
          }
        }
        else {
          (this.textConfigForm.get('OthersGroup').get('mappingConfigs') as FormArray).controls.map(
            control => control.setValue(false));
          if (this.lstFilterMappingConfig_others != null && this.lstFilterMappingConfig_others != undefined) {
            this.lstFilterMappingConfig_others.forEach((x, i) => {
              this.textConfigForm.value.OthersGroup.mappingConfigs[x.indexNo] = false;
              $('#aoSearch_' + x.indexNo).prop('checked', false);
              x.isChecked = false;
            });
          }
        }
        // tslint:disable-next-line: max-line-length
        const sothers = this.textConfigForm.value.OthersGroup.mappingConfigs.map((checked, index) => checked ? this.lstMappingConfig_others.data[index].name : null)
          .filter(value => value !== null).join();
        if (sothers !== '' && sothers !== undefined && this.enableSearchOth == true) {
          this.enableApply = true;
          this.isClearAll = true;
        }
        //this.selectedOthersAssignedId.nativeElement.classList.remove('show');
        break;
      default:
        break;
    }

  }
  selectConfig(tab: string, value: string) {
    let all;
    this.ShowPopup = false;
    switch (tab) {
      case 'ao':
        $(".newao .dropdown-menu ").addClass('show');
        $(".newao .iom-dropdown-toggle").addClass('show');
        if (this.lstFilterMappingConfig_aoSearch != null && this.lstFilterMappingConfig_aoSearch != undefined) {
          this.lstFilterMappingConfig_aoSearch.forEach((x, i) => {
            if (x.name == value) {
              x.isChecked = x.isChecked == true ? false : true;
            }
            if (x.isChecked) {
              this.textConfigForm.value.AOGroup.mappingConfigs[x.indexNo] = true;
              $('#aoSearch_' + x.indexNo).prop('checked', true);
            }
          });
        }
        // tslint:disable-next-line: max-line-length
        let sao = this.textConfigForm.value.AOGroup.mappingConfigs.map((checked, index) => checked ? this.lstMappingConfig_ao.data[index].name : null)
          .filter(value => value !== null).filter(value => value !== 'All').join();
        if (sao.split(',').length == this.textConfigForm.value.AOGroup.mappingConfigs.length) {
          // console.log('inside if');
          //  this.searchcheck_ao=true;
        }
        // tslint:disable-next-line: max-line-length
        if ((sao !== '' && sao !== undefined) && this.textConfigForm.value.AOGroup.mappingConfigs.length === sao.split(',').filter(value => value !== 'All').length) {
          this.selectedAllAoId.nativeElement.checked = true;
          this.searchcheck_ao = true;
          $(".dropdown-menu .new").removeClass('show');
          //  console.log('inside second if');
          sao = 'ALL';
        } else {
          this.selectedAllAoId.nativeElement.checked = false;
        }
        if (sao !== '' && sao !== undefined && this.enableSearchAO == true) {
          this.enableApply = true;
          this.isClearAll = true;
        }
        //  toggle dropdown in standalone
        // this.selectedAoAssignedId.nativeElement.classList.remove('show');
        break;
      case 'io':
        $(".newio .dropdown-menu ").addClass('show');
        $(".newio .iom-dropdown-toggle").addClass('show');
        if (this.lstFilterMappingConfig_ioSearch != null && this.lstFilterMappingConfig_ioSearch != undefined) {
          this.lstFilterMappingConfig_ioSearch.forEach((x, i) => {
            if (x.name == value) {
              x.isChecked = x.isChecked == true ? false : true;
            }
            if (x.isChecked) {
              this.textConfigForm.value.IOGroup.mappingConfigs[x.indexNo] = true;
              $('#ioSearch_' + x.indexNo).prop('checked', true);
            }
          });
        }
        // tslint:disable-next-line: max-line-length
        let sio = this.textConfigForm.value.IOGroup.mappingConfigs.map((checked, index) => checked ? this.lstMappingConfig_io.data[index].name : null)
          .filter(value => value !== null).filter(value => value !== 'All').join();
        if (sio.split(',').length == this.textConfigForm.value.IOGroup.mappingConfigs.length) {
          this.searchcheck_io = true;
        }
        // tslint:disable-next-line: max-line-length
        if ((sio !== '' && sio !== undefined) && this.textConfigForm.value.IOGroup.mappingConfigs.length === sio.split(',').filter(value => value !== 'All').length) {
          this.selectedAllIoId.nativeElement.checked = true;
          sio = 'ALL';
          $(".dropdown-menu .new").removeClass('show');
        } else {
          this.selectedAllIoId.nativeElement.checked = false;
        }
        if (sao !== '' && sao !== undefined && this.enableSearchIO == true) {
          this.enableApply = true;
          this.isClearAll = true;
        }
        //  toggle dropdown in standalone
        //this.selectedIoAssignedId.nativeElement.classList.remove('show');
        break;
      case 'others':
        $(".newoth .dropdown-menu ").addClass('show');
        $(".newoth .iom-dropdown-toggle").addClass('show');
        if (this.lstFilterMappingConfig_othSearch != null && this.lstFilterMappingConfig_othSearch != undefined) {
          this.lstFilterMappingConfig_othSearch.forEach((x, i) => {
            if (x.name == value) {
              x.isChecked = x.isChecked == true ? false : true;
            }
            if (x.isChecked) {
              this.textConfigForm.value.OthersGroup.mappingConfigs[x.indexNo] = true;
              $('#othSearch_' + x.indexNo).prop('checked', true);
            }
          });
        }
        // tslint:disable-next-line: max-line-length
        let sothers = this.textConfigForm.value.OthersGroup.mappingConfigs.map((checked, index) => checked ? this.lstMappingConfig_others.data[index].name : null)
          .filter(value => value !== null).filter(value => value !== 'All').join();
        if (sothers.split(',').length == this.textConfigForm.value.OthersGroup.mappingConfigs.length) {
          this.searchcheck_others = true;
        }
        // tslint:disable-next-line: max-line-length
        if ((sothers !== '' && sothers !== undefined) && this.textConfigForm.value.OthersGroup.mappingConfigs.length === sothers.split(',').filter(value => value !== 'All').length) {
          this.selectedAllOthersId.nativeElement.checked = true;
          sothers = 'ALL';
          $(".dropdown-menu .new").removeClass('show');
        } else {
          this.selectedAllOthersId.nativeElement.checked = false;
        }
        if (sao !== '' && sao !== undefined && this.enableSearchOth == true) {
          this.enableApply = true;
          this.isClearAll = true;
        }
        //  toggle dropdown in standalone
        //this.selectedOthersAssignedId.nativeElement.classList.remove('show');
        break;
      default:
        break;
    }
    if (this.isAddkeywordsEnabled_IO == false && tab == "IO") {
      return;
    }
    this.LoadWordCloudDataFromHistory(tab == 'others' ? 'Others' : tab.toUpperCase());
  }
  CancelTicketUpload() {
    if (this.BatchId != "") {
      this.clearStagingTicketsByCloudId(this.BatchId);
    }
    this.SessionService.setSessionStorageItem('CreateDDInput', null);
    $("#btnAdvanceClose").click();
    if (this.router.url.startsWith('/createdeepdive')) {
      if (this.SessionService.getSessionStorageItem('userType') != '4') {
        this.router.navigate(['deepdive']);
      }
      else {
        this.router.navigate(['deepdive'], { queryParams: { SolutionId: this.SessionService.getSolutionId() } });
      }
    }
    else {
      this.router.navigate(['proposalsummary']);
    }
  }
  IsEmpty(x) {
    return ((typeof x == 'undefined') || (x === null) || (x === ""));
  }
  getTopKeyWords(tab: string, exists: boolean) {
    this.UserOption = 2;
    this.userType = parseInt(this.SessionService.getUserType());
    if (!this.ValidateFormForTopKeyWords(tab)) {
      return false;
    }
    if (exists == true) {
      this.BatchId = "";
    }
    var existingstopwordsAO = this.lstIgnoreKeysTemp;
    var existingstopwordsIO = this.lstIgnoreKeys_ioTemp;
    var existingstopwordsOthers = this.lstIgnoreKeys_othersTemp;

    if (tab == "AO") {
      if (existingstopwordsAO.length > 0) {
        for (var i = 0; i < existingstopwordsAO.length; i++) {
          existingstopwordsAO[i] = existingstopwordsAO[i].substring(0, existingstopwordsAO[i].indexOf('('));
        }
        this.lstIgnoreKeysTemp = [];

        for (var i = 0; i < this.lstIgnoreKeys.length; i++) {
          this.lstIgnoreKeysTemp.push(this.lstIgnoreKeys[i])
        }
      }
    }
    else if (tab == 'IO') {
      if (existingstopwordsIO.length > 0) {
        for (var i = 0; i < existingstopwordsIO.length; i++) {
          existingstopwordsIO[i] = existingstopwordsIO[i].substring(0, existingstopwordsIO[i].indexOf('('));
        }

        this.lstIgnoreKeys_ioTemp = [];
        for (var i = 0; i < this.lstIgnoreKeys_io.length; i++) {
          this.lstIgnoreKeys_ioTemp.push(this.lstIgnoreKeys_io[i])
        }
      }
    }
    else {
      if (existingstopwordsOthers.length > 0) {
        for (var i = 0; i < existingstopwordsOthers.length; i++) {
          existingstopwordsOthers[i] = existingstopwordsOthers[i].substring(0, existingstopwordsOthers[i].indexOf('('));
        }
        this.lstIgnoreKeys_othersTemp = [];
        for (var i = 0; i < this.lstIgnoreKeys_others.length; i++) {
          this.lstIgnoreKeys_othersTemp.push(this.lstIgnoreKeys_others[i])
        }
      }
    }
    if (!this.LoadWordCloudDataFromHistory(tab, false)) {
      switch (tab) {
        case 'AO':
          this.topKeyWord_AO = new TopKeyWordsFilter(this.BatchId, false,
            this.textConfigForm.value.AOGroup.startDate != '' ? JSON.stringify(this.textConfigForm.value.AOGroup.startDate) : '',
            this.textConfigForm.value.AOGroup.endDate != '' ? JSON.stringify(this.textConfigForm.value.AOGroup.endDate) : '',
            this.textConfigForm.value.AOGroup.topWordOption,
            tab,
            this.textConfigForm.value.AOGroup.ClassifiedBased == 'Select' ? 'ShortDescription' : this.textConfigForm.value.AOGroup.ClassifiedBased,

            this.textConfigForm.value.AOGroup.ticketType == 'Select' ? '' : this.textConfigForm.value.AOGroup.ticketType,
            this.textConfigForm.value.AOGroup.mappingConfigs
              .map((checked, index) => checked ? this.lstMappingConfig_ao.data[index].name : null)
              .filter(value => value !== null).join(),
            null, this.lstMappingConfig_ao.ActualFilterName, existingstopwordsAO?.join(), "", this.envVar.EnableLanguage ? this.selectedLanguage_AO.join('|') : 'English');
          //this.isSkipTopWords_AO = this.checkModifiedFilter(this.topKeyWord_AO_Pre, this.topKeyWord_AO);
          //this.checkFromResponseData(this.textConfigForm.value.AOGroup.startDate, this.textConfigForm.value.AOGroup.endDate, 'AO');
          break;
        case 'IO':
          this.topKeyWord_IO = new TopKeyWordsFilter(this.BatchId, false,
            this.textConfigForm.value.IOGroup.startDate != '' ? JSON.stringify(this.textConfigForm.value.IOGroup.startDate) : '',
            this.textConfigForm.value.IOGroup.endDate != '' ? JSON.stringify(this.textConfigForm.value.IOGroup.endDate) : '',
            this.textConfigForm.value.IOGroup.topWordOption,
            tab,
            this.textConfigForm.value.IOGroup.ClassifiedBased == 'Select' ? 'ShortDescription' : this.textConfigForm.value.IOGroup.ClassifiedBased,

            this.textConfigForm.value.IOGroup.ticketType == 'Select' ? '' : this.textConfigForm.value.IOGroup.ticketType,
            this.textConfigForm.value.IOGroup.mappingConfigs
              .map((checked, index) => checked ? this.lstMappingConfig_io.data[index].name : null)
              .filter(value => value !== null).join(),
            null, this.lstMappingConfig_io.ActualFilterName, existingstopwordsIO?.join(), "", this.envVar.EnableLanguage ? this.selectedLanguage_IO.join('|') : 'English');
          //this.isSkipTopWords_IO = this.checkModifiedFilter(this.topKeyWord_IO_Pre, this.topKeyWord_IO);
          //this.checkFromResponseData(this.textConfigForm.value.IOGroup.startDate, this.textConfigForm.value.IOGroup.endDate, 'IO');

          break;
        case 'Others':
          this.topKeyWord_Others = new TopKeyWordsFilter(this.BatchId, false,
            this.textConfigForm.value.OthersGroup.startDate != '' ? JSON.stringify(this.textConfigForm.value.OthersGroup.startDate) : '',
            this.textConfigForm.value.OthersGroup.endDate != '' ? JSON.stringify(this.textConfigForm.value.OthersGroup.endDate) : '',
            this.textConfigForm.value.OthersGroup.topWordOption,
            tab,
            this.textConfigForm.value.OthersGroup.ClassifiedBased == 'Select' ? 'ShortDescription' : this.textConfigForm.value.OthersGroup.ClassifiedBased,
            this.textConfigForm.value.OthersGroup.ticketType == 'Select' ? '' : this.textConfigForm.value.OthersGroup.ticketType,
            this.textConfigForm.value.OthersGroup.mappingConfigs
              .map((checked, index) => checked ? this.lstMappingConfig_others.data[index].name : null)
              .filter(value => value !== null).join(),
            null, this.lstMappingConfig_others.ActualFilterName, existingstopwordsOthers?.join(), "", this.envVar.EnableLanguage ? this.selectedLanguage_Other.join('|') : 'English');
          //this.isSkipTopWords_Others = this.checkModifiedFilter(this.topKeyWord_Others_Pre, this.topKeyWord_Others);
          //this.checkFromResponseData(this.textConfigForm.value.OthersGroup.startDate, this.textConfigForm.value.OthersGroup.endDate, 'Others');
          break;
      }
      if (tab == "AO") {
        //this.checkMinMaxDate();
        this.spinner.show();
        let stopwords = existingstopwordsAO != '' ? existingstopwordsAO.join() : '';
        this.iomService.getTopKeyWords_Standalone(this.SessionService.getUserName(), "AO", this.UserOption, null, this.topKeyWord_AO, false, this.DoTicketPull, this.MinStartDate, this.MaxEndDate, this.userType, this.BAUploadedData, this.MasterDummyDataUpload.MandatoryColumns, this.MasterDummyDataUpload.ExcelMappingFields, this.MasterDummyDataUpload.ActualColumns, this.MasterDummyDataUpload.fileName, this.MasterDummyDataUpload.SheetName, this.EnableLemmaAO)
          .pipe(timeout(6000000))
          .subscribe((res: any) => {
            this.spinner.hide();
            if (res != null || res != "") {
              if (res.Result != undefined) {
                if (res.Result.indexOf('Success') > -1) {
                  //this.iomService.DeleteExcelFile(this.MasterDummyDataUpload.fileName);
                  this.isSkipTopWords = false;
                  this.TopKeyWordData_AO = res;
                  if (this.TopKeyWordData_AO.WordCloudData) {
                    if (JSON.parse(this.TopKeyWordData_AO.WordCloudData).Message == undefined) {
                      this.ChartData_AO = JSON.parse(this.TopKeyWordData_AO.WordCloudData);
                      if (res.TopKeyWordsFilter) {
                        delete res.TopKeyWordsFilter.DeliveryConstructUId;
                        delete res.TopKeyWordsFilter.UserType;
                        delete res.TopKeyWordsFilter.isSkipTopWords;
                        res.TopKeyWordsFilter.responselen = res.TopKeyWordsFilter.responselen.toString();
                      }
                      this.topKeywordsResponse_History_AO.push(res);
                    } else {
                      this.ChartData_AO = null;
                      bootbox.alert(JSON.parse(this.TopKeyWordData_AO.WordCloudData).Message);
                    }
                  }
                  else {
                    this.ChartData_AO = null;
                    bootbox.alert("No TopKeyWords Available");
                  }
                  this.BatchId = res.BatchUID;
                  //this.topKeyWord_AO_pre = this.topKeyWord_AO;
                }
                else {
                  if (res.BatchUID != '') {
                    this.BatchId = res.BatchUID;
                  }
                  bootbox.alert(res.Result);
                }
              }
              else {
                bootbox.alert(res);
              }
            }
          }, (error: HttpErrorResponse) => {
            this.spinner.hide();
            if (error.message != "Timeout has occurred") {
              bootbox.alert('Error occur while get top keywords.');
            }
          });
      }
      else if (tab == 'IO') {
        //this.checkMinMaxDate();
        this.spinner.show();
        let stopwords = existingstopwordsIO != '' ? existingstopwordsIO.join() : '';
        this.iomService.getTopKeyWords_Standalone(this.SessionService.getUserName(), "IO", this.UserOption, null, this.topKeyWord_IO, false, this.DoTicketPull, this.MinStartDate, this.MaxEndDate, this.userType, this.BAUploadedData, this.MasterDummyDataUpload.MandatoryColumns, this.MasterDummyDataUpload.ExcelMappingFields, this.MasterDummyDataUpload.ActualColumns, this.MasterDummyDataUpload.fileName, this.MasterDummyDataUpload.SheetName, this.EnableLemmaIO)
          .pipe(timeout(3600000))
          .subscribe((res: any) => {
            this.spinner.hide();
            if (res != null || res != "") {
              if (res.Result != undefined) {
                if (res.Result.indexOf('Success') > -1) {
                  //this.iomService.DeleteExcelFile(this.MasterDummyDataUpload.fileName);
                  this.isSkipTopWords = false;
                  this.TopKeyWordData_IO = res;
                  if (this.TopKeyWordData_IO.WordCloudData) {
                    if (JSON.parse(this.TopKeyWordData_IO.WordCloudData).Message == undefined) {
                      this.ChartData_IO = JSON.parse(this.TopKeyWordData_IO.WordCloudData);
                      if (res.TopKeyWordsFilter) {
                        delete res.TopKeyWordsFilter.DeliveryConstructUId;
                        delete res.TopKeyWordsFilter.UserType;
                        delete res.TopKeyWordsFilter.isSkipTopWords;
                        res.TopKeyWordsFilter.responselen = res.TopKeyWordsFilter.responselen.toString();
                      }
                      this.topKeywordsResponse_History_IO.push(res);
                    } else {
                      this.ChartData_IO = null;
                      bootbox.alert(JSON.parse(this.TopKeyWordData_IO.WordCloudData).Message);
                    }
                  }
                  else {
                    this.ChartData_IO = null;
                    bootbox.alert("No TopKeyWords Available");
                  }
                  this.BatchId = res.BatchUID;
                  // this.topKeyWord_IO_pre = this.topKeyWord_IO;
                }
                else {
                  if (res.BatchUID != '') {
                    this.BatchId = res.BatchUID;
                  }
                  bootbox.alert(res.Result);
                }
              }
              else {
                bootbox.alert(res);
              }
            }
          }, (error: HttpErrorResponse) => {
            this.spinner.hide();
            if (error.message != "Timeout has occurred") {
              bootbox.alert('Error occur while get top keywords.');
            }
          });
      }
      else {
        //this.checkMinMaxDate();
        this.spinner.show();
        let stopwords = existingstopwordsOthers != '' ? existingstopwordsOthers.join() : '';
        this.iomService.getTopKeyWords_Standalone(this.SessionService.getUserName(), "Others", this.UserOption, null, this.topKeyWord_Others, false, this.DoTicketPull, this.MinStartDate, this.MaxEndDate, this.userType, this.BAUploadedData, this.MasterDummyDataUpload.MandatoryColumns, this.MasterDummyDataUpload.ExcelMappingFields, this.MasterDummyDataUpload.ActualColumns, this.MasterDummyDataUpload.fileName, this.MasterDummyDataUpload.SheetName, this.EnableLemmaOth)
          .pipe(timeout(3600000))
          .subscribe((res: any) => {
            this.spinner.hide();
            if (res != null || res != "") {
              if (res.Result != undefined) {
                if (res.Result.indexOf('Success') > -1) {
                  //this.iomService.DeleteExcelFile(this.MasterDummyDataUpload.fileName);
                  this.isSkipTopWords = false;
                  this.TopKeyWordData_Others = res;
                  if (this.TopKeyWordData_Others.WordCloudData) {
                    if (JSON.parse(this.TopKeyWordData_Others.WordCloudData).Message == undefined) {
                      this.ChartData_Others = JSON.parse(this.TopKeyWordData_Others.WordCloudData);
                      if (res.TopKeyWordsFilter) {
                        delete res.TopKeyWordsFilter.DeliveryConstructUId;
                        delete res.TopKeyWordsFilter.UserType;
                        delete res.TopKeyWordsFilter.isSkipTopWords;
                        res.TopKeyWordsFilter.responselen = res.TopKeyWordsFilter.responselen.toString();
                      }
                      this.topKeywordsResponse_History_Others.push(res);
                    } else {
                      this.ChartData_Others = null;
                      bootbox.alert(JSON.parse(this.TopKeyWordData_Others.WordCloudData).Message);
                    }
                  }
                  else {
                    this.ChartData_Others = null;
                    bootbox.alert("No TopKeyWords Available");
                  }
                  this.BatchId = res.BatchUID;
                  //this.topKeyWord_Others_pre = this.topKeyWord_Others;
                }
                else {
                  if (res.BatchUID != '') {
                    this.BatchId = res.BatchUID;
                  }
                  bootbox.alert(res.Result);
                }
              }
              else {
                bootbox.alert(res);
              }
            }
          }, (error: HttpErrorResponse) => {
            this.spinner.hide();
            if (error.message != "Timeout has occurred") {
              bootbox.alert('Error occur while get top keywords.');
            }
          });
      }
    }
  }
  ValidateFormForTopKeyWords(domain: string) {
    if (domain == 'AO') {
      this.loadValues('ao');
      let AO_config = this.textConfigForm.value.AOGroup.mappingConfigs.map((checked, index) => checked ? this.lstMappingConfig_ao.data[index].name : null)
        .filter(value => value !== null).join();
      if (AO_config == '' || AO_config == undefined) {
        bootbox.alert('Please select ' + this.lstMappingConfig_ao.FilterName + ' Apps.');
        return false;
      }
      if (this.textConfigForm.value.AOGroup.ticketType == 'Select' || this.textConfigForm.value.AOGroup.ticketType == undefined) {
        bootbox.alert('Please select TicketType for Apps.');
        return false;
      }
      if (this.textConfigForm.value.AOGroup.startDate == '' || this.textConfigForm.value.AOGroup.startDate == undefined) {
        bootbox.alert('Please select start date for Apps.');
        return false;
      }
      if (this.textConfigForm.value.AOGroup.endDate == '' || this.textConfigForm.value.AOGroup.endDate == undefined) {
        bootbox.alert('Please select end date for Apps.');
        return false;
      }
      if (this.selectedLanguage_AO.length == 0 || this.selectedLanguage_AO == undefined) {
        if (this.envVar.EnableLanguage == true) {
          bootbox.alert('Please select Ticket Language for Apps.');
          return false;
        }
      }
      if (this.textConfigForm.value.AOGroup.ClassifiedBased == 'Select' || this.textConfigForm.value.AOGroup.ClassifiedBased == undefined || this.textConfigForm.value.AOGroup.ClassifiedBased == '') {
        bootbox.alert('Please select Classified Based on for Apps.');
        return false;
      }
      if (this.textConfigForm.value.AOGroup.startDate != '' && this.textConfigForm.value.AOGroup.endDate != '') {
        let fd = this.textConfigForm.value.AOGroup.startDate;
        let ed = this.textConfigForm.value.AOGroup.endDate;
        const fdate = new Date(fd.year, fd.month - 1, fd.day);
        const edate = new Date(ed.year, ed.month - 1, ed.day);
        if (fdate > edate) {
          bootbox.alert('End Date should be greater than or equal to Start Date For Apps.');
          return false;
        }
      }
    }
    else if (domain == 'IO') {
      this.loadValues('io');
      let IO_config = this.textConfigForm.value.IOGroup.mappingConfigs.map((checked, index) => checked ? this.lstMappingConfig_io.data[index].name : null)
        .filter(value => value !== null).join();
      if (IO_config == '' || IO_config == undefined) {
        bootbox.alert('Please select ' + this.lstMappingConfig_io.FilterName + ' Infra.');
        return false;
      }
      if (this.textConfigForm.value.IOGroup.ticketType == 'Select' || this.textConfigForm.value.IOGroup.ticketType == undefined) {
        bootbox.alert('Please select TicketType for Infra.');
        return false;
      }
      if (this.textConfigForm.value.IOGroup.startDate == '' || this.textConfigForm.value.IOGroup.startDate == undefined) {
        bootbox.alert('Please select start date for Infra.');
        return false;
      }
      if (this.textConfigForm.value.IOGroup.endDate == '' || this.textConfigForm.value.IOGroup.endDate == undefined) {
        bootbox.alert('Please select end date for Infra.');
        return false;
      }
      if (this.selectedLanguage_IO.length == 0 || this.selectedLanguage_IO == undefined) {
        if (this.envVar.EnableLanguage == true) {
          bootbox.alert('Please select Ticket Language for Infra.');
          return false;
        }
      }
      if (this.textConfigForm.value.IOGroup.ClassifiedBased == 'Select' || this.textConfigForm.value.IOGroup.ClassifiedBased == undefined || this.textConfigForm.value.IOGroup.ClassifiedBased == '') {
        bootbox.alert('Please select Classified Based on for Infra.');
        return false;
      }
      if (this.textConfigForm.value.IOGroup.startDate != '' && this.textConfigForm.value.IOGroup.endDate != '') {
        let fd = this.textConfigForm.value.IOGroup.startDate;
        let ed = this.textConfigForm.value.IOGroup.endDate;
        const fdate = new Date(fd.year, fd.month - 1, fd.day);
        const edate = new Date(ed.year, ed.month - 1, ed.day);
        if (fdate > edate) {
          bootbox.alert('End Date should be greater than or equal to Start Date For Infra.');
          return false;
        }
      }
    }
    else {
      this.loadValues('others');
      let Others_config = this.textConfigForm.value.OthersGroup.mappingConfigs.map((checked, index) => checked ? this.lstMappingConfig_others.data[index].name : null)
        .filter(value => value !== null).join();
      if (Others_config == '' || Others_config == undefined) {
        bootbox.alert('Please select ' + this.lstMappingConfig_others.FilterName + ' Others.');
        return false;
      }
      if (this.textConfigForm.value.OthersGroup.ticketType == 'Select' || this.textConfigForm.value.OthersGroup.ticketType == undefined) {
        bootbox.alert('Please select TicketType for Others.');
        return false;
      }
      if (this.textConfigForm.value.OthersGroup.startDate == '' || this.textConfigForm.value.OthersGroup.startDate == undefined) {
        bootbox.alert('Please select start date for Others.');
        return false;
      }
      if (this.textConfigForm.value.OthersGroup.endDate == '' || this.textConfigForm.value.OthersGroup.endDate == undefined) {
        bootbox.alert('Please select end date for Others.');
        return false;
      }
      if (this.selectedLanguage_Other.length == 0 || this.selectedLanguage_Other == undefined) {
        if (this.envVar.EnableLanguage == true) {
          bootbox.alert('Please select Ticket Language for Others.');
          return false;
        }
      }
      if (this.textConfigForm.value.OthersGroup.ClassifiedBased == 'Select' || this.textConfigForm.value.OthersGroup.ClassifiedBased == undefined || this.textConfigForm.value.OthersGroup.ClassifiedBased == '') {
        bootbox.alert('Please select Classified Based on for Others.');
        return false;
      }
      if (this.textConfigForm.value.OthersGroup.startDate != '' && this.textConfigForm.value.OthersGroup.endDate != '') {
        let fd = this.textConfigForm.value.OthersGroup.startDate;
        let ed = this.textConfigForm.value.OthersGroup.endDate;
        const fdate = new Date(fd.year, fd.month - 1, fd.day);
        const edate = new Date(ed.year, ed.month - 1, ed.day);
        if (fdate > edate) {
          bootbox.alert('End Date should be greater than or equal to Start Date For Others.');
          return false;
        }
      }
    }
    return true;
  }
  LoadWordCloudDataFromHistory(domain, isOnChangeEvent = true) {
    let isExists = false;
    let historyObj = null;
    let currentObj = null;
    switch (domain) {
      case 'AO':
        this.ChartData_AO = null;
        if (isOnChangeEvent) {
          this.textConfigForm.get('AOGroup').get('topWordOption').setValue(this.WordCloudFilterOptions[2]);
        }
        if (this.topKeywordsResponse_History_AO && this.topKeywordsResponse_History_AO.length > 0) {
          currentObj = new TopKeyWordsFilter(this.BatchId, true,
            this.textConfigForm.value.AOGroup.startDate != '' ? this.ConvertToDateFormat(this.textConfigForm.value.AOGroup.startDate) : '',
            this.textConfigForm.value.AOGroup.endDate != '' ? this.ConvertToDateFormat(this.textConfigForm.value.AOGroup.endDate) : '',
            this.textConfigForm.value.AOGroup.topWordOption,
            "AO",
            this.textConfigForm.value.AOGroup.classifiedBasedOn.replace(/ /g, ''),

            this.textConfigForm.value.AOGroup.ticketType == 'Select' ? '' : this.textConfigForm.value.AOGroup.ticketType,
            this.textConfigForm.value.AOGroup.mappingConfigs
              .map((checked, index) => checked ? this.lstMappingConfig_ao.data[index].name : null)
              .filter(value => value !== null).join(),
            null, this.lstMappingConfig_ao.ActualFilterName.split('|')[0], this.lstIgnoreKeys?.join(), "", this.envVar.EnableLanguage ? this.selectedLanguage_AO.join('|') : 'English');
          delete currentObj.isSkipTopWords;
          for (let index = 0; index < this.topKeywordsResponse_History_AO.length; index++) {
            if (JSON.stringify(currentObj) == JSON.stringify(this.topKeywordsResponse_History_AO[index].TopKeyWordsFilter)) {
              isExists = true;
              historyObj = this.topKeywordsResponse_History_AO[index];
              break;
            }
          }
          if (isExists) {
            this.ChartData_AO = JSON.parse(historyObj.WordCloudData);
            this.BatchId = historyObj.BatchUID;
          }
          else {
            this.ChartData_AO = null;
          }
        }
        break;
      case "IO":
        this.ChartData_IO = null;
        if (isOnChangeEvent) {
          this.textConfigForm.get('IOGroup').get('topWordOption').setValue(this.WordCloudFilterOptions[2]);
        }
        if (this.topKeywordsResponse_History_IO && this.topKeywordsResponse_History_IO.length > 0) {
          currentObj = new TopKeyWordsFilter(this.BatchId, true,
            this.textConfigForm.value.IOGroup.startDate != '' ? this.ConvertToDateFormat(this.textConfigForm.value.IOGroup.startDate) : '',
            this.textConfigForm.value.IOGroup.endDate != '' ? this.ConvertToDateFormat(this.textConfigForm.value.IOGroup.endDate) : '',
            this.textConfigForm.value.IOGroup.topWordOption,
            "IO",
            this.textConfigForm.value.IOGroup.classifiedBasedOn.replace(/ /g, ''),

            this.textConfigForm.value.IOGroup.ticketType == 'Select' ? '' : this.textConfigForm.value.IOGroup.ticketType,
            this.textConfigForm.value.IOGroup.mappingConfigs
              .map((checked, index) => checked ? this.lstMappingConfig_io.data[index].name : null)
              .filter(value => value !== null).join(),
            null, this.lstMappingConfig_io.ActualFilterName.split('|')[0], this.lstIgnoreKeys_io?.join(), "", this.envVar.EnableLanguage ? this.selectedLanguage_IO.join('|') : 'English');
          delete currentObj.isSkipTopWords;
          for (let index = 0; index < this.topKeywordsResponse_History_IO.length; index++) {
            if (JSON.stringify(currentObj) == JSON.stringify(this.topKeywordsResponse_History_IO[index].TopKeyWordsFilter)) {
              isExists = true;
              historyObj = this.topKeywordsResponse_History_IO[index];
              break;
            }
          }
          if (isExists) {
            this.ChartData_IO = JSON.parse(historyObj.WordCloudData);
            this.BatchId = historyObj.BatchUID;
          }
          else {
            this.ChartData_IO = null;
          }
        }
        break;
      case "Others":
        this.ChartData_Others = null;
        if (isOnChangeEvent) {
          this.textConfigForm.get('OthersGroup').get('topWordOption').setValue(this.WordCloudFilterOptions[2]);
        }
        if (this.topKeywordsResponse_History_Others && this.topKeywordsResponse_History_Others.length > 0) {
          currentObj = new TopKeyWordsFilter(this.BatchId, true,
            this.textConfigForm.value.OthersGroup.startDate != '' ? this.ConvertToDateFormat(this.textConfigForm.value.OthersGroup.startDate) : '',
            this.textConfigForm.value.OthersGroup.endDate != '' ? this.ConvertToDateFormat(this.textConfigForm.value.OthersGroup.endDate) : '',
            this.textConfigForm.value.OthersGroup.topWordOption,
            'Others',
            this.textConfigForm.value.OthersGroup.classifiedBasedOn.replace(/ /g, ''),

            this.textConfigForm.value.OthersGroup.ticketType == 'Select' ? '' : this.textConfigForm.value.OthersGroup.ticketType,
            this.textConfigForm.value.OthersGroup.mappingConfigs
              .map((checked, index) => checked ? this.lstMappingConfig_others.data[index].name : null)
              .filter(value => value !== null).join(),
            null, this.lstMappingConfig_others.ActualFilterName.split('|')[0], this.lstIgnoreKeys_others?.join(), "", this.envVar.EnableLanguage ? this.selectedLanguage_Other.join('|') : 'English');
          delete currentObj.isSkipTopWords;
          for (let index = 0; index < this.topKeywordsResponse_History_Others.length; index++) {
            if (JSON.stringify(currentObj) == JSON.stringify(this.topKeywordsResponse_History_Others[index].TopKeyWordsFilter)) {
              isExists = true;
              historyObj = this.topKeywordsResponse_History_Others[index];
              break;
            }
          }
          if (isExists) {
            this.ChartData_Others = JSON.parse(historyObj.WordCloudData);
            this.BatchId = historyObj.BatchUID;
          }
          else {
            this.ChartData_Others = null;
          }
        }
        break;
      default:
        break;
    }
    return isExists;
  }
  ConvertToDateFormat(dateObj: any) {
    return dateObj.month + "/" + dateObj.day + "/" + dateObj.year;
  }
  onDateSelected(domain, event) {
    //console.log("change event, date:" + event);
    if (this.isAddkeywordsEnabled_IO == false && domain == "IO") {
      return;
    }
    this.LoadWordCloudDataFromHistory(domain);
  }
  // onClickedOutside(e: Event) {
  //   if ($(e.target).attr('ngbdatepickerdayview') == undefined)
  //     this.displayDD = false;
  // }

  // displaydropdown() {
  //   this.displayDD = !this.displayDD;
  // }
  getLanguageList() {
    this.iomService.GetLanguageList().subscribe(data => {
      this.LanguageList = data;
    }, (err: HttpErrorResponse) => {
      console.log(err)
    })
  }

  getStopKeyWords(tab: string, event: any, isQualifiedReset: boolean) {
    // this.spinner.show()
    var stopkeyWordsRequest = [];
    var EnableLemmaVal;
    if (tab == 'AO') {
      EnableLemmaVal = this.EnableLemmaAO;
    }
    else if (tab == 'IO') {
      EnableLemmaVal = this.EnableLemmaIO;
    }
    else if (tab == 'Others') {
      EnableLemmaVal = this.EnableLemmaOth;
    }
    let values: { E2EUID: string, CMSUID: string, WSUID: string, FDSType: string, Domain: string };
    values = {
      E2EUID: null,
      CMSUID: null,
      WSUID: null,
      FDSType: null,
      Domain: tab
    };
    stopkeyWordsRequest.push(values);
    this.skrequest = stopkeyWordsRequest;
    if (event != 'IO') {
      this.ticketType = event.target.value;
    }
    else {
      this.ticketType = this.textConfigForm.value.IOGroup.ticketType == 'Select' ? '' : this.textConfigForm.value.IOGroup.ticketType
    }
    this.userType = parseInt(this.SessionService.getUserType());
    //if (this.SessionService.getUserType() == "1") {
    //this.proposalId = parseInt(this.SessionService.getSessionStorageItem('selectedProposalId'));     
    //}
    // else if (this.SessionService.getUserType() == "4") {
    //   this.proposalId = parseInt(this.SessionService.getSessionStorageItem('solutionId'));
    // }
    //else {
    //nothing to do
    //}
    this.proposalId = this.SessionService.getDeliveryConstructUId();
    // this.spinner.hide()
    if (this.isAddkeywordsEnabled_IO == false && tab == "IO") {
      return;
    }
    else {
      if (tab == 'AO') {
        this.Language = this.envVar.EnableLanguage ? this.selectedLanguage_AO.join('|') : 'English';
        if (isQualifiedReset) {
          this.textConfigForm.get('AOGroup').get('ClassifiedBased').setValue('Select');
        }
      }
      else if (tab == 'IO') {
        this.Language = this.envVar.EnableLanguage ? this.selectedLanguage_IO.join('|') : 'English';
        if (isQualifiedReset) {
          this.textConfigForm.get('IOGroup').get('ClassifiedBased').setValue('Select');
        }
      }
      else if (tab == 'Others') {
        this.Language = this.envVar.EnableLanguage ? this.selectedLanguage_Other.join('|') : 'English';
        if (isQualifiedReset) {
          this.textConfigForm.get('OthersGroup').get('ClassifiedBased').setValue('Select');
        }
      }
      // let that = this;
      // bootbox.confirm({
      //   message: this.Language+ ' will be selected as ticket language.<br> Are you sure to continue?',
      //   buttons: {
      //     confirm: {
      //       label: 'Yes',
      //       className: 'btn-primary'
      //     },
      //     cancel: {
      //       label: 'No',
      //       className: 'btn-secondary'
      //     }
      //   },
      //   callback: function (result) {
      //     if (result) //'Yes' selection
      //     {
      //       that.getStopwords(tab,stopkeyWordsRequest,that.userType,that.proposalId,that.ticketType,that.Language);
      //     }
      //     else //'No' selection
      //     {
      //       //TODO:
      //     }
      //   }
      // });
      this.getStopwords(tab, stopkeyWordsRequest, this.userType, this.proposalId, this.ticketType, this.envVar.EnableLanguage ? this.Language : 'English', EnableLemmaVal, isQualifiedReset);
    }
  }
  getStopwords(tab, stopkeyWordsRequest, userType, proposalId, ticketType, Language, EnableLemmaVal, isQualifiedReset) {
    this.spinner.show()
    // var EnableLemmaVal = this.enableLemma;
    // if (tab == 'AO'){
    //   EnableLemmaVal = this.EnableLemmaAO;
    // }
    // else if (tab == 'IO'){
    //   EnableLemmaVal = this.EnableLemmaIO;
    // }
    // else if (tab == 'Others'){
    //   EnableLemmaVal = this.EnableLemmaOth;
    // }
    this.iomService.getStopKeywords_standalone<any>(stopkeyWordsRequest, userType, proposalId, ticketType, Language, EnableLemmaVal ? 1 : 0).pipe(timeout(2400000)).subscribe(response => {
      this.spinner.hide();
      if (tab == "AO") {
        if (response != null && response != "" && response != undefined && response.Message != "Execution Failed" && response.Message != "No Input") {
          this.enableBox_AO = true;
          this.lstIgnoreKeys = response.toString().replace(/,\s*$/, "").trim().split(',');
          this.lstIgnoreKeysTemp = response.toString().replace(/,\s*$/, "").trim().split(',');
          // if(this.lstIgnoreKeys.length == 1)
          // {
          //    var ignoreKey = this.lstIgnoreKeys[0].split(',')[0];
          //    this.lstIgnoreKeys=[];
          //    this.lstIgnoreKeys.push(ignoreKey);
          // }
          this.lstIgnoreKeys = this.lstIgnoreKeys.filter(function (el) { return el; });
          this.lstIgnoreKeysTemp = response.toString().replace(/,\s*$/, "").trim().split(',');

          this.LanguageKeywordAO = [];

          var existingstopwords = this.lstIgnoreKeys;
          if (existingstopwords.length > 0) {
            for (var i = 0; i < existingstopwords.length; i++) {
              this.lstIgnoreKeys[i] = this.lstIgnoreKeys[i].replace(" ", "");
              existingstopwords[i] = existingstopwords[i].replace(" ", "");
              var Keywords = existingstopwords[i].substring(0, existingstopwords[i].indexOf('('));
              var Language = existingstopwords[i].substring(existingstopwords[i].indexOf('(') + 1, existingstopwords[i].indexOf(')'));

              if(Keywords != ''){
                let objIndexAO = this.LanguageKeywordAO.findIndex((obj => obj.Language == Language));
                if (objIndexAO != -1) {
                  var keywordsTemp: string[] = this.LanguageKeywordAO[objIndexAO].Keywords;
                  keywordsTemp.push(Keywords.trim());
                  this.LanguageKeywordAO[objIndexAO].Keywords = keywordsTemp;
                }
                else {
                  var keywordsTemp: string[] = [];
                  keywordsTemp.push(Keywords.trim());
                  this.LanguageKeywordAO.push({ Language: Language, Keywords: keywordsTemp });
                }              
              }              
            }
          }                                       
        }
        else {
          if (isQualifiedReset) {
            this.lstIgnoreKeys = [];
            this.lstIgnoreKeysTemp = [];
            this.LanguageKeywordAO = [];
          }
        }
      }
      else if (tab == "IO") {
        if (response != null && response != "" && response != undefined && response.Message != "Execution Failed" && response.Message != "No Input") {
          this.enableBox_IO = true;
          this.lstIgnoreKeys_io = response.toString().replace(/,\s*$/, "").trim().split(',');
          // if(this.lstIgnoreKeys_io.length == 1)
          // {
          //   var ignoreKey = this.lstIgnoreKeys_io[0].split(',')[0];
          //    this.lstIgnoreKeys_io=[];
          //    this.lstIgnoreKeys_io.push(ignoreKey);
          // }
          this.lstIgnoreKeys_io = this.lstIgnoreKeys_io.filter(function (el) { return el; });
          this.lstIgnoreKeys_ioTemp = response.toString().replace(/,\s*$/, "").trim().split(',');

          this.LanguageKeywordIO = [];

          var existingstopwords = this.lstIgnoreKeys;
          if (existingstopwords.length > 0) {
            for (var i = 0; i < existingstopwords.length; i++) {
              this.lstIgnoreKeys_io[i] = this.lstIgnoreKeys_io[i].replace(" ", "");
              existingstopwords[i] = existingstopwords[i].replace(" ", "");
              var Keywords = existingstopwords[i].substring(0, existingstopwords[i].indexOf('('));
              var Language = existingstopwords[i].substring(existingstopwords[i].indexOf('(') + 1, existingstopwords[i].indexOf(')'));

              if(Keywords != ''){
              let objIndexAO = this.LanguageKeywordIO.findIndex((obj => obj.Language == Language));
              if (objIndexAO != -1) {
                var keywordsTemp: string[] = this.LanguageKeywordIO[objIndexAO].Keywords;
                keywordsTemp.push(Keywords.trim());
                this.LanguageKeywordIO[objIndexAO].Keywords = keywordsTemp;
              }
              else {
                var keywordsTemp: string[] = [];
                keywordsTemp.push(Keywords.trim());
                this.LanguageKeywordIO.push({ Language: Language, Keywords: keywordsTemp });
              }
            }
            }
          }
        }
        else {
          if (isQualifiedReset) {
            this.lstIgnoreKeys_io = [];
            this.lstIgnoreKeys_ioTemp = [];
            this.LanguageKeywordIO = [];
          }
        }
      }
      else {
        if (response != null && response != "" && response != undefined && response.Message != "Execution Failed" && response.Message != "No Input") {
          this.enableBox_Others = true;
          this.lstIgnoreKeys_others = response.toString().replace(/,\s*$/, "").trim().split(',');
          // if(this.lstIgnoreKeys_others.length == 1)
          // {
          //    var ignoreKey = this.lstIgnoreKeys_others[0].split(',')[0];
          //    this.lstIgnoreKeys_others=[];
          //    this.lstIgnoreKeys_others.push(ignoreKey);
          // }
          this.lstIgnoreKeys_othersTemp = response.toString().replace(/,\s*$/, "").trim().split(',');
          this.LanguageKeywordOthers = [];
          var existingstopwords = this.lstIgnoreKeys_others;
          if (existingstopwords.length > 0) {
            for (var i = 0; i < existingstopwords.length; i++) {
              this.lstIgnoreKeys_others[i] = this.lstIgnoreKeys_others[i].replace(" ", "");
              existingstopwords[i] = existingstopwords[i].replace(" ", "");
              var Keywords = existingstopwords[i].substring(0, existingstopwords[i].indexOf('('));
              var Language = existingstopwords[i].substring(existingstopwords[i].indexOf('(') + 1, existingstopwords[i].indexOf(')'));

              if(Keywords != ''){
              let objIndexAO = this.LanguageKeywordOthers.findIndex((obj => obj.Language == Language));
              if (objIndexAO != -1) {
                var keywordsTemp: string[] = this.LanguageKeywordOthers[objIndexAO].Keywords;
                keywordsTemp.push(Keywords.trim());
                this.LanguageKeywordOthers[objIndexAO].Keywords = keywordsTemp;
              }
              else {
                var keywordsTemp: string[] = [];
                keywordsTemp.push(Keywords.trim());
                this.LanguageKeywordOthers.push({ Language: Language, Keywords: keywordsTemp });
              }
            }
            }
          }
        }
        else {
          if (isQualifiedReset) {
            this.lstIgnoreKeys_others = [];
            this.lstIgnoreKeys_othersTemp = [];
            this.LanguageKeywordOthers = [];
          }
        }
      }

    });
  }
  GetLanguageCheck_Std(Language: string) {
    let check_language = this.envVar.EnableLanguage ? this.selectedStdLanguage.join('|') : 'English';
    if (check_language.includes('Chinese')) {
      this.LemmaDisableStd = true;
      this.EnableLemmaStd = false;
    }
    else {
      this.LemmaDisableStd = false;
    }
    if (check_language.includes('English')) {
      this.DQTenableStd = false;
      this.EnableRestrictDDCreation = false;
    }
    else {
      this.DQTenableStd = true;
      this.EnableRestrictDDCreation = true;
      this.enableRestrictdd = false;
    }
    this.textConfigFormStandard.get('ClassifiedBased').setValue('Select');
  }
  GetLanguageCheck_AO(tab: string, resetClassified: boolean) {
    if (resetClassified) {
      this.textConfigForm.get('AOGroup').get('ClassifiedBased').setValue('Select');
    }
    this.check_language_ao = this.envVar.EnableLanguage ? this.selectedLanguage_AO.join('|') : 'English';

    this.getStopwords(tab, this.skrequest, this.userType, this.proposalId, this.ticketType, this.check_language_ao, this.EnableLemmaAO, false);
    if (this.check_language_ao.includes('Chinese')) {
      this.LemmaDisableAO = true;
      this.EnableLemmaAO = false;
    }
    else {
      this.LemmaDisableAO = false;
    }
    if (this.check_language_ao.includes('English')) {
      this.DQTenableAO = false;
    }
    else {
      this.DQTenableAO = true;
    }
    // if (this.selectedStdLanguage.join('|').includes("|")) {
    //   this.lstClassifiedBy_ao = [];
    // }
    // else {
    //   this.lstClassifiedBy_ao = this.templstClassifiedBy_ao;
    // }
    this.textConfigForm.get('AOGroup').get('ClassifiedBased').setValue('Select');
    // this.iomService.getStopKeywords_standalone<any>(stopkeyWordsRequest, userType, proposalId, ticketType,Language).pipe(timeout(2400000)).subscribe(response => {
  }
  GetLanguageCheck_AO_Lemma(tab: string) {
    this.check_language_ao = this.envVar.EnableLanguage ? this.selectedLanguage_AO.join('|') : 'English';
    this.getStopwords(tab, this.skrequest, this.userType, this.proposalId, this.ticketType, this.check_language_ao, this.EnableLemmaAO,false);
    if (this.selectedLanguage_AO.join('|').toString().includes('Chinese')) {
      this.LemmaDisableAO = true;
      this.EnableLemmaAO = false;
    }
    else {
      this.LemmaDisableAO = false;
    }
    if (this.selectedLanguage_AO.join('|').toString().includes('English')) {
      this.DQTenableAO = false;
    }
    else {
      this.DQTenableAO = true;
    }
    // this.iomService.getStopKeywords_standalone<any>(stopkeyWordsRequest, userType, proposalId, ticketType,Language).pipe(timeout(2400000)).subscribe(response => {
  }
  GetLanguageCheck_IO(tab: string) {
    this.check_language = this.envVar.EnableLanguage ? this.selectedLanguage_IO.join('|') : 'English';
    if (this.check_language != 'English') {
      if (this.prev_language == 'English' && this.textConfigForm.get('IOGroup').get('algorithmModel').value == 3) {
        this.textConfigForm.get('IOGroup').get('algorithmModel').setValue('1');
        this.algorithmChange(false, 'io', true, true, true, '');
      }
      this.prev_language = this.check_language;
    }
    else {
      if (this.prev_language == 'English') {
        this.textConfigForm.get('IOGroup').get('algorithmModel').setValue('3');
        this.algorithmChange(false, 'io', false, false, false, 'regression');
      }
      this.prev_language = this.check_language;
    }
    this.getStopwords(tab, this.skrequest, this.userType, this.proposalId, this.ticketType, this.check_language, this.EnableLemmaIO, false);
    // this.algorithmChange(false,'io', true, true, true,'')
    if (this.selectedLanguage_IO.join('|').toString().includes('Chinese')) {
      this.LemmaDisableIO = true;
      this.EnableLemmaIO = false;
    }
    else {
      this.LemmaDisableIO = false;
    }
    if (this.selectedLanguage_IO.includes('English') || this.selectedLanguage_IO.includes('Select')) {
      this.DQTenableIO = false;
      if(this.selectedLanguage_IO.length != 1){
        this.textConfigForm.get('IOGroup').get('algorithmModel').setValue('2');
      }
    }
    else {
      this.DQTenableIO = true;
    }
    // if (this.selectedLanguage_IO.join('|').includes("|")) {
    //   this.lstClassifiedBy_io = [];
    // }
    // else {
    //   this.lstClassifiedBy_io = this.templstClassifiedBy_io;
    // }        
    this.textConfigForm.get('IOGroup').get('ClassifiedBased').setValue('Select');
  }
  GetLanguageCheck_Others(tab: string, resetClassified: boolean) {
    if (resetClassified) {
      this.textConfigForm.get('OthersGroup').get('ClassifiedBased').setValue('Select');
    }
    this.check_language_others = this.envVar.EnableLanguage ? this.selectedLanguage_IO.join('|') : 'English';
    this.getStopwords(tab, this.skrequest, this.userType, this.proposalId, this.ticketType, this.check_language_others, this.EnableLemmaOth, false);
    if (this.selectedLanguage_Other.join('|').toString().includes('Chinese')) {
      this.LemmaDisableOth = true;
      this.EnableLemmaOth = false;
    }
    else {
      this.LemmaDisableOth = false;
    }
    if (this.selectedLanguage_Other.includes('English')) {
      this.DQTenableOth = false;
    }
    else {
      this.DQTenableOth = true;
    }
    // if (this.selectedLanguage_Other.join('|').includes("|")) {
    //   this.lstClassifiedBy_others = [];
    // }
    // else {
    //   this.lstClassifiedBy_others = this.templstClassifiedBy_others;
    // }
    this.textConfigForm.get('OthersGroup').get('ClassifiedBased').setValue('Select');
  }
  GetLanguageCheck_Others_Lemma(tab: string) {
    this.check_language_others = this.envVar.EnableLanguage ? this.selectedLanguage_Other.join('|') : 'English';
    this.getStopwords(tab, this.skrequest, this.userType, this.proposalId, this.ticketType, this.check_language_others, this.EnableLemmaOth,false);
    if (this.selectedLanguage_Other.join('|').toString().includes('Chinese')) {
      this.LemmaDisableOth = true;
      this.EnableLemmaOth = false;
    }
    else {
      this.LemmaDisableOth = false;
    }
    if (this.selectedLanguage_Other.join('|').toString().includes('English')) {
      this.DQTenableOth = false;
    }
    else {
      this.DQTenableOth = true;
    }
  }
  clearStagingTicketsByCloudId(cloudId) {
    this.iomService.DeleteStagingTickets(cloudId).subscribe(data => {
      if (data == "Success") {
        console.log("Deleted Successfully");
      }
    }
      ,
      (err: HttpErrorResponse) => {
        this.spinner.hide();
        console.log("Error Occured !");
      });
  }

  HideCheckboxPopup() {
    if (this.ShowPopup == false) {
      $(".dropdown-menu .new").removeClass('show');
    }
  }

  ShowCheckboxPopup(tab: string) {
    if (this.ShowPopup == false) {
      $(".dropdown-menu .new").addClass('show');
    }
  }

  loadValues(tab: string) {
    switch (tab) {
      case 'ao':
        setTimeout(() => {
          if (this.lstFilterMappingConfig_ao != null && this.lstFilterMappingConfig_ao != undefined) {
            if (this.textConfigForm.value.AOGroup.mappingConfigs.length === this.aoArr.length) {
              (this.textConfigForm.get('AOGroup').get('mappingConfigs') as FormArray).controls.map(
                control => control.setValue(true));
              this.lstFilterMappingConfig_ao.forEach((x, i) => {
                this.textConfigForm.value.AOGroup.mappingConfigs[x.indexNo] = true;
                $('#aoSearch_' + x.indexNo).prop('checked', true);
                x.isChecked = true;
              });
            }
            else {
              this.lstFilterMappingConfig_ao.filter(x => !this.aoArr.some(y => x.name === y.fullName)).map(x => x.isChecked = false);
              this.lstFilterMappingConfig_ao.filter(x => this.aoArr.some(y => x.name === y.fullName)).map(x => x.isChecked = true);
              this.lstFilterMappingConfig_ao.forEach((x, i) => {
                if (x.isChecked) {
                  this.textConfigForm.value.AOGroup.mappingConfigs[x.indexNo] = true;
                  $('#aoSearch_' + x.indexNo).prop('checked', true);
                  this.isClearAll = true;
                }
                else {
                  this.textConfigForm.value.AOGroup.mappingConfigs[x.indexNo] = false;
                  $('#aoSearch_' + x.indexNo).prop('checked', false);
                }
              });
            }
          }
        }, 100);
        let allAO = this.SessionService.getSessionStorageItem("selectAllAO");
        if (allAO == "true") {
          this.textConfigForm.value.AOGroup.selectAllConfig = true;
          $('#selectAllConfigAO').prop('checked', true);
        }
        else {
          this.textConfigForm.value.AOGroup.selectAllConfig = false;
          $('#selectAllConfigAO').prop('checked', false);
        }
        $('#selectAllSearchAO').prop('checked', false);
        break;
      case 'io':
        setTimeout(() => {
          if (this.lstFilterMappingConfig_io != null && this.lstFilterMappingConfig_io != undefined) {
            if (this.textConfigForm.value.IOGroup.mappingConfigs.length === this.ioArr.length) {
              (this.textConfigForm.get('IOGroup').get('mappingConfigs') as FormArray).controls.map(
                control => control.setValue(true));
              this.lstFilterMappingConfig_io.forEach((x, i) => {
                this.textConfigForm.value.IOGroup.mappingConfigs[x.indexNo] = true;
                $('#ioSearch_' + x.indexNo).prop('checked', true);
                x.isChecked = true;
              });
            }
            else {
              this.lstFilterMappingConfig_io.filter(x => !this.ioArr.some(y => x.name === y.fullName)).map(x => x.isChecked = false);
              this.lstFilterMappingConfig_io.filter(x => this.ioArr.some(y => x.name === y.fullName)).map(x => x.isChecked = true);
              this.lstFilterMappingConfig_io.forEach((x, i) => {
                if (x.isChecked) {
                  this.textConfigForm.value.IOGroup.mappingConfigs[x.indexNo] = true;
                  $('#ioSearch_' + x.indexNo).prop('checked', true);
                  this.isClearAll = true;
                }
                else {
                  this.textConfigForm.value.IOGroup.mappingConfigs[x.indexNo] = false;
                  $('#ioSearch_' + x.indexNo).prop('checked', false);
                }
              });
            }
          }
        }, 100);
        let allIO = this.SessionService.getSessionStorageItem("selectAllIO");
        if (allIO == "true") {
          this.textConfigForm.value.IOGroup.selectAllConfig = true;
          $('#selectAllConfigIO').prop('checked', true);
        }
        else {
          this.textConfigForm.value.IOGroup.selectAllConfig = false;
          $('#selectAllConfigIO').prop('checked', false);
        }
        $('#selectAllSearchIO').prop('checked', false);
        break;
      case 'others':
        setTimeout(() => {
          if (this.lstFilterMappingConfig_others != null && this.lstFilterMappingConfig_others != undefined) {
            if (this.textConfigForm.value.OthersGroup.mappingConfigs.length === this.othArr.length) {
              (this.textConfigForm.get('OthersGroup').get('mappingConfigs') as FormArray).controls.map(
                control => control.setValue(true));
              this.lstFilterMappingConfig_others.forEach((x, i) => {
                this.textConfigForm.value.OthersGroup.mappingConfigs[x.indexNo] = true;
                $('#othSearch_' + x.indexNo).prop('checked', true);
                x.isChecked = true;
              });
            }
            else {
              this.lstFilterMappingConfig_others.filter(x => !this.othArr.some(y => x.name === y.fullName)).map(x => x.isChecked = false);
              this.lstFilterMappingConfig_others.filter(x => this.othArr.some(y => x.name === y.fullName)).map(x => x.isChecked = true);
              this.lstFilterMappingConfig_others.forEach((x, i) => {
                if (x.isChecked) {
                  this.textConfigForm.value.OthersGroup.mappingConfigs[x.indexNo] = true;
                  $('#othSearch_' + x.indexNo).prop('checked', true);
                  this.isClearAll = true;
                }
                else {
                  this.textConfigForm.value.OthersGroup.mappingConfigs[x.indexNo] = false;
                  $('#othSearch_' + x.indexNo).prop('checked', false);
                }
              });
            }
          }
        }, 100);
        let allOth = this.SessionService.getSessionStorageItem("selectAllOth");
        if (allOth == "true") {
          this.textConfigForm.value.OthersGroup.selectAllConfig = true;
          $('#selectAllConfigOth').prop('checked', true);
        }
        else {
          this.textConfigForm.value.OthersGroup.selectAllConfig = false;
          $('#selectAllConfigOth').prop('checked', false);
        }
        $('#selectAllSearchOth').prop('checked', false);
        break;
      default:
        break;
    }
    this.ShowPopup = true;
  }

  loadSupportGrpName(tab: string) {
    this.isAvanced = false;
    this.isAvanced1 = false;
    this.enableSearch = true;
    this.enableApply = false;
    this.isClearAll = false;
    this.enableSearchAO = false;
    this.enableSearchIO = false;
    this.enableSearchOth = false;
    switch (tab) {
      case 'ao':
        this.textConfigForm.get('AOGroup').get('searchText').setValue('');
        this.enableSearchAO = true;
        this.lstMappingConfig_ao.data.filter(x => this.lstFilterMappingConfig_ao.some(y => y.isChecked == true)).map(x => x.isChecked = true);
        this.lstFilterMappingConfig_ao = this.lstMappingConfig_ao.data;
        setTimeout(() => {
          if (this.lstFilterMappingConfig_ao != null && this.lstFilterMappingConfig_ao != undefined) {
            this.lstFilterMappingConfig_ao.filter(x => !this.aoArr.some(y => x.name === y.fullName)).map(x => x.isChecked = false);
            this.lstFilterMappingConfig_ao.filter(x => this.aoArr.some(y => x.name === y.fullName)).map(x => x.isChecked = true);
            this.lstFilterMappingConfig_ao.forEach((x, i) => {
              if (x.isChecked) {
                this.textConfigForm.value.AOGroup.mappingConfigs[x.indexNo] = true;
                $('#aoSearch_' + x.indexNo).prop('checked', true);
                this.isClearAll = true;
              }
              else {
                this.textConfigForm.value.AOGroup.mappingConfigs[x.indexNo] = false;
                $('#aoSearch_' + x.indexNo).prop('checked', false);
              }
            });
          }
        }, 100);
        break;
      case 'io':
        this.textConfigForm.get('IOGroup').get('searchText').setValue('');
        this.enableSearchIO = true;
        this.lstMappingConfig_io.data.filter(x => this.lstFilterMappingConfig_io.some(y => y.isChecked == true)).map(x => x.isChecked = true);
        this.lstFilterMappingConfig_io = this.lstMappingConfig_io.data;
        setTimeout(() => {
          if (this.lstFilterMappingConfig_io != null && this.lstFilterMappingConfig_io != undefined) {
            this.lstFilterMappingConfig_io.filter(x => !this.ioArr.some(y => x.name === y.fullName)).map(x => x.isChecked = false);
            this.lstFilterMappingConfig_io.filter(x => this.ioArr.some(y => x.name === y.fullName)).map(x => x.isChecked = true);
            this.lstFilterMappingConfig_io.forEach((x, i) => {
              if (x.isChecked) {
                this.textConfigForm.value.IOGroup.mappingConfigs[x.indexNo] = true;
                $('#ioSearch_' + x.indexNo).prop('checked', true);
                this.isClearAll = true;
              }
              else {
                this.textConfigForm.value.IOGroup.mappingConfigs[x.indexNo] = false;
                $('#ioSearch_' + x.indexNo).prop('checked', false);
              }
            });
          }
        }, 100);
        break;
      case 'others':
        this.textConfigForm.get('OthersGroup').get('searchText').setValue('');
        this.enableSearchOth = true;
        this.lstMappingConfig_others.data.filter(x => this.lstFilterMappingConfig_others.some(y => y.isChecked == true)).map(x => x.isChecked = true);
        this.lstFilterMappingConfig_others = this.lstMappingConfig_others.data;
        setTimeout(() => {
          if (this.lstFilterMappingConfig_others != null && this.lstFilterMappingConfig_others != undefined) {
            this.lstFilterMappingConfig_others.filter(x => !this.othArr.some(y => x.name === y.fullName)).map(x => x.isChecked = false);
            this.lstFilterMappingConfig_others.filter(x => this.othArr.some(y => x.name === y.fullName)).map(x => x.isChecked = true);
            this.lstFilterMappingConfig_others.forEach((x, i) => {
              if (x.isChecked) {
                this.textConfigForm.value.OthersGroup.mappingConfigs[x.indexNo] = true;
                $('#othSearch_' + x.indexNo).prop('checked', true);
                this.isClearAll = true;
              }
              else {
                this.textConfigForm.value.OthersGroup.mappingConfigs[x.indexNo] = false;
                $('#othSearch_' + x.indexNo).prop('checked', false);
              }
            });
          }
        }, 100);
        break;
      default:
        break;
    }
    setTimeout(() => {
      this.loadValues(tab);
    }, 100);
  }

  ApplyChanges(tab: string) {
    let all;
    let count;
    switch (tab) {
      case 'ao':
        $('#selectAllSearchAO').prop('checked', false);
        this.selectedSearchAllAoId.nativeElement.checked = false;
        this.textConfigForm.value.AOGroup.selectAllSearchConfig = false;
        this.textConfigForm.get('AOGroup').get('searchText').setValue('');
        count = this.lstFilterMappingConfig_ao.length - 1;
        this.lstFilterMappingConfig_ao = this.lstMappingConfig_ao.data;
        this.searchcheck_ao = true;
        var sao: any = '';

        if (this.lstFilterMappingConfig_ao != null) {
          this.lstFilterMappingConfig_ao.forEach((x, i) => {
            if (x.isChecked)
              sao += sao == '' ? x.name : ',' + x.name;
          });
        }

        if (count == 0 && sao == 'ALL') {
          sao = 'ALL';
        }

        if (sao != '' && sao != undefined) {
          bootbox.alert('Selected values has been Applied Successfully');
          this.CancelSearch('ao');
        }
        else if (count == 0) {
          bootbox.alert('Entered text is not relevant to the available values');
          break;
        }
        else {
          bootbox.alert('Please select atleast one value');
          break;
        }
        setTimeout(() => {
          this.loadValues(tab);
          sao = '';
          this.aoArr = [];
          if (this.lstFilterMappingConfig_ao != null) {
            this.lstFilterMappingConfig_ao.forEach((x, i) => {
              if (x.isChecked) {
                if (x.name != 'All') {
                  sao += sao == '' ? x.name : ',' + x.name;
                  this.aoArr.push({
                    name: x.name.length > 15 ? x.name.substring(0, 15) + '...' : x.name,
                    fullName: x.name
                  })
                }
              }
            });
          }
          if ((sao !== '' && sao !== undefined) && (this.textConfigForm.value.AOGroup.mappingConfigs.length) === sao.split(',').filter(value => value !== 'All').length) {
            all = true;
          }
          if (all) {
            sao = 'ALL';
            this.SessionService.setSessionStorageItem("selectAllAO", "true");
          }
          else {
            this.SessionService.setSessionStorageItem("selectAllAO", "false");
            if (count == 0 && sao == 'ALL') {
              this.SessionService.setSessionStorageItem("selectAllAO", "true");
              this.aoArr.push({
                name: 'All',
                fullName: 'All'
              })
              sao = 'All';
            }
          }
          this.selectedSupportGroup_AO = sao;
        }, 100);
        break;
      case 'io':
        $('#selectAllSearchIO').prop('checked', false);
        this.selectedSearchAllIoId.nativeElement.checked = false;
        this.textConfigForm.value.IOGroup.selectAllSearchConfig = false;
        this.textConfigForm.get('IOGroup').get('searchText').setValue('');
        count = this.lstFilterMappingConfig_io.length - 1;
        this.lstFilterMappingConfig_io = this.lstMappingConfig_io.data;
        this.searchcheck_io = true;
        var sio: any = '';
        if (this.lstFilterMappingConfig_io != null) {
          this.lstFilterMappingConfig_io.forEach((x, i) => {
            if (x.isChecked)
              sio += sio == '' ? x.name : ',' + x.name;
          });
        }
        if (count == 0 && sio == 'ALL') {
          sio = 'ALL';
        }
        if (sio != '' && sio != undefined) {
          bootbox.alert('Selected values has been Applied Successfully');
          this.CancelSearch('io');
        }
        else if (count == 0) {
          bootbox.alert('Entered text is not relevant to the available values');
          break;
        }
        else {
          bootbox.alert('Please select atleast one value');
          break;
        }
        setTimeout(() => {
          this.loadValues(tab);
          sio = '';
          this.ioArr = [];
          if (this.lstFilterMappingConfig_io != null) {
            this.lstFilterMappingConfig_io.forEach((x, i) => {
              if (x.isChecked) {
                if (x.name != 'All') {
                  sio += sio == '' ? x.name : ',' + x.name;
                  this.ioArr.push({
                    name: x.name.length > 15 ? x.name.substring(0, 15) + '...' : x.name,
                    fullName: x.name
                  })
                }
              }
            });
          }
          if ((sio !== '' && sio !== undefined) && (this.textConfigForm.value.IOGroup.mappingConfigs.length) === sio.split(',').filter(value => value !== 'All').length) {
            all = true;
          }
          if (all) {
            sio = 'ALL';
            this.SessionService.setSessionStorageItem("selectAllIO", "true");
          }
          else {
            this.SessionService.setSessionStorageItem("selectAllIO", "false");
            if (count == 0 && sio == 'ALL') {
              this.SessionService.setSessionStorageItem("selectAllIO", "true");
              this.ioArr.push({
                name: 'All',
                fullName: 'All'
              })
              sio = 'All';
            }
          }
          this.selectedSupportGroup_IO = sio;
        }, 100);
        break;
      case 'others':
        $('#selectAllSearchOth').prop('checked', false);
        this.selectedSearchAllOthersId.nativeElement.checked = false;  //chk
        this.textConfigForm.value.OthersGroup.selectAllSearchConfig = false;
        this.textConfigForm.get('OthersGroup').get('searchText').setValue('');
        count = this.lstFilterMappingConfig_others.length - 1;
        this.lstFilterMappingConfig_others = this.lstMappingConfig_others.data;
        this.searchcheck_others = true;
        var sothers: any = '';
        if (this.lstFilterMappingConfig_others != null) {
          this.lstFilterMappingConfig_others.forEach((x, i) => {
            if (x.isChecked)
              sothers += sothers == '' ? x.name : ',' + x.name;
          });
        }
        if (count == 0 && sothers == 'ALL') {
          sothers = 'ALL';
        }
        if (sothers != '' && sothers != undefined) {
          bootbox.alert('Selected values has been Applied Successfully');
          this.CancelSearch('others');
        }
        else if (count == 0) {
          bootbox.alert('Entered text is not relevant to the available values');
          break;
        }
        else {
          bootbox.alert('Please select atleast one value');
          break;
        }
        setTimeout(() => {
          this.loadValues(tab);
          sothers = '';
          this.othArr = [];
          if (this.lstFilterMappingConfig_others != null) {
            this.lstFilterMappingConfig_others.forEach((x, i) => {
              if (x.isChecked) {
                if (x.name != 'All') {
                  sothers += sothers == '' ? x.name : ',' + x.name;
                  this.othArr.push({
                    name: x.name.length > 15 ? x.name.substring(0, 15) + '...' : x.name,
                    fullName: x.name
                  })
                }
              }
            });
          }
          if ((sothers !== '' && sothers !== undefined) && (this.textConfigForm.value.OthersGroup.mappingConfigs.length) === sothers.split(',').filter(value => value !== 'All').length) {
            all = true;
          }
          if (all) {
            sothers = 'ALL';
            this.SessionService.setSessionStorageItem("selectAllOth", "true");
          }
          else {
            this.SessionService.setSessionStorageItem("selectAllOth", "false");
            if (count == 0 && sothers == 'ALL') {
              this.SessionService.setSessionStorageItem("selectAllOth", "true");
              this.othArr.push({
                name: 'All',
                fullName: 'All'
              })
              sothers = 'All';
            }
          }
          this.selectedSupportGroup_Others = sothers;
        }, 100);
        break;
      default:
        break;
    }
  }

  CancelSearch(tab: string) {
    $(".select-domain").hide();
    $(".validate-section").show();
    $(".suportgrp-section").hide();
    this.enableApply = false;
    this.isClearAll = false;
    this.enableSearch = false;
    this.isAvanced = false;
    this.isAvanced1 = true;
    this.lstFilterMappingConfig_aoSearch = null;
    this.lstFilterMappingConfig_ioSearch = null;
    this.lstFilterMappingConfig_othSearch = null;
    let allAO = this.SessionService.getSessionStorageItem("selectAllAO");
    if (allAO == "true") {
      this.textConfigForm.value.AOGroup.selectAllConfig = true;
      $('#selectAllConfigAO').prop('checked', true);
    }
    else {
      this.textConfigForm.value.AOGroup.selectAllConfig = false;
      $('#selectAllSearchAO').prop('checked', false);
      $('#selectAllConfigAO').prop('checked', false);
    }
    let allIO = this.SessionService.getSessionStorageItem("selectAllIO");
    if (allIO == "true") {
      this.textConfigForm.value.IOGroup.selectAllConfig = true;
      $('#selectAllConfigIO').prop('checked', true);
    }
    else {
      this.textConfigForm.value.IOGroup.selectAllConfig = false;
      $('#selectAllSearchIO').prop('checked', false);
      $('#selectAllConfigIO').prop('checked', false);
    }
    let allOth = this.SessionService.getSessionStorageItem("selectAllOth");
    if (allOth == "true") {
      this.textConfigForm.value.OthersGroup.selectAllConfig = true;
      $('#selectAllConfigOth').prop('checked', true);
    }
    else {
      this.textConfigForm.value.OthersGroup.selectAllConfig = false;
      $('#selectAllSearchOth').prop('checked', false);
      $('#selectAllConfigOth').prop('checked', false);
    }
    setTimeout(() => {
      this.loadValues(tab);
    }, 100)
  }

  selectAllSearchConfig(tab: string) {
    this.ShowPopup = false;
    let all;
    switch (tab) {
      case 'ao':
        all = this.textConfigForm.value.AOGroup.selectAllSearchConfig;
        if (all) {
          if (this.textConfigForm.value.AOGroup.searchText == "") {

          }
          else {
            if (this.lstFilterMappingConfig_aoSearch != null && this.lstFilterMappingConfig_aoSearch != undefined) {
              this.lstFilterMappingConfig_ao.forEach((x, i) => {
                this.textConfigForm.value.AOGroup.mappingConfigs[x.indexNo] = true;
                $('#aoSearch_' + x.indexNo).prop('checked', true);
                x.isChecked = true;
              });
            }
          }
        }
        else {
          if (this.lstFilterMappingConfig_aoSearch != null && this.lstFilterMappingConfig_aoSearch != undefined) {
            this.lstFilterMappingConfig_ao.forEach((x, i) => {
              this.textConfigForm.value.AOGroup.mappingConfigs[x.indexNo] = false;
              $('#aoSearch_' + x.indexNo).prop('checked', false);
              x.isChecked = false;
            });
          }
        }

        var sao: any = '';
        if (this.lstFilterMappingConfig_aoSearch != null) {
          this.lstFilterMappingConfig_aoSearch.forEach((x, i) => {
            sao += sao == '' ? x.name : ',' + x.name;
          });
        }
        if (sao !== '' && sao !== undefined && this.enableSearchAO == true) {
          this.enableApply = true;
          this.isClearAll = true;
        }
        break;
      case 'io':
        all = this.textConfigForm.value.IOGroup.selectAllSearchConfig;
        if (all) {
          if (this.textConfigForm.value.IOGroup.searchText == "") {

          }
          else {
            if (this.lstFilterMappingConfig_ioSearch != null && this.lstFilterMappingConfig_ioSearch != undefined) {
              this.lstFilterMappingConfig_io.forEach((x, i) => {
                this.textConfigForm.value.IOGroup.mappingConfigs[x.indexNo] = true;
                $('#ioSearch_' + x.indexNo).prop('checked', true);
                x.isChecked = true;
              });
            }
          }
        }
        else {
          if (this.lstFilterMappingConfig_ioSearch != null && this.lstFilterMappingConfig_ioSearch != undefined) {
            this.lstFilterMappingConfig_io.forEach((x, i) => {
              this.textConfigForm.value.IOGroup.mappingConfigs[x.indexNo] = false;
              $('#ioSearch_' + x.indexNo).prop('checked', false);
              x.isChecked = false;
            });
          }
        }

        var sio: any = '';
        if (this.lstFilterMappingConfig_ioSearch != null) {
          this.lstFilterMappingConfig_ioSearch.forEach((x, i) => {
            sio += sio == '' ? x.name : ',' + x.name;
          });
        }

        if (sio !== '' && sio !== undefined && this.enableSearchIO == true) {
          this.enableApply = true;
          this.isClearAll = true;
        }
        break;
      case 'others':
        all = this.textConfigForm.value.OthersGroup.selectAllSearchConfig;
        if (all) {
          if (this.textConfigForm.value.OthersGroup.searchText == "") {

          }
          else {
            if (this.lstFilterMappingConfig_othSearch != null && this.lstFilterMappingConfig_othSearch != undefined) {
              this.lstFilterMappingConfig_others.forEach((x, i) => {
                this.textConfigForm.value.OthersGroup.mappingConfigs[x.indexNo] = true;
                $('#othSearch_' + x.indexNo).prop('checked', true);
                x.isChecked = true;
              });
            }
          }
        }
        else {
          if (this.lstFilterMappingConfig_othSearch != null && this.lstFilterMappingConfig_othSearch != undefined) {
            this.lstFilterMappingConfig_others.forEach((x, i) => {
              this.textConfigForm.value.OthersGroup.mappingConfigs[x.indexNo] = false;
              $('#othSearch_' + x.indexNo).prop('checked', false);
              x.isChecked = false;
            });
          }
        }
        var sothers: any = '';
        if (this.lstFilterMappingConfig_othSearch != null) {
          this.lstFilterMappingConfig_othSearch.forEach((x, i) => {
            sothers += sothers == '' ? x.name : ',' + x.name;
          });
        }

        if (sothers !== '' && sothers !== undefined && this.enableSearchOth == true) {
          this.enableApply = true;
          this.isClearAll = true;
        }
        break;
      default:
        break;
    }

  }

  ClearAllvalues(tab: string) {
    switch (tab) {
      case 'ao':
        this.textConfigForm.value.AOGroup.selectAllSearchConfig = false;
        $('#selectAllSearchAO').prop('checked', false);
        this.textConfigForm.get('AOGroup').get('searchText').setValue('');
        this.lstFilterMappingConfig_ao = this.lstMappingConfig_ao.data;
        this.lstFilterMappingConfig_ao.forEach((x, i) => {
          this.textConfigForm.value.AOGroup.mappingConfigs[x.indexNo] = false;
          $('#aoSearch_' + x.indexNo).prop('checked', false);
          x.isChecked = false;
        });
        this.lstFilterMappingConfig_aoSearch = null;
        this.selectedSupportGroup_AO = 'Select ' + this.lstMappingConfig_ao.FilterName;
        this.SessionService.setSessionStorageItem("selectAllAO", "false");
        this.selectedAllAoId.nativeElement.checked = false;
        this.textConfigForm.value.AOGroup.selectAllConfig = false;
        break;
      case 'io':
        this.textConfigForm.value.IOGroup.selectAllSearchConfig = false;
        $('#selectAllSearchIO').prop('checked', false);
        this.textConfigForm.get('IOGroup').get('searchText').setValue('');
        this.lstFilterMappingConfig_io = this.lstMappingConfig_io.data;
        this.lstFilterMappingConfig_io.forEach((x, i) => {
          this.textConfigForm.value.IOGroup.mappingConfigs[x.indexNo] = false;
          $('#ioSearch_' + x.indexNo).prop('checked', false);
          x.isChecked = false;
        });
        this.lstFilterMappingConfig_ioSearch = null;
        this.selectedSupportGroup_IO = 'Select ' + this.lstMappingConfig_io.FilterName;
        this.SessionService.setSessionStorageItem("selectAllIO", "false");
        this.selectedAllIoId.nativeElement.checked = false;
        this.textConfigForm.value.IOGroup.selectAllConfig = false;
        break;
      case 'others':
        this.textConfigForm.value.OthersGroup.selectAllSearchConfig = false;
        $('#selectAllSearchOth').prop('checked', false);
        this.textConfigForm.get('OthersGroup').get('searchText').setValue('');
        this.lstFilterMappingConfig_others = this.lstMappingConfig_others.data;
        this.lstFilterMappingConfig_others.forEach((x, i) => {
          this.textConfigForm.value.OthersGroup.mappingConfigs[x.indexNo] = false;
          $('#othSearch_' + x.indexNo).prop('checked', false);
          x.isChecked = false;
        });
        this.lstFilterMappingConfig_othSearch = null;
        this.selectedSupportGroup_Others = 'Select ' + this.lstMappingConfig_others.FilterName;
        this.SessionService.setSessionStorageItem("selectAllOth", "false");
        this.selectedAllOthersId.nativeElement.checked = false;
        this.textConfigForm.value.OthersGroup.selectAllConfig = false;
        break;
      default:
        break;
    }
    this.aoArr = [];
    this.ioArr = [];
    this.othArr = [];
    //this.CancelSearch();
  }

  selectConfigSearch(tab: string, value: string) {
    let all;
    let text;
    this.ShowPopup = false;
    switch (tab) {
      case 'ao':
        var sao: any = '';
        this.lstFilterMappingConfig_ao.forEach((x, i) => {
          if (x.name == value) {
            x.isChecked = x.isChecked == false ? true : false;
          }
          if (x.isChecked)
            sao += sao == '' ? x.name : ',' + x.name;
        });

        if (sao.split(',').length == this.textConfigForm.value.AOGroup.mappingConfigs.length) {

        }
        text = this.textConfigForm.value.AOGroup.searchText != undefined && this.textConfigForm.value.AOGroup.searchText != '' ? this.textConfigForm.value.AOGroup.searchText.toString().toLowerCase().trim() : '';
        if ((sao !== '' && sao !== undefined) && (this.textConfigForm.value.AOGroup.mappingConfigs.length) === sao.split(',').filter(value => value !== 'All').length) {
          this.selectedAllAoId.nativeElement.checked = true;
          this.searchcheck_ao = true;
          $(".dropdown-menu .new").removeClass('show');
          this.textConfigForm.value.AOGroup.selectAllConfig = true;
          this.SessionService.setSessionStorageItem("selectAllAO", "true");
          if (text != "") {
            this.selectedSearchAllAoId.nativeElement.checked = true;
            this.textConfigForm.value.AOGroup.selectAllSearchConfig = true;
          }
          else {
            this.selectedSearchAllAoId.nativeElement.checked = false;
            this.textConfigForm.value.AOGroup.selectAllSearchConfig = false;
          }
        }
        else {
          this.selectedAllAoId.nativeElement.checked = false;
          this.SessionService.setSessionStorageItem("selectAllAO", "false");
          this.textConfigForm.value.AOGroup.selectAllConfig = false;
        }

        if (this.lstFilterMappingConfig_aoSearch != null && this.lstFilterMappingConfig_aoSearch != undefined) {
          if ((sao !== '' && sao !== undefined) && this.lstFilterMappingConfig_aoSearch.length === sao.split(',').filter(value => value !== 'All').length) {
            if (text != "") {
              this.textConfigForm.value.AOGroup.selectAllSearchConfig = true;
              this.selectedSearchAllAoId.nativeElement.checked = true;
              this.searchcheck_ao = true;
            }
            else {
              this.selectedSearchAllAoId.nativeElement.checked = false;
              this.textConfigForm.value.AOGroup.selectAllSearchConfig = false;
            }
          }
          else {
            this.selectedSearchAllAoId.nativeElement.checked = false;
            this.textConfigForm.value.AOGroup.selectAllSearchConfig = false;
          }
        }
        if (sao !== '' && sao !== undefined && this.enableSearchAO == true) {
          this.enableApply = true;
          this.isClearAll = true;
        }
        break;
      case 'io':
        var sio: any = '';
        this.lstFilterMappingConfig_io.forEach((x, i) => {
          if (x.name == value) {
            x.isChecked = x.isChecked == false ? true : false;
          }
          if (x.isChecked)
            sio += sio == '' ? x.name : ',' + x.name;
        });

        if (sio.split(',').length == this.textConfigForm.value.IOGroup.mappingConfigs.length) {
          this.searchcheck_io = true;
        }
        text = this.textConfigForm.value.IOGroup.searchText != undefined && this.textConfigForm.value.IOGroup.searchText != '' ? this.textConfigForm.value.IOGroup.searchText.toString().toLowerCase().trim() : '';
        if ((sio !== '' && sio !== undefined) && (this.textConfigForm.value.IOGroup.mappingConfigs.length) === sio.split(',').filter(value => value !== 'All').length) {
          this.selectedAllIoId.nativeElement.checked = true;
          $(".dropdown-menu .new").removeClass('show');
          this.textConfigForm.value.IOGroup.selectAllConfig = true;
          this.SessionService.setSessionStorageItem("selectAllIO", "true");
          if (text != "") {
            this.selectedSearchAllIoId.nativeElement.checked = true;
            this.textConfigForm.value.IOGroup.selectAllSearchConfig = true;
          }
          else {
            this.selectedSearchAllIoId.nativeElement.checked = false;
            this.textConfigForm.value.IOGroup.selectAllSearchConfig = false;
          }
        }
        else {
          this.selectedAllIoId.nativeElement.checked = false;
          this.textConfigForm.value.IOGroup.selectAllConfig = false;
          this.SessionService.setSessionStorageItem("selectAllIO", "false");
        }
        if (this.lstFilterMappingConfig_ioSearch != null && this.lstFilterMappingConfig_ioSearch != undefined) {
          if ((sio !== '' && sio !== undefined) && this.lstFilterMappingConfig_ioSearch.length === sio.split(',').filter(value => value !== 'All').length) {
            if (text != "") {
              this.textConfigForm.value.IOGroup.selectAllSearchConfig = true;
              this.selectedSearchAllIoId.nativeElement.checked = true;
              this.searchcheck_io = true;
            }
            else {
              this.selectedSearchAllIoId.nativeElement.checked = false;
              this.textConfigForm.value.IOGroup.selectAllSearchConfig = false;
            }
          }
          else {
            this.selectedSearchAllIoId.nativeElement.checked = false;
            this.textConfigForm.value.IOGroup.selectAllSearchConfig = false;
          }
        }
        if (sio !== '' && sio !== undefined && this.enableSearchIO == true) {
          this.enableApply = true;
          this.isClearAll = true;
        }
        break;
      case 'others':
        var sothers: any = '';
        this.lstFilterMappingConfig_others.forEach((x, i) => {
          if (x.name == value) {
            x.isChecked = x.isChecked == false ? true : false;
          }
          if (x.isChecked)
            sothers += sothers == '' ? x.name : ',' + x.name;
        });
        if (sothers.split(',').length == this.textConfigForm.value.OthersGroup.mappingConfigs.length) {
          this.searchcheck_others = true;
        }
        text = this.textConfigForm.value.OthersGroup.searchText != undefined && this.textConfigForm.value.OthersGroup.searchText != '' ? this.textConfigForm.value.OthersGroup.searchText.toString().toLowerCase().trim() : '';
        if ((sothers !== '' && sothers !== undefined) && (this.textConfigForm.value.OthersGroup.mappingConfigs.length) === sothers.split(',').filter(value => value !== 'All').length) {
          this.selectedAllOthersId.nativeElement.checked = true;
          $(".dropdown-menu .new").removeClass('show');
          this.textConfigForm.value.OthersGroup.selectAllConfig = true;
          this.SessionService.setSessionStorageItem("selectAllOth", "true");
          if (text != "") {
            this.selectedSearchAllOthersId.nativeElement.checked = true;
            this.textConfigForm.value.OthersGroup.selectAllSearchConfig = true;
          }
          else {
            this.selectedSearchAllOthersId.nativeElement.checked = false;
            this.textConfigForm.value.OthersGroup.selectAllSearchConfig = false;
          }
        }
        else {
          this.selectedAllOthersId.nativeElement.checked = false;
          this.textConfigForm.value.OthersGroup.selectAllConfig = false;
          this.SessionService.setSessionStorageItem("selectAllOth", "false");
        }
        if (this.lstFilterMappingConfig_othSearch != null && this.lstFilterMappingConfig_othSearch != undefined) {
          if ((sothers !== '' && sothers !== undefined) && this.lstFilterMappingConfig_othSearch.length === sothers.split(',').filter(value => value !== 'All').length) {
            if (text != "") {
              this.textConfigForm.value.OthersGroup.selectAllSearchConfig = true;
              this.selectedSearchAllOthersId.nativeElement.checked = true;
              this.searchcheck_others = true;
            }
            else {
              this.selectedSearchAllOthersId.nativeElement.checked = false;
              this.textConfigForm.value.OthersGroup.selectAllSearchConfig = false;
            }
          }
          else {
            this.selectedSearchAllOthersId.nativeElement.checked = false;
            this.textConfigForm.value.OthersGroup.selectAllSearchConfig = false;
          }
        }

        if (sothers !== '' && sothers !== undefined && this.enableSearchOth == true) {
          this.enableApply = true;
          this.isClearAll = true;
        }
        break;
      default:
        break;
    }
  }

  GetQualifiedDescriptionStandalone(tab: string) {
    this.isQualifiedDescEnabled = false;
    if (this.isQualifiedDescEnabled_AO == null) {
      this.isQualifiedDescEnabled_AO = false;
    }

    if (this.isQualifiedDescEnabled_IO == null) {
      this.isQualifiedDescEnabled_IO = false;
    }

    if (this.isQualifiedDescEnabled_Others == null) {
      this.isQualifiedDescEnabled_Others = false;
    }
    this.UserOption = 2;
    this.userType = parseInt(this.SessionService.getUserType());
    if (tab == "NA") {
      this.UserOption = 1;
      if (this.selectedStdLanguage.join('|').toString().includes('Select')) {
        this.textConfigFormStandard.get('ClassifiedBased').setValue('Select');
        bootbox.alert('Please select Ticket Language.');
        return false;
      }
      if (this.textConfigFormStandard.value.ClassifiedBased == 'Select' || this.textConfigFormStandard.value.ClassifiedBased == '' || this.textConfigFormStandard.value.ClassifiedBased == undefined) {
        bootbox.alert('Please select Classified Based on.');
        return false;
      }
      if (this.textConfigFormStandard.value.ClassifiedBased == 'ShortDescription' || this.textConfigFormStandard.value.ClassifiedBased == 'ResolutionDescription' || this.textConfigFormStandard.value.ClassifiedBased == 'LongDescription') {
        this.isQualifiedDescEnabled = true;
        return false;
      }
    }
    else if (tab == "AO") {
      this.UserOption = 2;
      this.loadValues('ao');
      this.ChartData_AO = null;
      let AO_config = this.textConfigForm.value.AOGroup.mappingConfigs.map((checked, index) => checked ? this.lstMappingConfig_ao.data[index].name : null)
        .filter(value => value !== null).join();
      if (AO_config == '' || AO_config == undefined) {
        this.textConfigForm.get('AOGroup').get('ClassifiedBased').setValue('Select');
        bootbox.alert('Please select ' + this.lstMappingConfig_ao.FilterName + ' Apps.');
        return false;
      }
      if (this.selectedLanguage_AO.join('|').toString().includes('Select') || this.selectedLanguage_AO == undefined) {
        this.textConfigForm.get('AOGroup').get('ClassifiedBased').setValue('Select');
        bootbox.alert('Please select Ticket Language for Apps.');
        return false;
      }
      if (this.textConfigForm.value.AOGroup.ClassifiedBased == 'Select' || this.textConfigForm.value.AOGroup.ClassifiedBased == '' || this.textConfigForm.value.AOGroup.ClassifiedBased == undefined) {
        bootbox.alert('Please select Classified Based on for Apps.');
        return false;
      }
      if (this.textConfigForm.value.AOGroup.ClassifiedBased == 'ShortDescription' || this.textConfigForm.value.AOGroup.ClassifiedBased == 'ResolutionDescription' || this.textConfigForm.value.AOGroup.ClassifiedBased == 'LongDescription') {
        this.isQualifiedDescEnabled_AO = true;
        return false;
      }
    }
    else if (tab == "IO") {
      this.UserOption = 2;
      this.loadValues('io');
      this.ChartData_IO = null;
      let IO_config = this.textConfigForm.value.IOGroup.mappingConfigs.map((checked, index) => checked ? this.lstMappingConfig_io.data[index].name : null)
        .filter(value => value !== null).join();
      if (IO_config == '' || IO_config == undefined) {
        this.textConfigForm.get('IOGroup').get('ClassifiedBased').setValue('Select');
        bootbox.alert('Please select ' + this.lstMappingConfig_io.FilterName + ' Infra.');
        return false;
      }
      if (this.selectedLanguage_IO.join('|').toString().includes('Select') || this.selectedLanguage_IO == undefined) {
        this.textConfigForm.get('IOGroup').get('ClassifiedBased').setValue('Select');
        bootbox.alert('Please select Ticket Language for Infra.');
        return false;
      }
      if (this.textConfigForm.value.IOGroup.ClassifiedBased == 'Select' || this.textConfigForm.value.IOGroup.ClassifiedBased == '' || this.textConfigForm.value.IOGroup.ClassifiedBased == undefined) {
        bootbox.alert('Please select Classified Based on for Infra.');
        return false;
      }
      if (this.textConfigForm.value.IOGroup.ClassifiedBased == 'ShortDescription' || this.textConfigForm.value.IOGroup.ClassifiedBased == 'ResolutionDescription' || this.textConfigForm.value.IOGroup.ClassifiedBased == 'LongDescription') {
        this.isQualifiedDescEnabled_IO = true;
        return false;
      }
    }
    else {
      this.loadValues('others');
      this.ChartData_Others = null;
      let Others_config = this.textConfigForm.value.OthersGroup.mappingConfigs.map((checked, index) => checked ? this.lstMappingConfig_others.data[index].name : null)
        .filter(value => value !== null).join();
      if (Others_config == '' || Others_config == undefined) {
        this.textConfigForm.get('OthersGroup').get('ClassifiedBased').setValue('Select');
        bootbox.alert('Please select ' + this.lstMappingConfig_others.FilterName + ' Others.');
        return false;
      }
      if (this.selectedLanguage_Other.join('|').toString().includes('Select') || this.selectedLanguage_Other == undefined) {
        this.textConfigForm.get('OthersGroup').get('ClassifiedBased').setValue('Select');
        bootbox.alert('Please select Ticket Language for Others.');
        return false;
      }
      if (this.textConfigForm.value.OthersGroup.ClassifiedBased == 'Select' || this.textConfigForm.value.OthersGroup.ClassifiedBased == '' || this.textConfigForm.value.OthersGroup.ClassifiedBased == undefined) {
        bootbox.alert('Please select Classified Based on for Others.');
        return false;
      }
      if (this.textConfigForm.value.OthersGroup.ClassifiedBased == 'ShortDescription' || this.textConfigForm.value.OthersGroup.ClassifiedBased == 'ResolutionDescription' || this.textConfigForm.value.OthersGroup.ClassifiedBased == 'LongDescription') {
        this.isQualifiedDescEnabled_Others = true;
        return false;
      }
    }
    switch (tab) {
      case 'AO':
        this.topKeyWord_AO = new TopKeyWordsFilter(this.BatchId, false,
          this.textConfigForm.value.AOGroup.startDate != '' ? JSON.stringify(this.textConfigForm.value.AOGroup.startDate) : '',
          this.textConfigForm.value.AOGroup.endDate != '' ? JSON.stringify(this.textConfigForm.value.AOGroup.endDate) : '',
          this.textConfigForm.value.AOGroup.topWordOption,
          tab,
          this.textConfigForm.value.AOGroup.ClassifiedBased == 'Select' ? '' : this.textConfigForm.value.AOGroup.ClassifiedBased,

          this.textConfigForm.value.AOGroup.ticketType == 'Select' ? '' : this.textConfigForm.value.AOGroup.ticketType,
          this.textConfigForm.value.AOGroup.mappingConfigs
            .map((checked, index) => checked ? this.lstMappingConfig_ao.data[index].name : null)
            .filter(value => value !== null).join(),
          null, this.lstMappingConfig_ao.ActualFilterName, this.lstIgnoreKeys?.join(), "", this.envVar.EnableLanguage ? this.selectedLanguage_AO.join('|') : 'English');
        //this.isSkipTopWords_AO = this.checkModifiedFilter(this.topKeyWord_AO_Pre, this.topKeyWord_AO);
        //this.checkFromResponseData(this.textConfigForm.value.AOGroup.startDate, this.textConfigForm.value.AOGroup.endDate, 'AO');
        break;
      case 'IO':
        this.topKeyWord_IO = new TopKeyWordsFilter(this.BatchId, false,
          this.textConfigForm.value.IOGroup.startDate != '' ? JSON.stringify(this.textConfigForm.value.IOGroup.startDate) : '',
          this.textConfigForm.value.IOGroup.endDate != '' ? JSON.stringify(this.textConfigForm.value.IOGroup.endDate) : '',
          this.textConfigForm.value.IOGroup.topWordOption,
          tab,
          this.textConfigForm.value.IOGroup.ClassifiedBased == 'Select' ? '' : this.textConfigForm.value.IOGroup.ClassifiedBased,

          this.textConfigForm.value.IOGroup.ticketType == 'Select' ? '' : this.textConfigForm.value.IOGroup.ticketType,
          this.textConfigForm.value.IOGroup.mappingConfigs
            .map((checked, index) => checked ? this.lstMappingConfig_io.data[index].name : null)
            .filter(value => value !== null).join(),
          null, this.lstMappingConfig_io.ActualFilterName, this.lstIgnoreKeys_io?.join(), "", this.envVar.EnableLanguage ? this.selectedLanguage_IO.join('|') : 'English');
        //this.isSkipTopWords_IO = this.checkModifiedFilter(this.topKeyWord_IO_Pre, this.topKeyWord_IO);
        //this.checkFromResponseData(this.textConfigForm.value.IOGroup.startDate, this.textConfigForm.value.IOGroup.endDate, 'IO');

        break;
      case 'OTHERS':
        this.topKeyWord_Others = new TopKeyWordsFilter(this.BatchId, false,
          this.textConfigForm.value.OthersGroup.startDate != '' ? JSON.stringify(this.textConfigForm.value.OthersGroup.startDate) : '',
          this.textConfigForm.value.OthersGroup.endDate != '' ? JSON.stringify(this.textConfigForm.value.OthersGroup.endDate) : '',
          this.textConfigForm.value.OthersGroup.topWordOption,
          tab,
          this.textConfigForm.value.OthersGroup.ClassifiedBased == 'Select' ? '' : this.textConfigForm.value.OthersGroup.ClassifiedBased,
          this.textConfigForm.value.OthersGroup.ticketType == 'Select' ? '' : this.textConfigForm.value.OthersGroup.ticketType,
          this.textConfigForm.value.OthersGroup.mappingConfigs
            .map((checked, index) => checked ? this.lstMappingConfig_others.data[index].name : null)
            .filter(value => value !== null).join(),
          null, this.lstMappingConfig_others.ActualFilterName, this.lstIgnoreKeys_others?.join(), "", this.envVar.EnableLanguage ? this.selectedLanguage_Other.join('|') : 'English');
        //this.isSkipTopWords_Others = this.checkModifiedFilter(this.topKeyWord_Others_Pre, this.topKeyWord_Others);
        //this.checkFromResponseData(this.textConfigForm.value.OthersGroup.startDate, this.textConfigForm.value.OthersGroup.endDate, 'Others');
        break;
      case 'NA':
        this.topKeyWord_std = new TopKeyWordsFilter(this.BatchId,
          false,
          this.textConfigFormStandard.value.startDate != '' ? JSON.stringify(this.textConfigFormStandard.value.startDate) : '',
          this.textConfigFormStandard.value.endDate != '' ? JSON.stringify(this.textConfigFormStandard.value.endDate) : '',
          50,
          tab,
          this.textConfigFormStandard.value.ClassifiedBased == 'Select' ? '' : this.textConfigFormStandard.value.ClassifiedBased,
          "",
          "",
          null, "", "", "", this.envVar.EnableLanguage ? this.selectedStdLanguage.join('|') : 'English');
        break;
    }
    if (tab == "AO") {
      //this.checkMinMaxDate();
      this.spinner.show();
      this.iomService.GetQualifiedDescriptionStandalone(this.SessionService.getUserName(), "AO", this.UserOption, null, this.topKeyWord_AO, false, this.DoTicketPull, this.MinStartDate, this.MaxEndDate, this.userType, this.BAUploadedData, this.MasterDummyDataUpload.MandatoryColumns, this.MasterDummyDataUpload.ExcelMappingFields, this.MasterDummyDataUpload.ActualColumns, this.MasterDummyDataUpload.fileName, this.MasterDummyDataUpload.SheetName, this.EnableLemmaAO)
        .pipe(timeout(6000000))
        .subscribe((res: any) => {
          this.spinner.hide();
          if (res != null || res != "") {
            if (res.Result != undefined) {
              if (res.Result.indexOf('Success') > -1) {
                if (res.Result.indexOf('1') > -1) {
                  this.isQualifiedDescEnabled_AO = true;
                  bootbox.alert('Selected value is qualified for the categorized description.');
                }
                else {
                  this.isQualifiedDescEnabled_AO = false;
                  bootbox.alert('Selected value is not qualified for the categorized description.');
                }
              }
              else {
                if (res.BatchUID != '') {
                  this.BatchId = res.BatchUID;
                }
                this.isQualifiedDescEnabled_AO = false;
                bootbox.alert('Qualified Description Failed.');
              }
            }
            else {
              this.isQualifiedDescEnabled_AO = false;
              bootbox.alert('Qualified Description Failed.');
            }
          }
        }, (error: HttpErrorResponse) => {
          this.spinner.hide();
          if (error.message != "Timeout has occurred") {
            this.isQualifiedDescEnabled_AO = false;
            bootbox.alert('Error occur while Get Qualified Description.');
          }
        });
    }
    else if (tab == 'IO') {
      //this.checkMinMaxDate();
      this.spinner.show();
      this.iomService.GetQualifiedDescriptionStandalone(this.SessionService.getUserName(), "IO", this.UserOption, null, this.topKeyWord_IO, false, this.DoTicketPull, this.MinStartDate, this.MaxEndDate, this.userType, this.BAUploadedData, this.MasterDummyDataUpload.MandatoryColumns, this.MasterDummyDataUpload.ExcelMappingFields, this.MasterDummyDataUpload.ActualColumns, this.MasterDummyDataUpload.fileName, this.MasterDummyDataUpload.SheetName, this.EnableLemmaIO)
        .pipe(timeout(6000000))
        .subscribe((res: any) => {
          this.spinner.hide();
          if (res != null || res != "") {
            if (res.Result != undefined) {
              if (res.Result.indexOf('Success') > -1) {
                if (res.Result.indexOf('1') > -1) {
                  this.isQualifiedDescEnabled_IO = true;
                  bootbox.alert('Selected value is qualified for the categorized description.');
                }
                else {
                  this.isQualifiedDescEnabled_IO = false;
                  bootbox.alert('Selected value is not qualified for the categorized description.');
                }
              }
              else {
                if (res.BatchUID != '') {
                  this.BatchId = res.BatchUID;
                }
                this.isQualifiedDescEnabled_IO = false;
                bootbox.alert('Qualified Description Failed.');
              }
            }
            else {
              this.isQualifiedDescEnabled_IO = false;
              bootbox.alert('Qualified Description Failed.');
            }
          }
        }, (error: HttpErrorResponse) => {
          this.spinner.hide();
          if (error.message != "Timeout has occurred") {
            this.isQualifiedDescEnabled_IO = false;
            bootbox.alert('Error occur while Get Qualified Description.');
          }
        });
    }
    else if (tab == 'OTHERS') {
      //this.checkMinMaxDate();
      this.spinner.show();
      this.iomService.GetQualifiedDescriptionStandalone(this.SessionService.getUserName(), "Others", this.UserOption, null, this.topKeyWord_Others, false, this.DoTicketPull, this.MinStartDate, this.MaxEndDate, this.userType, this.BAUploadedData, this.MasterDummyDataUpload.MandatoryColumns, this.MasterDummyDataUpload.ExcelMappingFields, this.MasterDummyDataUpload.ActualColumns, this.MasterDummyDataUpload.fileName, this.MasterDummyDataUpload.SheetName, this.EnableLemmaOth)
        .pipe(timeout(6000000))
        .subscribe((res: any) => {
          this.spinner.hide();
          if (res != null || res != "") {
            if (res.Result != undefined) {
              if (res.Result.indexOf('Success') > -1) {
                if (res.Result.indexOf('1') > -1) {
                  this.isQualifiedDescEnabled_Others = true;
                  bootbox.alert('Selected value is qualified for the categorized description.');
                }
                else {
                  this.isQualifiedDescEnabled_Others = false;
                  bootbox.alert('Selected value is not qualified for the categorized description.');
                }
              }
              else {
                if (res.BatchUID != '') {
                  this.BatchId = res.BatchUID;
                }
                this.isQualifiedDescEnabled_Others = false;
                bootbox.alert('Qualified Description Failed.');
              }
            }
            else {
              this.isQualifiedDescEnabled_Others = false;
              bootbox.alert('Get Qualified Description Failed.');
            }
          }
        }, (error: HttpErrorResponse) => {
          this.spinner.hide();
          if (error.message != "Timeout has occurred") {
            this.isQualifiedDescEnabled_Others = false;
            bootbox.alert('Error occur while Get Qualified Description.');
          }
        });
    }
    else {
      //this.checkMinMaxDate();
      this.spinner.show();
      this.iomService.GetQualifiedDescriptionStandalone(this.SessionService.getUserName(), "NA", this.UserOption, null, this.topKeyWord_std, false, this.DoTicketPull, this.MinStartDate, this.MaxEndDate, this.userType, this.BAUploadedData, this.MasterDummyDataUpload.MandatoryColumns, this.MasterDummyDataUpload.ExcelMappingFields, this.MasterDummyDataUpload.ActualColumns, this.MasterDummyDataUpload.fileName, this.MasterDummyDataUpload.SheetName, this.EnableLemmaOth)
        .pipe(timeout(6000000))
        .subscribe((res: any) => {
          this.spinner.hide();
          if (res != null || res != "") {
            if (res.Result != undefined) {
              if (res.Result.indexOf('Success') > -1) {
                if (res.Result.indexOf('1') > -1) {
                  this.isQualifiedDescEnabled = true;
                  bootbox.alert('Selected value is qualified for the categorized description.');
                }
                else {
                  bootbox.alert('Selected value is not qualified for the categorized description.');
                }
              }
              else {
                if (res.BatchUID != '') {
                  this.BatchId = res.BatchUID;
                }
                bootbox.alert('Qualified Description Failed.');
              }
            }
            else {
              bootbox.alert('Qualified Description Failed.');
            }
          }
        }, (error: HttpErrorResponse) => {
          this.spinner.hide();
          if (error.message != "Timeout has occurred") {
            bootbox.alert('Error occur while Get Qualified Description.');
          }
        });
    }
  }
  onItemSelect(dropdownName: string, item: any) {
    if (dropdownName == 'stdLanguage') {
      if(!(this.selectedStdLanguage.join('|').toString().includes(item))){
        this.selectedStdLanguage.push(item);
      }      
      this.GetLanguageCheck_Std(item);
    }
    else if (dropdownName == 'LanguageAO') {
      this.ChartData_AO = null;
      if(!(this.selectedLanguage_AO.join('|').toString().includes(item))){
        this.selectedLanguage_AO.push(item);
      }       
      this.GetLanguageCheck_AO('AO', true);
    }
    else if (dropdownName == 'LanguageIO') {
      this.ChartData_IO = null;
      if(!(this.selectedLanguage_IO.join('|').toString().includes(item))){
        this.selectedLanguage_IO.push(item);
      }      
      this.GetLanguageCheck_IO('IO');
      if (item != 'English') {
        this.textConfigForm.get('IOGroup').get('algorithmModel').setValue('2');
        this.algorithmChange(true, 'io', false, true, true, '')
      }
    }
    else if (dropdownName == 'LanguageOther') {
      this.ChartData_Others = null;
      if(!(this.selectedLanguage_Other.join('|').toString().includes(item))){
        this.selectedLanguage_Other.push(item);
      }      
      this.GetLanguageCheck_Others('Others', true);
    }
  }

  onItemSelectAll(dropdownName: string, item: any) {
    if (dropdownName == 'stdLanguage') {
      this.selectedStdLanguage = [];
      for (var i = 0; i < this.LanguageList.length; i++) {
        this.selectedStdLanguage.push(this.LanguageList[i])
      }
      this.GetLanguageCheck_Std(item);
    }
    else if (dropdownName == 'LanguageAO') {
      this.ChartData_AO = null;
      this.selectedLanguage_AO = [];
      for (var i = 0; i < this.LanguageList.length; i++) {
        this.selectedLanguage_AO.push(this.LanguageList[i])
      }
      this.GetLanguageCheck_AO('AO', true);
    }
    else if (dropdownName == 'LanguageIO') {
      this.ChartData_IO = null;
      this.selectedLanguage_IO = [];
      for (var i = 0; i < this.LanguageList.length; i++) {
        this.selectedLanguage_IO.push(this.LanguageList[i])
      }
      this.GetLanguageCheck_IO('IO');
    }
    else if (dropdownName == 'LanguageOther') {
      this.ChartData_Others = null;
      this.selectedLanguage_Other = [];
      for (var i = 0; i < this.LanguageList.length; i++) {
        this.selectedLanguage_Other.push(this.LanguageList[i])
      }
      this.GetLanguageCheck_Others('Others', true);
    }
  }

  onItemDeSelect(dropdownName: string, item: any) {
    if (dropdownName == 'stdLanguage') {
      this.selectedStdLanguage.forEach((value, index) => {
        if (value == item) this.selectedStdLanguage.splice(index, 1);
      });
      this.GetLanguageCheck_Std(item);
    }
    else if (dropdownName == 'LanguageAO') {
      this.ChartData_AO = null;
      this.selectedLanguage_AO.forEach((value, index) => {
        if (value == item) this.selectedLanguage_AO.splice(index, 1);
      });
      this.GetLanguageCheck_AO('AO', true);
    }
    else if (dropdownName == 'LanguageIO') {
      this.ChartData_IO = null;
      this.selectedLanguage_IO.forEach((value, index) => {
        if (value == item) this.selectedLanguage_IO.splice(index, 1);
      });
      this.GetLanguageCheck_IO('IO');
    }
    else if (dropdownName == 'LanguageOther') {
      this.ChartData_Others = null;
      this.selectedLanguage_Other.forEach((value, index) => {
        if (value == item) this.selectedLanguage_Other.splice(index, 1);
      });
      this.GetLanguageCheck_Others('Others', true);
    }
  }

  onItemDeSelectAll(dropdownName: string, item: any) {
    if (dropdownName == 'stdLanguage') {
      this.selectedStdLanguage = [];
      this.GetLanguageCheck_Std(item);
    }
    else if (dropdownName == 'LanguageAO') {
      this.ChartData_AO = null;
      this.selectedLanguage_AO = [];
      this.GetLanguageCheck_AO('AO', true);
    }
    else if (dropdownName == 'LanguageIO') {
      this.ChartData_IO = null;
      this.selectedLanguage_IO = [];
      this.GetLanguageCheck_IO('IO');
    }
    else if (dropdownName == 'LanguageOther') {
      this.ChartData_Others = null;
      this.selectedLanguage_Other = [];
      this.GetLanguageCheck_Others('Others', true);
    }
  }

  GetSelectedLanguage(item: any, tab: string) {
    // this.spinner.show();
    // this.SessionService.setSessionStorageItem("SelectedDDLanguage", item.target.value);
    // this.selectedStdLanguage=item;
    switch (tab) {
      case 'ao':
        this.selectedStdLanguageAO = item.target.value;
        //this.getStopKeyWords('AO', item, false)
        break;
      case 'io':
        this.selectedStdLanguageIO = item.target.value;
        //this.getStopKeyWords('IO', item, false)
        break;
      case 'others':
        this.selectedStdLanguageOthers = item.target.value;
        //this.getStopKeyWords('Others', item, false)
        break;
      default:
        break;
    }
  }

  pushLanguageWiseKeyword(item: string, tab: string) {
    switch (tab) {
      case 'ao':
        let objIndexAO = this.LanguageKeywordAO.findIndex((obj => obj.Language == this.selectedStdLanguageAO));
        if (objIndexAO != -1) {
          var keywordsTemp: string[] = this.LanguageKeywordAO[objIndexAO].Keywords;
          keywordsTemp.push(item);
          this.LanguageKeywordAO[objIndexAO].Keywords = keywordsTemp;
        }
        else {
          var keywordsTemp: string[] = [];
          keywordsTemp.push(item);
          this.LanguageKeywordAO.push({ Language: this.selectedStdLanguageAO, Keywords: keywordsTemp });
        }
        break;
      case 'io':
        let objIndexIO = this.LanguageKeywordIO.findIndex((obj => obj.Language == this.selectedStdLanguageIO));
        if (objIndexIO != -1) {
          var keywordsTemp: string[] = this.LanguageKeywordIO[objIndexIO].Keywords;
          keywordsTemp.push(item);
          this.LanguageKeywordIO[objIndexIO].Keywords = keywordsTemp;
        }
        else {
          var keywordsTemp: string[] = [];
          keywordsTemp.push(item);
          this.LanguageKeywordIO.push({ Language: this.selectedStdLanguageIO, Keywords: keywordsTemp });
        }
        break;
      case 'others':
        let objIndex = this.LanguageKeywordOthers.findIndex((obj => obj.Language == this.selectedStdLanguageOthers));
        if (objIndex != -1) {
          var keywordsTemp: string[] = this.LanguageKeywordOthers[objIndex].Keywords;
          keywordsTemp.push(item);
          this.LanguageKeywordOthers[objIndex].Keywords = keywordsTemp;
        }
        else {
          var keywordsTemp: string[] = [];
          keywordsTemp.push(item);
          this.LanguageKeywordOthers.push({ Language: this.selectedStdLanguageOthers, Keywords: keywordsTemp });
        }
        break;
      default:
        break;
    }
  }

  pullLanguageWiseKeyword(item: string, tab: string) {
    item = item.substring(0, item.indexOf('('));
    switch (tab) {
      case 'ao':
        let objIndexAO = this.LanguageKeywordAO.findIndex((obj => obj.Keywords.includes(item)));
        if (objIndexAO != -1) {
          var keywordsTemp: string[] = this.LanguageKeywordAO[objIndexAO].Keywords;
          const index: number = keywordsTemp.indexOf(item);
          if (index !== -1) {
            keywordsTemp.splice(index, 1);
          }
          this.LanguageKeywordAO[objIndexAO].Keywords = keywordsTemp;
        }
        break;
      case 'io':
        let objIndexIO = this.LanguageKeywordIO.findIndex((obj => obj.Keywords.includes(item)));
        if (objIndexIO != -1) {
          var keywordsTemp: string[] = this.LanguageKeywordIO[objIndexIO].Keywords;
          const index: number = keywordsTemp.indexOf(item);
          if (index !== -1) {
            keywordsTemp.splice(index, 1);
          }
          this.LanguageKeywordIO[objIndexIO].Keywords = keywordsTemp;
        }
        break;
      case 'others':
        let objIndex = this.LanguageKeywordOthers.findIndex((obj => obj.Keywords.includes(item)));
        if (objIndex != -1) {
          var keywordsTemp: string[] = this.LanguageKeywordOthers[objIndex].Keywords;
          const index: number = keywordsTemp.indexOf(item);
          if (index !== -1) {
            keywordsTemp.splice(index, 1);
          }
          this.LanguageKeywordOthers[objIndex].Keywords = keywordsTemp;
        }
        break;
      default:
        break;
    }
  }
}

